{
  "actions.back": "Retour",
  "actions.cancelAction": "Annuler",
  "actions.delete": "Supprimer",
  "actions.edit": "Modifier",
  "actions.new": "Créer",
  "actions.publish": "Publier",
  "actions.restore": "Restaurer",
  "actions.save": "Enregistrer",
  "actions.unpublish": "Dépublier",
  "admin.backToApp": "Retour à l'application",
  "admin.dashboard.subtitle": "Vue d'ensemble et statistiques de la plateforme",
  "admin.dashboard.viewAll": "Voir tout",
  "admin.domains.actions": "Actions",
  "admin.domains.activate": "Activer le domaine",
  "admin.domains.aliases.add": "Ajouter un site dédié",
  "admin.domains.aliases.baseUrl": "URL de base",
  "admin.domains.aliases.deleteConfirm.message": "Voulez-vous vraiment supprimer ce site dédié ? Ce nom d'hôte ne sera plus accessible.",
  "admin.domains.aliases.deleteConfirm.title": "Supprimer le site dédié",
  "admin.domains.aliases.description": "Un site dédié est un nom d'hôte supplémentaire qui affiche une seule équipe de ce domaine, avec son propre branding. Les comptes et les données restent partagés avec ce domaine.",
  "admin.domains.aliases.empty": "Aucun site dédié configuré",
  "admin.domains.aliases.hostname": "Nom d'hôte",
  "admin.domains.aliases.name": "Nom affiché",
  "admin.domains.aliases.notifications.created": "Site dédié créé avec succès",
  "admin.domains.aliases.notifications.deleted": "Site dédié supprimé avec succès",
  "admin.domains.aliases.notifications.updated": "Site dédié mis à jour avec succès",
  "admin.domains.aliases.teamSlug": "Slug de l'équipe épinglée",
  "admin.domains.aliases.title": "Sites dédiés (alias de domaine)",
  "admin.domains.androidFingerprints": "Empreintes Android (SHA-256)",
  "admin.domains.androidFingerprintsDescription": "Empreintes SHA-256 du certificat de signature de l'APK pour la vérification des clés d'accès (format hex avec deux-points, séparées par des virgules)",
  "admin.domains.androidFingerprintsPlaceholder": "18:A9:F7:56:...",
  "admin.domains.baseUrl": "URL de base",
  "admin.domains.cannotDeactivateCurrent": "Impossible de désactiver le domaine courant",
  "admin.domains.create.button": "Créer un domaine",
  "admin.domains.create.title": "Nouveau domaine",
  "admin.domains.deactivate": "Désactiver le domaine",
  "admin.domains.domain": "Domaine",
  "admin.domains.edit.title": "Modifier le domaine",
  "admin.domains.empty.description": "Aucun domaine n'a encore été créé.",
  "admin.domains.empty.title": "Aucun domaine",
  "admin.domains.enableGpxPlanner": "Tracé activé dans les outils GPX",
  "admin.domains.enableGpxPlannerHint": "Autorise le dessin d'un tracé de zéro. L'import d'un fichier GPX reste possible dans tous les cas.",
  "admin.domains.gpsCredentials.add": "Ajouter",
  "admin.domains.gpsCredentials.clientId": "Client ID",
  "admin.domains.gpsCredentials.clientSecret": "Client Secret",
  "admin.domains.gpsCredentials.clientSecretPlaceholder": "Laisser vide pour conserver l'actuel",
  "admin.domains.gpsCredentials.deleteConfirm.message": "Voulez-vous vraiment supprimer cet identifiant GPS ? Plus personne ne pourra se connecter à ce service.",
  "admin.domains.gpsCredentials.deleteConfirm.title": "Supprimer l'identifiant GPS",
  "admin.domains.gpsCredentials.empty": "Aucun identifiant GPS configuré",
  "admin.domains.gpsCredentials.notifications.created": "Identifiant GPS créé avec succès",
  "admin.domains.gpsCredentials.notifications.deleted": "Identifiant GPS supprimé avec succès",
  "admin.domains.gpsCredentials.notifications.updated": "Identifiant GPS mis à jour avec succès",
  "admin.domains.gpsCredentials.oauthVersionLabel": "Protocole",
  "admin.domains.gpsCredentials.oauthVersionOAuth1": "OAuth 1.0a (consumer key et secret)",
  "admin.domains.gpsCredentials.oauthVersionOAuth2": "OAuth 2.0",
  "admin.domains.gpsCredentials.oauthVersionSwitchWarning": "Changer de protocole rend les connexions existantes inutilisables : il faudra reconnecter Garmin sur chaque compte.",
  "admin.domains.gpsCredentials.serviceType": "Service",
  "admin.domains.gpsCredentials.title": "Identifiants GPS",
  "admin.domains.name": "Nom",
  "admin.domains.namePlaceholder": "Nom affiché du domaine",
  "admin.domains.notifications.created": "Domaine créé avec succès",
  "admin.domains.notifications.updated": "Domaine mis à jour avec succès",
  "admin.domains.singleTeam": "Équipe unique",
  "admin.domains.status": "Statut",
  "admin.domains.teams": "Équipes",
  "admin.domains.users": "Comptes",
  "admin.maintenance.currentDomain": "Domaine courant",
  "admin.maintenance.domain": "Domaine",
  "admin.maintenance.domainDescription": "Les deux actions portent sur ce domaine seulement",
  "admin.maintenance.elevation.attempts": "Tentatives",
  "admin.maintenance.elevation.confirmMessage": "Relancer le calcul pour les {{listed}} cibles prévisualisées ? Leurs tentatives sont remises à zéro.",
  "admin.maintenance.elevation.confirmTitle": "Relancer l'altimétrie HD",
  "admin.maintenance.elevation.description": "Relance le calcul du profil altimétrique HD des parcours et aperçus de l'outil GPX qui ont épuisé leurs tentatives et sont restés sur le profil rapide.",
  "admin.maintenance.elevation.firstRequestedAt": "Demandé le",
  "admin.maintenance.elevation.kind": "Cibles",
  "admin.maintenance.elevation.kinds.ALL": "Toutes",
  "admin.maintenance.elevation.kinds.PREVIEW": "Aperçus GPX",
  "admin.maintenance.elevation.kinds.ROUTE": "Parcours",
  "admin.maintenance.elevation.lastError": "Dernière erreur",
  "admin.maintenance.elevation.target": "Cible",
  "admin.maintenance.elevation.title": "Altimétrie HD abandonnée",
  "admin.maintenance.intro": "Rattrapages des traitements de fond. Prévisualisez d'abord : le lancement porte exactement sur les critères prévisualisés.",
  "admin.maintenance.limit": "Limite",
  "admin.maintenance.limitDescription": "Au plus 1 000, les plus anciens d'abord",
  "admin.maintenance.preview": "Prévisualiser",
  "admin.maintenance.previewSummary": "Essai à blanc : {{matched}} concernés, {{listed}} listés. Rien n'a été modifié.",
  "admin.maintenance.run": "Lancer",
  "admin.maintenance.runSummary": "Terminé : {{listed}} traités sur {{matched}} concernés.",
  "admin.maintenance.thumbnails.after": "Après",
  "admin.maintenance.thumbnails.before": "Avant",
  "admin.maintenance.thumbnails.confirmMessage": "Redessiner les {{listed}} éléments prévisualisés ? Leurs miniatures actuelles seront remplacées.",
  "admin.maintenance.thumbnails.confirmTitle": "Redessiner les miniatures",
  "admin.maintenance.thumbnails.criterionRequired": "Renseignez au moins un critère.",
  "admin.maintenance.thumbnails.description": "Redessine les miniatures claires et sombres des parcours, sorties et voyages à partir de la géométrie déjà stockée. Synchrone : la réponse arrive une fois tout redessiné.",
  "admin.maintenance.thumbnails.entity": "Élément",
  "admin.maintenance.thumbnails.fileMissing": "{{type}} : absent",
  "admin.maintenance.thumbnails.fileSize": "{{type}} : {{kb}} ko",
  "admin.maintenance.thumbnails.includeMissing": "Inclure les miniatures manquantes",
  "admin.maintenance.thumbnails.includeMissingDescription": "Ce qui a un tracé mais pas de miniature claire ou sombre — ce que laisse un rendu échoué",
  "admin.maintenance.thumbnails.kind.RIDE": "Sortie",
  "admin.maintenance.thumbnails.kind.ROUTE": "Parcours",
  "admin.maintenance.thumbnails.kind.TRIP": "Voyage",
  "admin.maintenance.thumbnails.outcome": "Résultat",
  "admin.maintenance.thumbnails.outcomes.FAILED": "Échec",
  "admin.maintenance.thumbnails.outcomes.PENDING": "À redessiner",
  "admin.maintenance.thumbnails.outcomes.REGENERATED": "Redessinée",
  "admin.maintenance.thumbnails.reason.MISSING": "Manquante",
  "admin.maintenance.thumbnails.reason.RENDERED_IN_WINDOW": "Dans la période",
  "admin.maintenance.thumbnails.reason.SMALL_FILE": "Fichier suspect",
  "admin.maintenance.thumbnails.reasons": "Raisons",
  "admin.maintenance.thumbnails.renderedFrom": "Dessinées à partir du",
  "admin.maintenance.thumbnails.renderedTo": "Dessinées avant le",
  "admin.maintenance.thumbnails.suspectBelowBytes": "Fichier plus petit que (octets)",
  "admin.maintenance.thumbnails.suspectBelowBytesDescription": "Une carte sans fond pèse quelques ko, une vraie quelques dizaines",
  "admin.maintenance.thumbnails.title": "Miniatures de carte",
  "admin.stats.domains": "Total domaines",
  "admin.stats.teams": "Total équipes",
  "admin.stats.users": "Total comptes",
  "admin.status.active": "Actif",
  "admin.status.inactive": "Inactif",
  "admin.tabs.dashboard": "Tableau de bord",
  "admin.tabs.domains": "Domaines",
  "admin.tabs.maintenance": "Maintenance",
  "admin.tabs.reports": "Signalements",
  "admin.tabs.teams": "Équipes",
  "admin.tabs.users": "Comptes",
  "admin.teams.actions": "Actions",
  "admin.teams.active": "Active",
  "admin.teams.archive": "Archiver l'équipe",
  "admin.teams.archived": "Archivée",
  "admin.teams.domain": "Domaine",
  "admin.teams.empty.description": "Aucune équipe n'a encore été créée.",
  "admin.teams.empty.title": "Aucune équipe",
  "admin.teams.filterByDomain": "Filtrer par domaine",
  "admin.teams.members": "Membres",
  "admin.teams.name": "Nom",
  "admin.teams.restore": "Restaurer l'équipe",
  "admin.teams.slug": "Slug",
  "admin.teams.status": "Statut",
  "admin.teams.visibility": "Visibilité",
  "admin.title": "Administration plateforme",
  "admin.users.actions": "Actions",
  "admin.users.adminOnly": "Admins plateforme uniquement",
  "admin.users.cannotRemoveOwnAdmin": "Impossible de retirer votre propre rôle admin plateforme",
  "admin.users.createdAt": "Créé",
  "admin.users.displayName": "Nom affiché",
  "admin.users.domain": "Domaine",
  "admin.users.email": "Adresse e-mail",
  "admin.users.emailVerified": "Vérifié",
  "admin.users.empty.description": "Aucun compte n'a encore été créé.",
  "admin.users.empty.title": "Aucun compte",
  "admin.users.filterByDomain": "Filtrer par domaine",
  "admin.users.makeAdmin": "Accorder admin plateforme",
  "admin.users.platformAdmin": "Admin plateforme",
  "admin.users.platformRole": "Rôle plateforme",
  "admin.users.removeAdmin": "Retirer admin plateforme",
  "admin.users.search": "Rechercher des comptes",
  "admin.users.searchPlaceholder": "Rechercher par adresse e-mail ou nom...",
  "admin.users.unverified": "Non vérifié",
  "admin.users.verified": "Vérifié",
  "ads.adType.RENTAL": "Location",
  "ads.adType.SALE": "Vente",
  "ads.adType.WANTED": "Recherche",
  "ads.contact.button": "Répondre à l'annonce",
  "ads.contact.counter": "{{length}} / {{max}}",
  "ads.contact.disclosure": "Votre message part par e-mail vers la personne qui a publié l'annonce : elle verra votre adresse et pourra vous répondre directement. La sienne ne vous est jamais communiquée.",
  "ads.contact.error.blank": "Le message ne peut pas être vide.",
  "ads.contact.error.deliveryFailed": "Le message n'est pas parti. Réessayez dans un moment.",
  "ads.contact.error.generic": "Le message n'a pas pu être envoyé.",
  "ads.contact.error.optedOut": "Ce membre a choisi de ne pas recevoir de messages au sujet de ses annonces.",
  "ads.contact.error.rateLimited": "Vous avez envoyé trop de messages récemment. Réessayez plus tard.",
  "ads.contact.error.rateLimitedIn": "Vous avez envoyé trop de messages récemment. Réessayez dans {{minutes}} minutes.",
  "ads.contact.error.tooLong": "Le message ne peut pas dépasser 2 000 caractères.",
  "ads.contact.error.tooShort": "Le message doit faire au moins 10 caractères.",
  "ads.contact.intro": "Votre message part par e-mail à {{seller}}.",
  "ads.contact.messageLabel": "Votre message",
  "ads.contact.placeholder": "Présentez-vous et dites ce qui vous intéresse dans cette annonce.",
  "ads.contact.send": "Envoyer",
  "ads.contact.sent": "Message envoyé, la réponse vous arrivera directement par e-mail.",
  "ads.contact.title": "Répondre à l'annonce",
  "ads.create.adTypeLabel": "Type d'annonce",
  "ads.create.descriptionPlaceholder": "Décrivez votre annonce...",
  "ads.create.locationDescriptionLabel": "Description du lieu",
  "ads.create.locationDescriptionPlaceholder": "Ex: Paris 15e, proche métro...",
  "ads.create.namePlaceholder": "Entrez le titre de l'annonce",
  "ads.create.priceHint": "Laissez vide si le prix est à négocier",
  "ads.create.priceLabel": "Prix",
  "ads.create.pricePlaceholder": "0.00",
  "ads.create.rentalPeriodLabel": "Période de location",
  "ads.create.submit": "Créer l'annonce",
  "ads.create.title": "Nouvelle annonce",
  "ads.detail.confirmations.delete": "Voulez-vous vraiment supprimer cette annonce ? Cette action est irréversible.",
  "ads.detail.confirmations.unpublish": "Voulez-vous dépublier cette annonce ? Elle redeviendra un brouillon.",
  "ads.detail.description": "Description",
  "ads.detail.gallery": "Photos de l'annonce",
  "ads.detail.location": "Localisation",
  "ads.detail.locationApproximate": "Localisation approximative, à environ 1 km près — le point exact est communiqué par la personne qui publie l'annonce.",
  "ads.detail.nextImage": "Photo suivante",
  "ads.detail.notFound.message": "Cette annonce n'existe pas ou a été supprimée",
  "ads.detail.notFound.title": "Annonce introuvable",
  "ads.detail.openImage": "Ouvrir la photo {{index}} sur {{total}}",
  "ads.detail.previousImage": "Photo précédente",
  "ads.detail.priceNegotiable": "Prix à négocier",
  "ads.detail.seller": "Publiée par",
  "ads.edit.title": "Modifier l'annonce",
  "ads.list.allTypes": "Tous les types",
  "ads.list.createAd": "Créer une annonce",
  "ads.list.empty.member": "Aucune annonce n'est disponible pour le moment.",
  "ads.list.empty.title": "Aucune annonce",
  "ads.list.filterByType": "Filtrer par type",
  "ads.list.filters.maxPrice": "Prix max.",
  "ads.list.filters.minPrice": "Prix min.",
  "ads.list.filters.priceHint": "Un prix limite écarte les annonces à négocier.",
  "ads.list.filters.pricePlaceholder": "Indifférent",
  "ads.list.membersOnly.description": "Les annonces de l'équipe ne sont visibles que par ses membres.",
  "ads.list.membersOnly.title": "Réservées aux membres",
  "ads.list.noResults": "Aucune annonce ne correspond à votre recherche.",
  "ads.list.noResultsTitle": "Aucune annonce trouvée",
  "ads.list.search.label": "Rechercher des annonces",
  "ads.list.search.placeholder": "Rechercher par titre ou description...",
  "ads.notifications.created": "Annonce créée avec succès",
  "ads.notifications.deleted": "Annonce supprimée avec succès",
  "ads.notifications.published": "Annonce publiée avec succès",
  "ads.notifications.restored": "Annonce restaurée avec succès",
  "ads.notifications.updated": "Annonce mise à jour avec succès",
  "ads.pricePerPeriod": "{{price}} / {{period}}",
  "ads.rentalPeriod.DAY": "Jour",
  "ads.rentalPeriod.MONTH": "Mois",
  "ads.rentalPeriod.WEEK": "Semaine",
  "ads.sort.nameAsc": "Nom A → Z",
  "ads.sort.nameDesc": "Nom Z → A",
  "ads.sort.newest": "Plus récentes d'abord",
  "ads.sort.oldest": "Plus anciennes d'abord",
  "ads.sort.priceAsc": "Prix croissant",
  "ads.sort.priceDesc": "Prix décroissant",
  "ads.sort.title": "Trier par",
  "ads.title": "Annonces",
  "agenda.empty.description": "Les sorties et les voyages de l'équipe apparaîtront ici.",
  "agenda.empty.filteredDescription": "Aucune sortie ni aucun voyage ne correspond à ces filtres.",
  "agenda.empty.seePast": "Voir les passées",
  "agenda.empty.title": "Rien à l'agenda pour le moment",
  "agenda.filters": "Filtres",
  "agenda.inProgress": "En cours",
  "agenda.returnAround": "retour vers {{time}}",
  "agenda.scope.all": "Tout",
  "agenda.scope.label": "Période",
  "agenda.scope.past": "Passées",
  "agenda.search.label": "Rechercher dans l'agenda",
  "agenda.search.placeholder": "Rechercher par titre ou description...",
  "agenda.tags.pickKind": "Choisissez Sorties ou Voyages pour filtrer par tag.",
  "agenda.type.all": "Tout",
  "agenda.type.label": "Type",
  "agenda.type.ride": "Sorties",
  "agenda.type.trip": "Voyages",
  "analytics.optOut.browserSignal": "Votre navigateur envoie déjà Do Not Track ou Global Privacy Control : aucune page vue n'est comptée, sur aucun de nos sites.",
  "analytics.optOut.description": "Compte les pages vues de façon anonyme, sans cookie ni adresse IP conservée. Ce réglage ne vaut que sur ce navigateur et pour ce site : pour vous opposer sur tous nos sites, activez Do Not Track ou Global Privacy Control dans votre navigateur.",
  "analytics.optOut.label": "Mesure d'audience du site",
  "analytics.optOut.title": "Mesure d'audience",
  "apps.garmin.description": "Les sorties et les parcours de vos équipes sur votre compteur Garmin Edge, prêts pour la navigation.",
  "apps.garmin.download": "Voir sur le Connect IQ Store",
  "apps.garmin.title": "Garmin",
  "apps.karoo.description": "Suivez vos sorties directement sur votre Hammerhead Karoo.",
  "apps.karoo.download": "Télécharger l'APK",
  "apps.karoo.install": "Depuis votre téléphone : appui long sur le bouton, puis Partager → Hammerhead Companion. Le Karoo, connecté au Wi-Fi, propose alors d'installer l'application, puis ses mises à jour.",
  "apps.karoo.instructions": "Instructions détaillées chez Hammerhead (en anglais)",
  "apps.karoo.title": "Karoo",
  "apps.mobile.apk": "APK Android sans Google Play",
  "apps.mobile.apkHint": "Pour les appareils sans services Google : pas de notifications push ni de mises à jour automatiques (retéléchargez l'APK pour mettre à jour). Ne s'installe pas par-dessus la version du Play Store.",
  "apps.mobile.description": "Disponible sur iPhone dans l'App Store. La version Android du Play Store arrive bientôt ; un APK est déjà proposé aux appareils sans Google Play.",
  "apps.mobile.download": "Télécharger sur l'App Store",
  "apps.mobile.title": "Application mobile",
  "apps.status.available": "Disponible",
  "apps.status.comingSoon": "Bientôt disponible",
  "apps.status.installed": "Installée",
  "apps.subtitle": "Suivez vos sorties partout : compteur GPS, téléphone ou navigateur.",
  "apps.title": "Applications",
  "apps.web.browserMenu": "Depuis le menu de votre navigateur : « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
  "apps.web.description": "Installez le site sur votre téléphone ou votre ordinateur : il s'ouvre comme une application, et reçoit vos notifications. Rien à télécharger depuis un store.",
  "apps.web.title": "Application web",
  "aria.breadcrumb": "Fil d'Ariane",
  "aria.closeDialog": "Fermer la fenêtre",
  "aria.createOther": "Créer autre chose",
  "aria.manageActions": "Options de gestion",
  "aria.more": "Plus",
  "aria.moveDown": "Déplacer vers le bas",
  "aria.moveUp": "Déplacer vers le haut",
  "attachments.add": "Ajouter une pièce jointe",
  "attachments.title": "Pièces jointes",
  "auth.errors.CONTENT_REJECTED": "Ce nom contient un terme interdit. Choisissez-en un autre.",
  "auth.errors.EMAIL_ALREADY_EXISTS": "Un compte existe déjà avec cette adresse e-mail",
  "auth.errors.EMAIL_NOT_VERIFIED": "Veuillez vérifier votre adresse e-mail avant de vous connecter",
  "auth.errors.INVALID_CREDENTIALS": "Adresse e-mail ou mot de passe incorrect",
  "auth.errors.LOGIN_RATE_LIMITED": "Trop de mots de passe erronés pour cette adresse. Réessayez dans un quart d'heure, ou connectez-vous avec un code reçu par e-mail.",
  "auth.errors.loginFailed": "Échec de la connexion",
  "auth.errors.otpFailed": "Échec de l'envoi du code",
  "auth.errors.otpInvalid": "Code invalide ou expiré",
  "auth.errors.otpVerifyFailed": "Échec de la vérification du code",
  "auth.errors.passkeyFailed": "Échec de l'authentification par clé d'accès",
  "auth.errors.registrationFailed": "Échec de l'inscription",
  "auth.errors.resetPasswordFailed": "Échec de la réinitialisation du mot de passe",
  "auth.forgotPassword.backToLogin": "Retour à la connexion",
  "auth.forgotPassword.sent.backToLogin": "Retour à la connexion",
  "auth.forgotPassword.sent.checkEmail": "Si un compte existe avec cette adresse e-mail, vous recevrez un lien pour réinitialiser votre mot de passe.",
  "auth.forgotPassword.sent.message": "Vérifiez votre boîte de réception",
  "auth.forgotPassword.sent.title": "E-mail envoyé",
  "auth.forgotPassword.submit": "Envoyer le lien",
  "auth.forgotPassword.subtitle": "Entrez votre adresse e-mail pour recevoir un lien de réinitialisation",
  "auth.forgotPassword.title": "Mot de passe oublié",
  "auth.form.confirmPassword": "Confirmer le mot de passe",
  "auth.form.confirmPasswordPlaceholder": "Confirmez votre mot de passe",
  "auth.form.displayName": "Nom affiché",
  "auth.form.displayNamePlaceholder": "Le nom qui s'affichera",
  "auth.form.email": "Adresse e-mail",
  "auth.form.newPassword": "Nouveau mot de passe",
  "auth.form.password": "Mot de passe",
  "auth.form.passwordPlaceholder": "Entrez votre mot de passe",
  "auth.login.button": "Se connecter",
  "auth.login.forgotPassword": "Mot de passe oublié ?",
  "auth.login.methods.otp": "Connexion par e-mail",
  "auth.login.methods.passkey": "Connexion rapide",
  "auth.login.methods.password": "E-mail et mot de passe",
  "auth.login.methods.register": "Créer un compte",
  "auth.login.noAccount": "Pas encore de compte ?",
  "auth.login.subtitle": "Connectez-vous pour gérer votre équipe cycliste",
  "auth.login.tabs.passkey": "Clé d'accès",
  "auth.login.tabs.password": "Mot de passe",
  "auth.login.termsText": "En vous connectant, vous acceptez nos <termsLink>Conditions d'utilisation</termsLink> et notre <privacyLink>Politique de confidentialité</privacyLink>",
  "auth.login.title": "Se connecter",
  "auth.otp.description": "Recevez un code de connexion par e-mail, sans mot de passe.",
  "auth.otp.resend": "Renvoyer le code",
  "auth.otp.resendIn": "Renvoyer dans {{seconds}}s",
  "auth.otp.send": "Envoyer le code",
  "auth.otp.title": "Code par e-mail",
  "auth.otp.verify.digit": "Chiffre {{position}} sur {{length}} du code",
  "auth.otp.verify.instruction": "Entrez le code reçu par e-mail. Ce code expire dans 5 minutes.",
  "auth.otp.verify.sentTo": "Un code à 6 chiffres a été envoyé à <strong>{{email}}</strong>",
  "auth.otp.verify.title": "Entrez votre code",
  "auth.passkey.description": "Utilisez votre empreinte digitale, reconnaissance faciale ou clé de sécurité.",
  "auth.passkey.emailOptional": "Adresse e-mail (facultative)",
  "auth.passkey.login": "Se connecter avec une clé d'accès",
  "auth.register.acceptTerms": "J'ai au moins 16 ans et j'accepte les <termsLink>Conditions d'utilisation</termsLink> et la <privacyLink>Politique de confidentialité</privacyLink>",
  "auth.register.button": "Créer un compte",
  "auth.register.haveAccount": "Déjà un compte ?",
  "auth.register.subtitle": "Rejoignez la communauté cycliste",
  "auth.register.success.backToLogin": "Retour à la connexion",
  "auth.register.success.checkEmail": "Cliquez sur le lien dans l'e-mail pour choisir votre mot de passe et activer votre compte.",
  "auth.register.success.message": "Un e-mail de vérification a été envoyé à <strong>{{email}}</strong>.",
  "auth.register.success.title": "Compte créé !",
  "auth.register.title": "Créer un compte",
  "auth.resetPassword.error.message": "Ce lien de réinitialisation est invalide ou a expiré.",
  "auth.resetPassword.error.requestNew": "Demander un nouveau lien",
  "auth.resetPassword.error.title": "Lien invalide",
  "auth.resetPassword.submit": "Réinitialiser le mot de passe",
  "auth.resetPassword.subtitle": "Choisissez un nouveau mot de passe",
  "auth.resetPassword.success.login": "Se connecter",
  "auth.resetPassword.success.message": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  "auth.resetPassword.success.title": "Mot de passe réinitialisé",
  "auth.resetPassword.title": "Réinitialiser le mot de passe",
  "auth.steps.credentials": "Identifiants",
  "auth.steps.method": "Méthode",
  "auth.validation.acceptTerms": "Confirmez votre âge et acceptez les conditions d'utilisation pour créer un compte",
  "auth.validation.displayNameMax": "Le nom doit faire moins de 100 caractères",
  "auth.validation.displayNameMin": "Le nom doit faire au moins 2 caractères",
  "auth.validation.email": "Adresse e-mail invalide",
  "auth.validation.passwordMin": "Le mot de passe doit faire au moins 8 caractères",
  "auth.validation.passwordMismatch": "Les mots de passe ne correspondent pas",
  "auth.validation.required": "Ce champ est requis",
  "auth.verifyEmail.activate.button": "Activer mon compte",
  "auth.verifyEmail.activate.message": "Choisissez le mot de passe du compte <strong>{{email}}</strong>.",
  "auth.verifyEmail.activate.notYours": "Ce n'est pas votre adresse ? Fermez cette page : rien n'est activé tant que vous ne cliquez pas.",
  "auth.verifyEmail.activate.signedInAs": "Votre session est ouverte en tant que <strong>{{current}}</strong>. Activer ce compte vous connectera à <strong>{{email}}</strong> à sa place.",
  "auth.verifyEmail.activate.title": "Activer votre compte",
  "auth.verifyEmail.emailChanged.message": "Votre adresse est désormais <strong>{{email}}</strong>.",
  "auth.verifyEmail.emailChanged.taken": "Cette adresse est déjà utilisée par un autre compte.",
  "auth.verifyEmail.emailChanged.title": "Adresse modifiée",
  "auth.verifyEmail.error.message": "Ce lien de vérification est invalide.",
  "auth.verifyEmail.error.title": "Lien invalide",
  "auth.verifyEmail.passkey.message": "Configurez une clé d'accès pour vous connecter plus rapidement et en toute sécurité à l'avenir.",
  "auth.verifyEmail.passkey.register": "Configurer une clé d'accès",
  "auth.verifyEmail.passkey.skip": "Plus tard",
  "auth.verifyEmail.passkey.title": "Sécurisez votre compte",
  "auth.verifyEmail.success.continue": "Continuer",
  "auth.verifyEmail.success.login": "Se connecter",
  "auth.verifyEmail.success.message": "Votre compte est activé.",
  "auth.verifyEmail.success.title": "Compte activé !",
  "auth.verifyEmail.title": "Vérification de l'adresse e-mail",
  "auth.verifyEmail.verifying": "Vérification en cours...",
  "autocomplete.noPlacesFound": "Aucun lieu trouvé",
  "autocomplete.noUsersFound": "Personne ne correspond",
  "autocomplete.searchMembers": "Rechercher un membre…",
  "autocomplete.searchPlaces": "Rechercher des lieux...",
  "biketeamMigration.backHome": "Retour à l'accueil",
  "biketeamMigration.backToBiketeam": "Retour sur biketeam",
  "biketeamMigration.block.LOGIN_REQUIRED": "Connectez-vous à {{site}}, ou créez un compte, pour confirmer. Vous reviendrez ensuite sur cette page, et ce compte administrera l'équipe.",
  "biketeamMigration.block.MIGRATED_IN_OTHER_DOMAIN": "Cette équipe biketeam a déjà été migrée vers un autre site Pédalons.",
  "biketeamMigration.block.MIGRATION_RUNNING": "Une migration de cette équipe est déjà en cours. Attendez qu'elle se termine, puis relancez-la depuis biketeam.",
  "biketeamMigration.block.NOT_TEAM_ADMIN": "L'équipe « {{team}} » existe déjà sur {{site}} et vous ne l'administrez pas. Connectez-vous avec un compte qui l'administre.",
  "biketeamMigration.block.REQUEST_ALREADY_USED": "Cette demande a déjà été utilisée. Relancez la migration depuis biketeam.",
  "biketeamMigration.block.RESET_BLOCKED": "La remise à zéro de l'équipe « {{team}} » est impossible : un domaine personnalisé pointe sur elle, et son site tomberait. Relancez la migration depuis biketeam sans remise à zéro, ou retirez d'abord ce domaine.",
  "biketeamMigration.block.SLUG_CONFLICT": "L'adresse {{slug}} est déjà prise sur {{site}} par l'équipe « {{team}} », qui ne vient pas de biketeam. Elle doit être renommée avant de migrer.",
  "biketeamMigration.cancel": "Annuler",
  "biketeamMigration.confirm": "Confirmer et revenir sur biketeam",
  "biketeamMigration.existing.update": "L'équipe « {{team}} » existe déjà sur {{site}}, issue d'une migration précédente : elle sera mise à jour.",
  "biketeamMigration.expiresAt": "Demande valable jusqu'au {{date}}.",
  "biketeamMigration.imported.logo": "Le logo",
  "biketeamMigration.imported.noLogo": "Pas de logo",
  "biketeamMigration.imported.note": "Avec leurs fichiers GPX et leurs images. Le contenu garde ses dates et sa visibilité d'origine.",
  "biketeamMigration.imported.pages": "La présentation de l'équipe",
  "biketeamMigration.imported.pagesWithFaq": "La présentation de l'équipe et sa FAQ",
  "biketeamMigration.imported.places_one": "{{count}} lieu",
  "biketeamMigration.imported.places_many": "{{count}} lieux",
  "biketeamMigration.imported.places_other": "{{count}} lieux",
  "biketeamMigration.imported.publications_one": "{{count}} publication",
  "biketeamMigration.imported.publications_many": "{{count}} publications",
  "biketeamMigration.imported.publications_other": "{{count}} publications",
  "biketeamMigration.imported.rides_one": "{{count}} sortie",
  "biketeamMigration.imported.rides_many": "{{count}} sorties",
  "biketeamMigration.imported.rides_other": "{{count}} sorties",
  "biketeamMigration.imported.rideTemplates_one": "{{count}} modèle de sortie",
  "biketeamMigration.imported.rideTemplates_many": "{{count}} modèles de sortie",
  "biketeamMigration.imported.rideTemplates_other": "{{count}} modèles de sortie",
  "biketeamMigration.imported.routes_one": "{{count}} parcours",
  "biketeamMigration.imported.routes_many": "{{count}} parcours",
  "biketeamMigration.imported.routes_other": "{{count}} parcours",
  "biketeamMigration.imported.title": "Ce qui sera importé",
  "biketeamMigration.imported.trips_one": "{{count}} voyage ({{stages}})",
  "biketeamMigration.imported.trips_many": "{{count}} voyages ({{stages}})",
  "biketeamMigration.imported.trips_other": "{{count}} voyages ({{stages}})",
  "biketeamMigration.imported.tripStages_one": "{{count}} étape",
  "biketeamMigration.imported.tripStages_many": "{{count}} étapes",
  "biketeamMigration.imported.tripStages_other": "{{count}} étapes",
  "biketeamMigration.mode.dryRun": "Essai",
  "biketeamMigration.mode.dryRunBody": "L'équipe sera réellement créée sur {{site}}, avec la visibilité qu'elle a sur biketeam, mais biketeam ne redirigera pas. Vous pourrez vérifier le résultat puis recommencer.",
  "biketeamMigration.mode.final": "Définitif",
  "biketeamMigration.mode.finalBody": "biketeam redirigera toutes les adresses de l'équipe vers {{site}}, et l'équipe passera en lecture seule sur biketeam.",
  "biketeamMigration.mode.title": "Mode",
  "biketeamMigration.notImported.body": "Vous administrerez l'équipe et tout le contenu importé sera à votre nom. Les membres la rejoindront ensuite, par lien d'invitation ou librement si l'équipe est ouverte.",
  "biketeamMigration.notImported.comments": "Les commentaires",
  "biketeamMigration.notImported.members": "Les membres et leurs adhésions",
  "biketeamMigration.notImported.participations": "Les inscriptions aux sorties et aux voyages",
  "biketeamMigration.notImported.routeRatings": "Les notes et favoris de parcours",
  "biketeamMigration.notImported.title": "Ce qui ne sera pas importé",
  "biketeamMigration.pageTitle": "Migration depuis biketeam",
  "biketeamMigration.redirecting": "Retour sur biketeam...",
  "biketeamMigration.requestedBy": "Demande faite par {{name}} sur biketeam.",
  "biketeamMigration.reset.existing": "L'équipe « {{team}} », issue d'une migration précédente, sera supprimée avant la migration, avec tout ce qui y a été ajouté depuis.",
  "biketeamMigration.reset.none": "Aucune équipe issue d'une migration précédente n'existe sur {{site}} : la remise à zéro sera sans effet.",
  "biketeamMigration.reset.title": "Remise à zéro",
  "biketeamMigration.signedInAs": "Session ouverte en tant que {{name}} ({{email}}).",
  "biketeamMigration.signIn": "Se connecter",
  "biketeamMigration.switchAccount": "Utiliser un autre compte",
  "biketeamMigration.target.address": "Adresse de l'équipe",
  "biketeamMigration.target.site": "Site",
  "biketeamMigration.target.title": "Destination",
  "biketeamMigration.title": "Migrer {{team}} vers {{site}}",
  "biketeamMigration.trashed.setAside": "L'équipe « {{team}} », issue d'une migration précédente, a été supprimée de {{site}}. Elle restera supprimée, sous une autre adresse, et une nouvelle équipe sera créée à sa place.",
  "biketeamMigration.unavailable.missing": "Le lien est incomplet. Relancez la migration depuis l'administration de votre équipe sur biketeam.",
  "biketeamMigration.unavailable.restart": "Relancez la migration depuis l'administration de votre équipe sur biketeam.",
  "biketeamMigration.unavailable.title": "Demande de migration indisponible",
  "boundary.message": "Nous sommes désolés, mais quelque chose d'inattendu s'est produit. Veuillez réessayer.",
  "boundary.reload": "Recharger la page",
  "boundary.report": "Signaler ce problème",
  "boundary.retry": "Réessayer",
  "boundary.title": "Une erreur est survenue",
  "buttons.confirm": "Confirmer",
  "calendar.event.registered": "J'y vais",
  "calendar.event.registeredInGroup": "J'y vais · {{group}}",
  "calendar.ics.copyLink": "Copier le lien",
  "calendar.ics.description": "Abonnez-vous à ce calendrier depuis votre application de calendrier (Apple Calendar, Google Calendar, Outlook...)",
  "calendar.ics.globalFeedLabel": "URL du flux global",
  "calendar.ics.regenerate": "Régénérer le lien",
  "calendar.ics.regenerateConfirmMessage": "L'ancien lien ne fonctionnera plus. Vous devrez mettre à jour l'abonnement dans vos applications de calendrier.",
  "calendar.ics.regenerateConfirmTitle": "Régénérer le lien du calendrier",
  "calendar.ics.subscribe": "S'abonner",
  "calendar.ics.teamDescription": "Abonnez-vous au calendrier de cette équipe depuis votre application de calendrier (Apple Calendar, Google Calendar, Outlook...)",
  "calendar.ics.teamFeedLabel": "URL du flux d'équipe",
  "calendar.schedule.allDay": "Toute la journée",
  "calendar.schedule.day": "Jour",
  "calendar.schedule.month": "Mois",
  "calendar.schedule.moreLabel_one": "+{{count}} autre",
  "calendar.schedule.moreLabel_many": "+{{count}} autres",
  "calendar.schedule.moreLabel_other": "+{{count}} autres",
  "calendar.schedule.next": "Suivant",
  "calendar.schedule.noEvents": "Aucun événement",
  "calendar.schedule.previous": "Précédent",
  "calendar.schedule.selectMonth": "Sélectionner le mois",
  "calendar.schedule.selectYear": "Sélectionner l'année",
  "calendar.schedule.switchToDayView": "Passer à la vue jour",
  "calendar.schedule.switchToMonthView": "Passer à la vue mois",
  "calendar.schedule.switchToWeekView": "Passer à la vue semaine",
  "calendar.schedule.switchToYearView": "Passer à la vue année",
  "calendar.schedule.timeSlot": "Créneau",
  "calendar.schedule.today": "Aujourd'hui",
  "calendar.schedule.viewSelectLabel": "Vue du calendrier",
  "calendar.schedule.week": "Semaine",
  "calendar.schedule.weekday": "Jour de semaine",
  "calendar.schedule.year": "Année",
  "calendar.title": "Calendrier",
  "cards.actions.addToCalendar": "Ajouter au calendrier",
  "cards.actions.menu": "Actions — {{name}}",
  "comments.actions.reply": "Répondre",
  "comments.confirmDelete.message": "Voulez-vous vraiment supprimer ce commentaire ? Cette action est irréversible.",
  "comments.confirmDelete.title": "Supprimer le commentaire",
  "comments.count_one": "{{count}} commentaire",
  "comments.count_many": "{{count}} commentaires",
  "comments.count_other": "{{count}} commentaires",
  "comments.deletedPlaceholder": "Commentaire supprimé",
  "comments.empty": "Aucun commentaire pour le moment. Lancez la discussion !",
  "comments.emptyTitle": "Aucun commentaire",
  "comments.form.placeholder": "Écrivez un commentaire...",
  "comments.form.replyPlaceholder": "Écrivez une réponse...",
  "comments.form.submit": "Envoyer le commentaire",
  "comments.loadMore": "Charger plus de commentaires",
  "comments.notifications.created": "Commentaire ajouté avec succès",
  "comments.notifications.deleted": "Commentaire supprimé avec succès",
  "comments.showReplies_one": "Voir la réponse",
  "comments.showReplies_many": "Voir les {{count}} réponses",
  "comments.showReplies_other": "Voir les {{count}} réponses",
  "comments.title": "Commentaires",
  "common.clearFilters": "Effacer les filtres",
  "common.clearSearch": "Effacer la recherche",
  "common.or": "ou",
  "dateFormats.dateTime": "EEEE PPP 'à' HH:mm",
  "device.client.garmin": "un appareil Garmin",
  "device.client.karoo": "un Karoo",
  "device.client.other": "un appareil GPS",
  "device.confirm.authorize": "Autoriser",
  "device.confirm.deny": "Refuser",
  "device.confirm.question": "Autoriser {{device}} à accéder au compte {{name}} ?",
  "device.confirm.requestedAt": "Code demandé {{when}}.",
  "device.confirm.title": "Autoriser cet appareil ?",
  "device.confirm.warning": "Vérifiez que ce code est bien celui affiché sur votre appareil, devant vous. Si quelqu'un vous a envoyé ce lien, refusez : cette personne obtiendrait l'accès à votre compte.",
  "device.denied.message": "Ce code n'est plus valable : l'appareil ne pourra pas s'en servir. Pour connecter votre propre appareil, relancez la connexion depuis celui-ci.",
  "device.denied.title": "Demande refusée",
  "device.errors.authorizationFailed": "Échec de l'autorisation. Veuillez réessayer.",
  "device.errors.denyFailed": "Le refus n'a pas pu être enregistré. Veuillez réessayer.",
  "device.errors.invalidCode": "Code invalide",
  "device.errors.invalidCodeMessage": "Ce code est invalide ou a expiré. Veuillez générer un nouveau code depuis votre appareil.",
  "device.errors.title": "Erreur",
  "device.hammerhead.authorized": "Karoo autorisé sur votre compte.",
  "device.hammerhead.connect": "Associer Hammerhead",
  "device.hammerhead.denied": "Vous avez refusé l'accès chez Hammerhead. Sans lui, le Karoo ne peut recevoir aucun parcours.",
  "device.hammerhead.failed": "L'association avec Hammerhead n'a pas abouti. Réessayez.",
  "device.hammerhead.hint": "Vous allez vous connecter chez Hammerhead puis revenir ici. Le Karoo se met à jour tout seul.",
  "device.hammerhead.message": "Vos parcours arrivent sur le Karoo par Hammerhead. Associez votre compte Hammerhead à Pédalons : sans cela, le Karoo ne recevra aucun parcours.",
  "device.hammerhead.title": "Dernière étape : associer Hammerhead",
  "device.manualEntry.description": "Saisissez le code à 6 caractères affiché sur votre appareil GPS.",
  "device.manualEntry.title": "Entrez le code",
  "device.manualEntry.tryAgain": "Réessayer",
  "device.ready.message": "Votre Karoo et votre compte Hammerhead sont associés à Pédalons. Le Karoo se met à jour tout seul.",
  "device.ready.title": "Votre Karoo est prêt",
  "device.success.message": "Votre appareil a été autorisé avec succès.",
  "device.success.returnToDevice": "Vous pouvez maintenant retourner sur votre appareil. Il devrait se connecter automatiquement.",
  "device.success.title": "Connexion réussie !",
  "device.title": "Connexion appareil",
  "device.verifying": "Vérification du code...",
  "distance": "{{distance}} km",
  "distance_imperial": "{{distance}} mi",
  "editor.image": "Image",
  "editor.imageSize.full": "Pleine largeur",
  "editor.imageSize.icon": "Icône",
  "editor.imageSize.medium": "Moyen",
  "editor.imageSize.thumbnail": "Miniature",
  "editor.placeholder": "Commencez à écrire... Utilisez le markdown pour le formatage",
  "elevation": "{{elevation}} m",
  "elevation_imperial": "{{elevation}} ft",
  "endPlace": "Arrivée",
  "error.loading": "Erreur lors du chargement",
  "errors.api.AD_CONTACT_DELIVERY_FAILED": "Le message n'est pas parti. Réessayez dans un moment.",
  "errors.api.AD_CONTACT_OPTED_OUT": "Ce membre a choisi de ne pas recevoir de messages au sujet de ses annonces.",
  "errors.api.AD_CONTACT_RATE_LIMITED": "Vous avez envoyé trop de messages récemment. Réessayez plus tard.",
  "errors.api.AD_CONTACT_SELF": "Vous ne pouvez pas vous écrire à vous-même.",
  "errors.api.ALREADY_REGISTERED": "Vous participez déjà à cette sortie",
  "errors.api.ASSET_NOT_AVAILABLE": "Une des pièces jointes n'est plus disponible pour ce contenu. Téléversez-la à nouveau.",
  "errors.api.AUTHORIZATION_PENDING": "Autorisation en attente, veuillez patienter",
  "errors.api.BAD_REQUEST": "Requête invalide",
  "errors.api.BIKETEAM_GRANT_EXPIRED": "L'autorisation de migration a expiré.",
  "errors.api.BIKETEAM_GRANT_INVALID": "L'autorisation de migration n'est pas valide.",
  "errors.api.BIKETEAM_JOB_NOT_FOUND": "Cette migration est introuvable.",
  "errors.api.BIKETEAM_MIGRATED_IN_OTHER_DOMAIN": "Cette équipe biketeam a déjà été migrée vers un autre site Pédalons.",
  "errors.api.BIKETEAM_MIGRATION_RUNNING": "Une migration de cette équipe est déjà en cours.",
  "errors.api.BIKETEAM_NOT_TEAM_ADMIN": "Vous n'administrez pas l'équipe déjà présente à cette adresse.",
  "errors.api.BIKETEAM_REQUEST_ALREADY_USED": "Cette demande de migration a déjà été utilisée. Relancez la migration depuis biketeam.",
  "errors.api.BIKETEAM_REQUEST_EXPIRED": "Cette demande de migration a expiré.",
  "errors.api.BIKETEAM_REQUEST_INVALID": "Cette demande de migration n'est pas valide : le lien a pu être tronqué ou modifié.",
  "errors.api.BIKETEAM_RESET_BLOCKED": "La remise à zéro est impossible : un domaine personnalisé pointe sur l'équipe existante.",
  "errors.api.BIKETEAM_SLUG_CONFLICT": "L'adresse de l'équipe est déjà prise par une équipe qui ne vient pas de biketeam.",
  "errors.api.BLOCK_SELF": "Vous ne pouvez pas vous bloquer vous-même.",
  "errors.api.BUSINESS_RULE": "Cette action n'est pas autorisée",
  "errors.api.CONTENT_REJECTED": "Ce texte contient un terme interdit sur la plateforme. Reformulez-le pour le publier.",
  "errors.api.DECRYPTION_FAILED": "Erreur interne du serveur",
  "errors.api.DEVICE_CODE_RATE_LIMITED": "Trop de codes d'appareil erronés récemment. Réessayez dans quelques minutes.",
  "errors.api.DOMAIN_ALIAS_HOSTNAME_EXISTS": "Ce nom d'hôte est déjà utilisé",
  "errors.api.DOMAIN_ALIAS_NOT_FOUND": "Site dédié introuvable",
  "errors.api.DOMAIN_ALIAS_TEAM_MISMATCH": "L'équipe épinglée n'appartient pas à ce domaine",
  "errors.api.DOMAIN_NOT_FOUND": "Domaine introuvable",
  "errors.api.EMAIL_ALREADY_EXISTS": "Un compte existe déjà avec cette adresse e-mail",
  "errors.api.EMAIL_NOT_SENT": "L'e-mail de vérification n'a pas pu partir. Réessayez dans un instant.",
  "errors.api.EMAIL_NOT_VERIFIED": "Veuillez vérifier votre adresse e-mail avant de continuer",
  "errors.api.ENCRYPTION_FAILED": "Erreur interne du serveur",
  "errors.api.EXPORT_IN_PROGRESS": "Un export de vos données est déjà en cours",
  "errors.api.EXPORT_RATE_LIMITED": "Vous avez déjà demandé un export récemment, réessayez dans un moment",
  "errors.api.failedToLoad": "Échec du chargement des données",
  "errors.api.FEEDBACK_RATE_LIMITED": "Vous avez envoyé beaucoup de signalements récemment. Réessayez plus tard.",
  "errors.api.FILE_DETECTION_FAILED": "Le type du fichier n'a pas pu être reconnu.",
  "errors.api.FILE_REQUIRED": "Un fichier est requis",
  "errors.api.FILE_TOO_LARGE": "Le fichier est trop volumineux",
  "errors.api.FILE_TYPE_REJECTED": "Ce type de fichier n'est pas accepté.",
  "errors.api.FORBIDDEN": "Vous n'avez pas les droits pour effectuer cette action",
  "errors.api.GEOCODING_UNAVAILABLE": "Le service de recherche d'adresse est indisponible. Réessayez dans un instant, ou laissez le lieu vide.",
  "errors.api.GPS_CLIENT_SECRET_REQUIRED": "Un identifiant OAuth 1.0a exige son consumer secret",
  "errors.api.GPS_CREDENTIAL_ALREADY_EXISTS": "Un identifiant GPS existe déjà pour ce service",
  "errors.api.GPS_INVALID_STATE": "L'état de la connexion GPS est invalide",
  "errors.api.GPS_OAUTH_VERSION_NOT_SUPPORTED": "Seul Garmin peut utiliser OAuth 1.0a",
  "errors.api.GPS_SERVICE_ALREADY_CONNECTED": "Ce service GPS est déjà connecté",
  "errors.api.GPS_SERVICE_NOT_CONFIGURED": "Le service GPS n'est pas configuré pour cette plateforme",
  "errors.api.GPS_SERVICE_NOT_CONNECTED": "Le service GPS n'est pas connecté",
  "errors.api.GPS_STATE_EXPIRED": "La connexion GPS a expiré, veuillez réessayer",
  "errors.api.GPS_TOKEN_EXCHANGE_FAILED": "La connexion au service GPS a échoué, veuillez réessayer",
  "errors.api.GPX_EMPTY": "Le fichier GPX ne contient aucune donnée de tracé",
  "errors.api.GPX_FAILURE": "Erreur lors du traitement du fichier GPX",
  "errors.api.GPX_MERGE_FILE_COUNT": "Choisissez entre 2 et 10 fichiers GPX à fusionner",
  "errors.api.GPX_MERGE_TOO_MANY_TRACKS": "Trop de tracés à fusionner : 16 au plus, tous fichiers confondus",
  "errors.api.GPX_NOT_FOUND": "Fichier GPX introuvable",
  "errors.api.GPX_TOO_LONG": "Le tracé est trop long : 4 000 km au plus",
  "errors.api.GROUP_FULL": "Ce groupe est complet",
  "errors.api.INTERNAL_ERROR": "Erreur interne du serveur",
  "errors.api.INVALID_CREDENTIALS": "Adresse e-mail ou mot de passe incorrect",
  "errors.api.INVALID_FORMAT": "Le format du fichier est invalide",
  "errors.api.INVALID_SLUG": "L'URL personnalisée est invalide",
  "errors.api.INVALID_TIMEZONE": "Ce fuseau horaire n'est pas reconnu",
  "errors.api.INVALID_VISIBILITY": "Le paramètre de visibilité est invalide",
  "errors.api.LAST_ADMIN": "L'équipe doit garder au moins une personne pour l'administrer",
  "errors.api.LOGIN_RATE_LIMITED": "Trop de mots de passe erronés pour cette adresse. Réessayez dans un quart d'heure.",
  "errors.api.MIGRATED_TEAM": "Cette équipe est venue de biketeam, dont les anciennes adresses redirigent vers elle : elle ne peut pas être supprimée. L'administration de la plateforme doit d'abord annuler sa bascule sur biketeam.",
  "errors.api.NOT_FOUND": "La ressource demandée est introuvable",
  "errors.api.NOT_REGISTERED": "Vous n'avez pas d'inscription à cette sortie",
  "errors.api.notFound": "La ressource demandée est introuvable.",
  "errors.api.PASSKEY_NOT_FOUND": "Clé d'accès introuvable",
  "errors.api.PASSWORD_NOT_SET": "Aucun mot de passe n'est défini pour ce compte",
  "errors.api.PLANNER_IMPORT_TOO_LARGE": "Ce fichier est trop long pour l'éditeur : importez-le avec l'onglet Fichier GPX.",
  "errors.api.PLANNER_STATE_INVALID": "L'état d'édition du tracé est invalide.",
  "errors.api.PUBLIC_RIDE_PRIVATE_ROUTE": "Une sortie publique ne peut pas utiliser un parcours privé",
  "errors.api.PUBLIC_TRIP_PRIVATE_ROUTE": "Un voyage public ne peut pas utiliser un parcours privé",
  "errors.api.RENTAL_PERIOD_MISSING": "La période de location est requise pour ce type d'annonce",
  "errors.api.REPORT_SELF": "Vous ne pouvez pas signaler votre propre contenu.",
  "errors.api.RIDE_GROUP_LEADER_NOT_MEMBER": "La personne choisie comme capitaine n'appartient pas à cette équipe.",
  "errors.api.RIDE_PAST": "Cette sortie est passée : on ne peut plus s'y inscrire",
  "errors.api.ROUTE_PLANNER_DISABLED": "Le tracé d'itinéraire n'est pas activé sur ce site.",
  "errors.api.ROUTING_NO_ROUTE": "Aucun itinéraire trouvé entre ces deux points.",
  "errors.api.ROUTING_QUOTA_EXCEEDED": "Le service de calcul d'itinéraire a atteint son quota mensuel. Réessayez plus tard.",
  "errors.api.ROUTING_SEGMENT_TOO_LONG": "Ces deux points sont trop éloignés pour un seul calcul d'itinéraire. Ajoutez un point intermédiaire.",
  "errors.api.ROUTING_UNAVAILABLE": "Le service de calcul d'itinéraire est indisponible. Réessayez dans un instant.",
  "errors.api.SESSION_EXPIRED": "Votre session a expiré, veuillez vous reconnecter",
  "errors.api.SLUG_TAKEN": "Cette URL personnalisée est déjà utilisée",
  "errors.api.SOLE_MIGRATED_TEAM_ADMIN": "Vous êtes la seule personne à administrer une équipe venue de biketeam, dont les anciennes adresses redirigent vers elle. Confiez l'administration à un autre membre avant de supprimer votre compte ; pour supprimer l'équipe, l'administration de la plateforme doit d'abord annuler sa bascule sur biketeam.",
  "errors.api.SOLE_TEAM_ADMIN": "Vous êtes la seule personne à administrer une équipe qui compte d'autres membres. Confiez l'administration à un autre membre, ou supprimez l'équipe, avant de supprimer votre compte.",
  "errors.api.STATUS_INVALID": "Ce changement de statut n'est pas autorisé",
  "errors.api.TAG_INVALID": "Un des tags choisis n'existe plus ou ne s'applique pas à ce contenu.",
  "errors.api.TAG_LABEL_INVALID": "Le libellé d'un tag doit faire entre 1 et 32 caractères.",
  "errors.api.TAG_LABEL_TAKEN": "Un tag porte déjà ce libellé pour ce type de contenu.",
  "errors.api.TAG_LIMIT_REACHED": "Cette équipe a atteint le maximum de 100 tags pour ce type de contenu.",
  "errors.api.TEAM_ADD_MEMBER_NOT_ALLOWED": "Vous n'avez pas le droit d'ajouter des membres à cette équipe",
  "errors.api.TEAM_CREATION_DISABLED": "La création d'équipes est désactivée sur cette plateforme",
  "errors.api.TEAM_INVITE_ALREADY_MEMBER": "Cette adresse appartient déjà à un membre de l'équipe.",
  "errors.api.TEAM_INVITE_ALREADY_USED": "Cette invitation a déjà été utilisée.",
  "errors.api.TEAM_INVITE_DELIVERY_FAILED": "L'e-mail d'invitation n'a pas pu être envoyé. Rien n'a été enregistré, vous pouvez réessayer.",
  "errors.api.TEAM_INVITE_EMAIL_MISMATCH": "Cette invitation est adressée à quelqu'un d'autre. Déconnectez-vous et reconnectez-vous avec l'adresse invitée.",
  "errors.api.TEAM_INVITE_EXPIRED": "Cette invitation a expiré. Demandez-en une nouvelle à l'équipe.",
  "errors.api.TEAM_INVITE_INVALID": "Cette invitation n'existe pas ou n'est plus valide.",
  "errors.api.TEAM_INVITE_NOT_PENDING": "Cette invitation n'est plus en attente.",
  "errors.api.TEAM_INVITE_RATE_LIMITED": "Vous avez envoyé trop d'invitations récemment. Réessayez plus tard.",
  "errors.api.TEAM_INVITE_REVOKED": "Cette invitation a été annulée.",
  "errors.api.TEAM_INVITE_SELF": "Vous ne pouvez pas vous inviter vous-même.",
  "errors.api.TEAM_JOIN_NOT_ALLOWED": "Vous ne pouvez pas rejoindre cette équipe",
  "errors.api.TEAM_NOT_FOUND": "Équipe introuvable",
  "errors.api.TOKEN_EXPIRED": "Le jeton a expiré",
  "errors.api.TOKEN_INVALID": "Le jeton est invalide",
  "errors.api.TOO_MANY_TAGS": "Un contenu porte au plus 10 tags.",
  "errors.api.TOO_MANY_TEAM_PAGES": "Le nombre maximum de pages pour cette équipe est atteint",
  "errors.api.UNAUTHORIZED": "Connectez-vous pour effectuer cette action",
  "errors.api.unknown": "Une erreur inattendue s'est produite",
  "errors.api.UNKNOWN": "Une erreur inattendue s'est produite",
  "errors.api.USER_NOT_FOUND": "Compte introuvable",
  "errors.api.USER_NOT_SYNCED": "Le compte n'est pas synchronisé",
  "errors.api.USER_TEAM_LIMIT_REACHED": "Vous avez atteint la limite d'équipes rejoignables",
  "errors.api.VALIDATION": "Les données fournies sont invalides",
  "errors.api.WEBHOOK_URL_INVALID": "L'URL doit être en https et pointer vers une adresse publique.",
  "errors.notFound.backHome": "Retour à l'accueil",
  "features.ads.eyebrow": "Annonces",
  "features.ads.lead": "Les annonces sont situées sans être localisables : la position est floutée à environ un kilomètre, et les messages passent par un relais e-mail.",
  "features.ads.point1": "Vente, location ou recherche",
  "features.ads.point2": "Position floutée, jamais de point exact",
  "features.ads.point3": "Aucune adresse e-mail affichée",
  "features.ads.title": "Vendre, louer, chercher du matériel entre cyclistes",
  "features.calendar.chip": "Calendrier",
  "features.calendar.eyebrow": "Calendrier et notifications",
  "features.calendar.lead": "Toutes les sorties et étapes de vos équipes dans un calendrier, que vous pouvez aussi suivre depuis votre agenda habituel. Vous choisissez ce qui vous est notifié.",
  "features.calendar.point1": "Calendrier jour, semaine, mois",
  "features.calendar.point2": "Abonnement iCal pour votre agenda",
  "features.calendar.point3": "Notifications dans le site, par e-mail, sur le téléphone et dans le navigateur",
  "features.calendar.point4": "Préférences par type de notification",
  "features.calendar.point5": "Agenda de l'équipe : à venir, mes inscriptions, passées",
  "features.calendar.title": "Rien ne vous échappe, sans tout surveiller",
  "features.cta.backToFeed": "Retour au fil",
  "features.cta.browseTeams": "Parcourir les équipes",
  "features.cta.signIn": "Se connecter",
  "features.cta.signUp": "Créer un compte",
  "features.demo.ad.blurred": "Position floutée à environ 1 km",
  "features.demo.ad.price": "450 €",
  "features.demo.ad.relay": "Votre message passe par un relais : l'adresse de la personne qui a publié l'annonce ne vous est jamais communiquée.",
  "features.demo.ad.title": "Roue arrière carbone 11 vitesses",
  "features.demo.calendar.gravel": "Gravel",
  "features.demo.calendar.ics": "Abonnez votre agenda (Google, Apple, Outlook) au calendrier de vos équipes.",
  "features.demo.calendar.notificationBody": "Gravel des Crêts · samedi 20, 08h00",
  "features.demo.calendar.notificationTitle": "Nouvelle sortie dans VC Craponne",
  "features.demo.calendar.stage1": "Étape 1",
  "features.demo.calendar.stage2": "Étape 2",
  "features.demo.calendar.tuesday": "Mardi soir",
  "features.demo.calendar.weekdays": "L,M,M,J,V,S,D",
  "features.demo.device.distance": "42,6 km",
  "features.demo.device.distanceLabel": "DIST.",
  "features.demo.device.elevation": "640 m",
  "features.demo.device.elevationLabel": "D+",
  "features.demo.post.comment1Author": "Julien L.",
  "features.demo.post.comment1Body": "Le départ reste au stade ?",
  "features.demo.post.comment1When": "il y a 3 h",
  "features.demo.post.comment2Author": "Camille M.",
  "features.demo.post.comment2Body": "Oui, même lieu. Seule l'heure change.",
  "features.demo.post.comment2When": "il y a 1 h",
  "features.demo.post.excerpt": "À partir du 1er novembre, départ une heure plus tard et parcours raccourcis à 70 km.",
  "features.demo.post.title": "Calendrier d'hiver : les sorties passent à 9h",
  "features.demo.privacy.passwordless": "Connexion sans mot de passe par clé d'accès ou code reçu par e-mail",
  "features.demo.privacy.public": "Visible de tout le monde, listé",
  "features.demo.privacy.team": "Visible des seuls membres",
  "features.demo.privacy.unlisted": "Accessible à qui a le lien",
  "features.demo.ride.groupA": "Groupe A",
  "features.demo.ride.groupB": "Groupe B",
  "features.demo.ride.groupC": "Groupe C",
  "features.demo.ride.groupsTitle": "Groupes",
  "features.demo.ride.paceA": "31 km/h · 110 km",
  "features.demo.ride.paceB": "28 km/h · 92 km",
  "features.demo.ride.paceC": "25 km/h · 68 km",
  "features.demo.ride.participants": "{{registered}}/{{max}} personnes",
  "features.demo.route.climb1": "Col de la Croix de Chaubouret",
  "features.demo.route.climb1Stats": "7,4 km · 5,2 %",
  "features.demo.route.climb2": "Montée de la Jasserie",
  "features.demo.route.climb2Stats": "4,1 km · 4,6 %",
  "features.demo.route.distance": "74 km",
  "features.demo.route.elevation": "1 580 m",
  "features.demo.route.title": "Les Crêts du Pilat par la Jasserie",
  "features.demo.trip.stage1Label": "Étape 1 · ven. 14 mai",
  "features.demo.trip.stage1Stats": "78 km · 1 350 m",
  "features.demo.trip.stage1Title": "Annonay → Lamastre",
  "features.demo.trip.stage2Label": "Étape 2 · sam. 15 mai",
  "features.demo.trip.stage2Stats": "84 km · 1 720 m",
  "features.demo.trip.stage2Title": "Lamastre → Vals-les-Bains",
  "features.demo.trip.stage3Label": "Étape 3 · dim. 16 mai",
  "features.demo.trip.stage3Stats": "66 km · 820 m",
  "features.demo.trip.stage3Title": "Vals-les-Bains → Vallon-Pont-d'Arc",
  "features.demo.trip.stage4Label": "Étape 4 · lun. 17 mai",
  "features.demo.trip.stage4Stats": "58 km · 640 m",
  "features.demo.trip.stage4Title": "Gorges de l'Ardèche",
  "features.demo.trip.title": "L'Ardèche en quatre étapes",
  "features.demo.weather.cross": "30 km",
  "features.demo.weather.head": "28 km",
  "features.demo.weather.km": "km {{km}}",
  "features.demo.weather.speed": "28 km/h",
  "features.demo.weather.tail": "34 km",
  "features.demo.weather.title": "Groupe B · samedi 08:00",
  "features.devices.eyebrow": "Compteurs",
  "features.devices.garmin": "Garmin Edge",
  "features.devices.karoo": "Hammerhead Karoo",
  "features.devices.lead": "Reliez votre compteur à votre compte une fois. Ensuite, envoyez le parcours vers votre compteur : il vous attend au départ.",
  "features.devices.title": "Du site au guidon",
  "features.devices.wahoo": "Wahoo ELEMNT",
  "features.final.subtitle": "Créez votre compte, rejoignez une équipe ou créez la vôtre.",
  "features.final.subtitleMember": "Retrouvez les sorties et les nouvelles de vos équipes dans votre fil.",
  "features.final.subtitleSingleTeam": "Créez votre compte pour rejoindre l'équipe.",
  "features.final.title": "On roule ensemble ?",
  "features.hero.eyebrow": "Fonctionnalités",
  "features.hero.subtitle": "Sorties en groupes, parcours GPX, météo, voyages, publications et annonces. Pour les associations, les équipes informelles et l'organisation de voyages.",
  "features.hero.title": "Tout ce qu'il faut pour faire rouler une équipe",
  "features.jump.label": "Sections de la page",
  "features.meta.description": "Sorties en groupes, parcours GPX, météo du parcours, voyages, publications et annonces : tout ce qu'il faut pour faire rouler une équipe cycliste.",
  "features.meta.title": "Fonctionnalités",
  "features.posts.eyebrow": "Publications",
  "features.posts.lead": "Changement d'horaire, compte rendu, assemblée générale : publiez un texte mis en forme, avec images et pièces jointes, et laissez les membres réagir.",
  "features.posts.point1": "Texte mis en forme, images et pièces jointes",
  "features.posts.point2": "Commentaires sur les sorties, parcours, voyages et publications",
  "features.posts.point3": "Pages d'équipe personnalisées",
  "features.posts.title": "Les nouvelles de l'équipe, là où sont les sorties",
  "features.privacy.eyebrow": "Confidentialité",
  "features.privacy.lead": "Chaque équipe, et chaque contenu, choisit sa visibilité. Vos données vous appartiennent : export et suppression du compte en libre-service.",
  "features.privacy.point1": "Trois niveaux de visibilité",
  "features.privacy.point2": "Connexion par clé d'accès, code par e-mail ou mot de passe",
  "features.privacy.point3": "Export de vos données, suppression de votre compte",
  "features.privacy.point4": "Signalement et modération des contenus",
  "features.privacy.title": "Vous décidez de qui voit quoi",
  "features.rides.eyebrow": "Sorties",
  "features.rides.lead": "Chaque sortie propose ses groupes, avec leur allure, leur parcours, leur nombre de places et les personnes inscrites. On s'inscrit en un geste, on voit qui vient.",
  "features.rides.point1": "Groupes avec places limitées",
  "features.rides.point2": "Lieux de départ et d'arrivée enregistrés",
  "features.rides.point3": "Modèles réutilisables pour les sorties régulières",
  "features.rides.point4": "Brouillon avant publication, annulation signalée à tout le monde",
  "features.rides.title": "Une sortie, plusieurs groupes, chacun à son allure",
  "features.roles.admin.point1": "Vous gérez les membres et leurs rôles",
  "features.roles.admin.point2": "Vous choisissez les rubriques actives et la visibilité",
  "features.roles.admin.point3": "Vous relayez les nouvelles de l'équipe vers Slack, Discord ou Mattermost",
  "features.roles.admin.point4": "Les derniers membres arrivés s'affichent, pour les accueillir",
  "features.roles.admin.title": "Vous animez l'équipe",
  "features.roles.member.point1": "Vous vous inscrivez dans le groupe à votre allure",
  "features.roles.member.point2": "Vous récupérez le parcours en GPX, en FIT ou sur votre compteur",
  "features.roles.member.point3": "Vous commentez et suivez les nouvelles",
  "features.roles.member.point4": "Vos prochaines sorties en tête du tableau de bord",
  "features.roles.member.title": "Vous roulez",
  "features.roles.organizer.point1": "Vous publiez sorties, parcours, voyages et publications",
  "features.roles.organizer.point2": "Vous réutilisez des modèles pour les sorties régulières",
  "features.roles.organizer.point3": "Vous préparez en brouillon avant de publier",
  "features.roles.organizer.point4": "Brouillons, sorties sans parcours, groupes complets et signalements vous sont rappelés",
  "features.roles.organizer.title": "Vous organisez",
  "features.roles.subtitle": "Trois rôles, attribués par l'administration de l'équipe. En ouvrant l'équipe, chaque membre trouve un tableau de bord à sa mesure.",
  "features.roles.title": "Une place pour tout le monde",
  "features.routes.eyebrow": "Parcours",
  "features.routes.lead": "Importez un GPX ou tracez le parcours sur la carte : distance, dénivelé positif, relief, cols et montées sont calculés pour vous. Filtrez par distance, dénivelé ou relief, et parcourez la bibliothèque en vignettes, en lignes ou sur la carte.",
  "features.routes.point1": "Profil altimétrique coloré par la pente",
  "features.routes.point2": "Cols et montées détectés, avec leur catégorie",
  "features.routes.point3": "Téléchargement en GPX et en FIT",
  "features.routes.point4": "Type de revêtement : route, gravel, VTT, mixte",
  "features.routes.point5": "Outils GPX : visualisez un fichier sans le publier",
  "features.routes.title": "Une bibliothèque de parcours que l'équipe enrichit",
  "features.trips.eyebrow": "Voyages",
  "features.trips.lead": "Un voyage regroupe ses étapes, chacune avec sa date, son parcours et ses lieux. On s'inscrit une fois pour tout le voyage.",
  "features.trips.point1": "Étapes datées, chacune avec son parcours",
  "features.trips.point2": "Inscription unique au voyage",
  "features.trips.point3": "Vue d'ensemble des distances et des dénivelés",
  "features.trips.point4": "Vitesse moyenne propre à chaque étape",
  "features.trips.title": "Des voyages de plusieurs jours, étape par étape",
  "features.weather.eyebrow": "Météo",
  "features.weather.lead": "Dans les sept jours qui précèdent le départ, chaque sortie et chaque étape affiche ses prévisions : au point de départ, puis le long du parcours, à l'heure où chaque groupe y passera à son allure.",
  "features.weather.point1": "Prévisions le long du parcours, groupe par groupe",
  "features.weather.point2": "Vent de face, de travers ou dans le dos, tronçon par tronçon",
  "features.weather.point3": "Alerte quand la pluie est probable sur le parcours",
  "features.weather.point4": "Météo de chaque étape d'un voyage, résumée sur les cartes",
  "features.weather.title": "La météo à l'heure où vous passerez",
  "feedback.attach": "Joindre les informations techniques",
  "feedback.attachDescription": "Page, version, navigateur et journal des dernières actions, sans mot de passe ni adresse e-mail. Ils nous aident beaucoup à reproduire un bug.",
  "feedback.counter": "{{length}} / {{max}}",
  "feedback.error.generic": "Le signalement n'a pas pu être envoyé. Votre texte est conservé, réessayez.",
  "feedback.error.rateLimitedIn": "Vous avez envoyé beaucoup de signalements récemment. Réessayez dans {{minutes}} minutes.",
  "feedback.error.tooLong": "Le message est trop long.",
  "feedback.error.tooShort": "Décrivez le problème en quelques mots (10 caractères minimum).",
  "feedback.errorAttached": "Erreur jointe au signalement",
  "feedback.hidePreview": "Masquer",
  "feedback.kind.BUG": "Un problème",
  "feedback.kind.SUGGESTION": "Une suggestion",
  "feedback.menu": "Signaler un problème",
  "feedback.messageLabel.BUG": "Que s'est-il passé ? (facultatif)",
  "feedback.messageLabel.SUGGESTION": "Votre idée",
  "feedback.placeholder.BUG": "Ce que vous faisiez, ce que vous attendiez, ce qui s'est produit…",
  "feedback.placeholder.SUGGESTION": "Ce qui vous manque, ce qui pourrait être plus simple…",
  "feedback.send": "Envoyer",
  "feedback.sent": "Merci ! Votre signalement a bien été transmis à l'équipe.",
  "feedback.showPreview": "Voir ce qui sera envoyé",
  "feedback.title": "Signaler un problème",
  "filters.membership.all": "Toutes les équipes",
  "filters.membership.label": "Équipes",
  "footer.apps": "Applications",
  "footer.copyright": "© {{year}} {{appName}}. Tous droits réservés.",
  "footer.features": "Fonctionnalités",
  "footer.privacy": "Politique de confidentialité",
  "footer.support": "Aide",
  "footer.terms": "Conditions d'utilisation",
  "footer.version": "v{{version}} ({{commit}})",
  "footer.versionShort": "v{{version}}",
  "form.charCount_one": "{{count}}/{{max}} caractère",
  "form.charCount_many": "{{count}}/{{max}} caractères",
  "form.charCount_other": "{{count}}/{{max}} caractères",
  "form.description": "Description",
  "form.publishAt.futureRequired": "La date de publication doit être dans le futur",
  "form.publishAtHint": "Définissez une date/heure pour une publication automatique",
  "form.rentalPeriod.required": "La période de location est requise pour les annonces de location",
  "form.status": "Statut",
  "form.title": "Titre",
  "generic.retry": "Réessayer",
  "generic.title": "Une erreur est survenue",
  "geocoder.attribution": "Adresses : Stadia Maps, © les contributeurs OpenStreetMap et autres",
  "geocoder.clear": "Supprimer la localisation",
  "geocoder.label": "Localisation",
  "geocoder.noResults": "Aucune adresse trouvée",
  "geocoder.placeholder": "Rechercher une adresse...",
  "geocoder.resolveFailed": "Impossible d'obtenir la position de cette adresse. Recherchez-la et choisissez-la de nouveau, ou laissez le lieu vide.",
  "geocoder.resolving": "Localisation de l'adresse…",
  "gps.autoSync.ariaLabel": "Envoyer automatiquement vers {{service}} les parcours de mes sorties",
  "gps.autoSync.description": "Les parcours des sorties auxquelles vous participez, dès 7 jours avant le départ, mis à jour s'ils changent. Pédalons les retire le lendemain de la sortie, si vous vous désinscrivez, ou quand vous désactivez l'envoi.",
  "gps.autoSync.label": "Envoyer automatiquement les parcours de mes sorties",
  "gps.autoSync.lastSent": "dernier envoi le {{date}}",
  "gps.autoSync.notifications.disabled": "Envoi automatique désactivé pour {{service}}",
  "gps.autoSync.notifications.enabled": "Envoi automatique activé pour {{service}}",
  "gps.autoSync.notifications.failed": "Le réglage n'a pas pu être enregistré. Réessayez.",
  "gps.autoSync.reconnect": "Reconnecter",
  "gps.autoSync.state.failing": "Le dernier envoi vers {{service}} a échoué. Pédalons réessaie pendant quelques heures, puis attend que le parcours change ou que l'envoi soit désactivé puis réactivé.",
  "gps.autoSync.state.pending": "Envoi en cours…",
  "gps.autoSync.state.reconnectRequired": "{{service}} refuse l'accès : reconnectez le service pour reprendre l'envoi.",
  "gps.autoSync.state.upToDate_one": "À jour · {{count}} parcours envoyé",
  "gps.autoSync.state.upToDate_many": "À jour · {{count}} parcours envoyés",
  "gps.autoSync.state.upToDate_other": "À jour · {{count}} parcours envoyés",
  "gps.autoSync.state.upToDateNone": "À jour · aucune sortie à venir à envoyer",
  "gps.connect": "Connecter",
  "gps.connected": "Connecté",
  "gps.connectedSince": "Connecté depuis le {{date}}",
  "gps.description": "Vos comptes Hammerhead, Garmin Connect ou Wahoo. « Envoyer vers l'appareil » y dépose un parcours ; l'envoi automatique y dépose ceux des sorties auxquelles vous participez. Votre compteur les récupère à sa prochaine synchronisation.",
  "gps.devices.description": "Les Karoo et Garmin sur lesquels l'application Pédalons est installée et liée à votre compte par un code.",
  "gps.devices.empty": "Aucun Karoo ni Garmin n'est appairé à votre compte.",
  "gps.devices.howToPair": "Comment appairer un appareil",
  "gps.devices.lastUsed": "utilisé {{when}}",
  "gps.devices.notifications.unpaired": "Appareil délié",
  "gps.devices.notifications.unpairFailed": "L'appareil n'a pas pu être délié. Réessayez.",
  "gps.devices.pairedOn": "Appairé le {{date}}",
  "gps.devices.title": "Appareils appairés",
  "gps.devices.types.garmin": "Garmin",
  "gps.devices.types.karoo": "Karoo",
  "gps.devices.types.other": "Appareil",
  "gps.devices.unpair": "Délier",
  "gps.devices.unpairConfirm.confirm": "Délier",
  "gps.devices.unpairConfirm.message": "{{device}} n'aura plus accès à votre compte et devra être appairé de nouveau. Vos autres appareils et sessions restent ouverts.",
  "gps.devices.unpairConfirm.title": "Délier l'appareil",
  "gps.devices.unpairLabel": "Délier {{device}}",
  "gps.disconnect": "Déconnecter",
  "gps.disconnectConfirm.autoSyncRoutes_one": "Le parcours envoyé automatiquement sera retiré de {{service}}.",
  "gps.disconnectConfirm.autoSyncRoutes_many": "Les {{count}} parcours envoyés automatiquement seront retirés de {{service}}.",
  "gps.disconnectConfirm.autoSyncRoutes_other": "Les {{count}} parcours envoyés automatiquement seront retirés de {{service}}.",
  "gps.disconnectConfirm.confirm": "Déconnecter",
  "gps.disconnectConfirm.message": "Voulez-vous vraiment déconnecter {{service}} ? Vous pouvez vous reconnecter à tout moment.",
  "gps.disconnectConfirm.title": "Déconnecter le service",
  "gps.noServicesConfigured": "Aucun service GPS n'est configuré pour cette plateforme.",
  "gps.notifications.connected": "{{service}} est associé à votre compte.",
  "gps.notifications.connectFailed": "Échec de la connexion au service GPS",
  "gps.notifications.disconnected": "Service GPS déconnecté",
  "gps.notifications.disconnectFailed": "Échec de la déconnexion du service GPS",
  "gps.notifications.returnDenied": "Vous avez refusé l'accès chez le service GPS : rien n'a été connecté.",
  "gps.notifications.returnFailed": "La connexion du service GPS n'a pas abouti.",
  "gps.notifications.uploadFailed": "Échec de l'envoi du parcours",
  "gps.notifications.uploadSuccess": "Parcours envoyé avec succès",
  "gps.services.garmin": "Garmin Connect",
  "gps.services.hammerhead": "Hammerhead",
  "gps.services.wahoo": "Wahoo",
  "gps.title": "Services connectés",
  "gpxTools.blankMap.description": "Ouvrez une carte vierge en plein écran : fonds de carte, relief et votre position.",
  "gpxTools.blankMap.pageTitle": "Carte",
  "gpxTools.blankMap.submit": "Ouvrir la carte",
  "gpxTools.blankMap.title": "Ouvrir une carte",
  "gpxTools.createFromScratch.created": "Parcours créé",
  "gpxTools.createFromScratch.description": "Tracez un itinéraire sur une carte vierge, sans fichier GPX, à l'aide du planificateur.",
  "gpxTools.createFromScratch.renameFailed": "Parcours créé, mais le nom saisi n'a pas pu être enregistré : il porte le nom du fichier.",
  "gpxTools.createFromScratch.submit": "Créer un parcours",
  "gpxTools.createFromScratch.subtitle": "Tracez votre itinéraire sur la carte, nommez-le, puis analysez-le.",
  "gpxTools.createFromScratch.title": "Créer un parcours",
  "gpxTools.edit.gpxFileHint": "Laissez vide pour conserver le tracé actuel et ne modifier que le nom.",
  "gpxTools.edit.nameTooShort": "Le nom doit contenir au moins 3 caractères.",
  "gpxTools.edit.subtitle": "Renommez le fichier et, si besoin, redessinez son tracé ou remplacez-le par un nouveau GPX.",
  "gpxTools.edit.title": "Modifier le fichier GPX",
  "gpxTools.edit.updated": "Fichier mis à jour",
  "gpxTools.listFiles.description": "Retrouvez les fichiers GPX que vous avez déposés et qui sont encore disponibles.",
  "gpxTools.listFiles.empty": "Vous n'avez aucun fichier disponible pour le moment.",
  "gpxTools.listFiles.submit": "Voir mes fichiers",
  "gpxTools.listFiles.title": "Lister mes fichiers",
  "gpxTools.listFiles.view": "Voir",
  "gpxTools.merge.description": "Déposez de 2 à 10 fichiers GPX : leurs tracés sont mis bout à bout en un seul, dans l'ordre et le sens qui les relient au plus court.",
  "gpxTools.merge.fileCount": "Choisissez entre {{min}} et {{max}} fichiers GPX à fusionner (sélection : {{selected}}).",
  "gpxTools.merge.submit": "Choisir les fichiers",
  "gpxTools.merge.title": "Fusionner des fichiers",
  "gpxTools.preview.delete": "Supprimer",
  "gpxTools.preview.deleteConfirm": "Voulez-vous vraiment supprimer ce fichier ? Le lien ne sera plus accessible.",
  "gpxTools.preview.deleted": "Fichier supprimé",
  "gpxTools.preview.drawnNeedsPlanner": "Ce tracé a été dessiné : il ne peut être enregistré que dans une équipe dont le tracé d'itinéraire est activé. Les autres équipes sont grisées.",
  "gpxTools.preview.edit": "Modifier",
  "gpxTools.preview.elevationRefining": "Profil d'altitude provisoire : un fichier téléchargé maintenant porte l'altitude rapide.",
  "gpxTools.preview.noTeam": "Aucune équipe où créer un parcours",
  "gpxTools.preview.plannerClosedForTeam": "Cette équipe n'a pas activé le tracé d'itinéraire : un tracé dessiné ne peut pas y être enregistré.",
  "gpxTools.preview.save": "Enregistrer",
  "gpxTools.preview.saveAsRoute": "Enregistrer comme parcours",
  "gpxTools.preview.selectTeam": "Équipe",
  "gpxTools.preview.title": "Visualisation",
  "gpxTools.retentionNotice": "Les fichiers déposés ici sont conservés 30 jours, puis supprimés.",
  "gpxTools.subtitle": "Analysez un fichier GPX sans le rattacher à une équipe.",
  "gpxTools.title": "Outils GPX",
  "gpxTools.viewFile.description": "Déposez un fichier GPX pour voir la carte, le profil altimétrique et les cols détectés.",
  "gpxTools.viewFile.submit": "Choisir un fichier",
  "gpxTools.viewFile.title": "Visualiser un fichier",
  "groups.add": "Ajouter un groupe",
  "groups.groupCount_one": "{{count}} groupe",
  "groups.groupCount_many": "{{count}} groupes",
  "groups.groupCount_other": "{{count}} groupes",
  "groups.groupOrganizer": "Organisateur du groupe",
  "home.actions.addRoute": "Ajouter un parcours",
  "home.actions.createRide": "Créer une sortie",
  "home.actions.label": "Actions rapides",
  "home.actions.pickTeam": "Choisir l'équipe",
  "home.actions.writePost": "Rédiger une publication",
  "home.feed.empty": "Aucune publication pour le moment",
  "home.feed.emptyDescription": "Les publications et les sorties des équipes apparaîtront ici dès leur parution.",
  "home.feed.noResults": "Aucune publication ne correspond à votre recherche.",
  "home.feed.noResultsTitle": "Aucune publication trouvée",
  "home.feed.search.label": "Rechercher des publications",
  "home.feed.search.placeholder": "Rechercher par titre ou description...",
  "home.feed.title": "Dernières publications",
  "home.member.dateFormat": "EEEE d MMMM",
  "home.member.greeting": "Bonjour {{name}}",
  "home.member.greetingAnonymous": "Bonjour",
  "home.member.promo.text": "Karoo, Garmin ou Wahoo : connectez votre compte ou appairez votre compteur depuis votre profil, et le parcours de votre groupe y arrive.",
  "home.member.promo.title": "Envoyez vos parcours vers votre compteur",
  "home.member.summary.none": "Aucune sortie prévue dans vos équipes ces 7 prochains jours.",
  "home.member.summary.registered_one": "Vous participez à l'une d'elles.",
  "home.member.summary.registered_many": "Vous participez à {{count}} d'entre elles.",
  "home.member.summary.registered_other": "Vous participez à {{count}} d'entre elles.",
  "home.member.summary.registeredAll_one": "Vous y participez.",
  "home.member.summary.registeredAll_many": "Vous participez à toutes.",
  "home.member.summary.registeredAll_other": "Vous participez à toutes.",
  "home.member.summary.rides_one": "{{count}} sortie dans vos équipes ces 7 prochains jours.",
  "home.member.summary.rides_many": "{{count}} sorties dans vos équipes ces 7 prochains jours.",
  "home.member.summary.rides_other": "{{count}} sorties dans vos équipes ces 7 prochains jours.",
  "home.nextRide.distance": "Distance",
  "home.nextRide.elevation": "Dénivelé positif",
  "home.nextRide.empty.description": "Inscrivez-vous à une sortie de vos équipes pour la retrouver ici.",
  "home.nextRide.empty.title": "Aucune sortie à venir",
  "home.nextRide.groupAndTime": "{{group}} — départ {{time}}",
  "home.nextRide.groupParticipants": "{{group}} · {{participants}}",
  "home.nextRide.leave": "Se désinscrire",
  "home.nextRide.leaveConfirm.message": "Votre inscription à « {{name}} » sera annulée. Vous pourrez vous réinscrire tant que la sortie n'est pas complète.",
  "home.nextRide.leaveConfirm.title": "Se désinscrire de la sortie ?",
  "home.nextRide.title": "Ma prochaine sortie",
  "home.nextRide.view": "Voir la sortie",
  "home.subtitle": "Votre plateforme pour organiser vos sorties cyclistes",
  "home.tabs.feed": "Accueil",
  "home.teams.activity.posts_one": "{{count}} nouvelle publication",
  "home.teams.activity.posts_many": "{{count}} nouvelles publications",
  "home.teams.activity.posts_other": "{{count}} nouvelles publications",
  "home.teams.activity.rides_one": "{{count}} sortie à venir",
  "home.teams.activity.rides_many": "{{count}} sorties à venir",
  "home.teams.activity.rides_other": "{{count}} sorties à venir",
  "home.teams.activity.trips_one": "{{count}} voyage à venir",
  "home.teams.activity.trips_many": "{{count}} voyages à venir",
  "home.teams.activity.trips_other": "{{count}} voyages à venir",
  "home.teams.empty": "Vous n'êtes membre d'aucune équipe pour le moment.",
  "home.teams.find": "Trouver une équipe",
  "home.teams.seeAll_one": "Voir l'équipe",
  "home.teams.seeAll_many": "Voir les {{count}} équipes",
  "home.teams.seeAll_other": "Voir les {{count}} équipes",
  "home.teams.title": "Mes équipes",
  "home.visitor.browseTeams": "Parcourir les équipes",
  "home.visitor.cta.text": "Créez un compte, puis votre équipe : vous l'administrez et vous invitez vos membres.",
  "home.visitor.cta.title": "Votre équipe n'est pas encore sur {{appName}} ?",
  "home.visitor.devices.garmin": "Garmin Edge",
  "home.visitor.devices.karoo": "Hammerhead Karoo",
  "home.visitor.devices.phone": "Téléphone",
  "home.visitor.devices.text": "Karoo, Garmin ou Wahoo : envoyez le parcours de votre sortie vers votre compteur. Le site s'installe aussi sur l'écran d'accueil de votre téléphone et vous prévient des nouvelles sorties.",
  "home.visitor.devices.title": "Du site à votre compteur",
  "home.visitor.devices.wahoo": "Wahoo ELEMNT",
  "home.visitor.discover": "Découvrir les fonctionnalités",
  "home.visitor.eyebrow": "Plateforme d'équipes cyclistes",
  "home.visitor.features.all": "Toutes les fonctionnalités",
  "home.visitor.features.posts.text": "Les nouvelles de l'équipe, commentées par ses membres.",
  "home.visitor.features.posts.title": "Publications",
  "home.visitor.features.rides.text": "Plusieurs groupes par sortie, des places limitées, l'inscription en un geste.",
  "home.visitor.features.rides.title": "Sorties et groupes",
  "home.visitor.features.routes.text": "Importez, tracez, filtrez par distance et dénivelé, envoyez vers votre compteur.",
  "home.visitor.features.routes.title": "Parcours GPX",
  "home.visitor.features.subtitle": "Des membres qui s'inscrivent, d'autres qui organisent, d'autres qui administrent.",
  "home.visitor.features.title": "Tout pour faire rouler une équipe",
  "home.visitor.features.trips.text": "Des voyages de plusieurs jours, découpés en étapes avec leur parcours.",
  "home.visitor.features.trips.title": "Voyages",
  "home.visitor.feed.subtitle": "Ce que partagent les équipes ouvertes à tout le monde.",
  "home.visitor.feed.subtitleSingleTeam": "Ce que l'équipe partage avec tout le monde.",
  "home.visitor.feed.title": "Dernières publications publiques",
  "home.visitor.login.subtitle": "Retrouvez vos équipes, vos sorties et vos parcours.",
  "home.visitor.login.title": "Connexion",
  "home.visitor.pitch": "{{appName}} réunit les équipes cyclistes : un calendrier de sorties, une bibliothèque de parcours et les nouvelles de l'équipe, au même endroit.",
  "home.visitor.points.devices": "Le parcours de la sortie envoyé vers votre compteur Karoo, Garmin ou Wahoo",
  "home.visitor.points.rides": "Les sorties de vos équipes, avec leurs groupes et leurs places",
  "home.visitor.points.routes": "Des parcours à explorer, à télécharger en GPX ou FIT",
  "home.visitor.title": "Organisez vos sorties. Partagez vos parcours. Roulez ensemble.",
  "home.week.calendarLink": "Voir le calendrier",
  "home.week.empty": "Aucune sortie ni étape prévue ces 7 prochains jours.",
  "home.week.nothingElse": "Aucune autre sortie ni étape prévue ces 7 prochains jours.",
  "home.week.title": "Les 7 prochains jours",
  "images.notFound": "Image non trouvée",
  "install.action": "Installer",
  "install.banner.close": "Ne plus proposer",
  "install.banner.message": "Installez le site comme une application, et recevez les notifications.",
  "install.banner.openStore": "Télécharger",
  "install.banner.storeMessage": "L'application mobile est disponible.",
  "install.banner.title": "{{appName}} sur votre écran d'accueil",
  "install.instructions.addToHomeScreen": "Choisissez « Sur l'écran d'accueil » (faites défiler si besoin).",
  "install.instructions.confirm": "Touchez « Ajouter » : l'icône apparaît sur votre écran d'accueil.",
  "install.instructions.intro": "Sur iPhone et iPad, l'installation passe par le menu Partager, depuis Safari ou votre navigateur.",
  "install.instructions.notifications": "Ouvrez ensuite l'application depuis cette icône pour pouvoir activer les notifications.",
  "install.instructions.share": "Touchez le bouton Partager, en bas de l'écran ou dans la barre d'adresse.",
  "install.instructions.title": "Installer {{appName}}",
  "install.menu": "Installer l'application",
  "invitations.accept.alreadyMember": "Vous faites déjà partie de {{team}}.",
  "invitations.accept.backToTeams": "Voir les équipes",
  "invitations.accept.goToTeam": "Voir l'équipe",
  "invitations.accept.join": "Rejoindre l'équipe",
  "invitations.accept.joined": "Vous avez rejoint {{team}}.",
  "invitations.accept.notRedeemable": "Cette invitation n'est plus valide. Demandez-en une nouvelle à l'équipe.",
  "invitations.accept.pageTitle": "Invitation",
  "invitations.accept.signIn": "Se connecter",
  "invitations.accept.signInPrompt": "Connectez-vous, ou créez un compte, avec l'adresse invitée pour accepter.",
  "invitations.accept.subtitle": "En tant que {{role}}, pour l'adresse {{email}}.",
  "invitations.accept.switchAccount": "Se déconnecter et utiliser un autre compte",
  "invitations.accept.title": "{{inviter}} vous invite à rejoindre {{team}}",
  "invitations.accept.unavailableBody": "Le lien est incomplet ou n'est plus valide.",
  "invitations.accept.unavailableTitle": "Invitation indisponible",
  "invitations.banner.accept": "Accepter",
  "invitations.banner.joined": "Vous avez rejoint {{team}}.",
  "invitations.banner.line": "{{inviter}} vous invite à rejoindre {{team}}.",
  "invitations.banner.title_one": "Vous avez une invitation en attente",
  "invitations.banner.title_many": "Vous avez {{count}} invitations en attente",
  "invitations.banner.title_other": "Vous avez {{count}} invitations en attente",
  "legal.privacy.title": "Politique de confidentialité",
  "legal.support.title": "Aide et contact",
  "legal.terms.title": "Conditions d'utilisation",
  "list.count.ads_one": "{{formatted}} annonce",
  "list.count.ads_many": "{{formatted}} annonces",
  "list.count.ads_other": "{{formatted}} annonces",
  "list.count.agendaMine_one": "{{formatted}} sortie ou voyage auquel vous participez",
  "list.count.agendaMine_many": "{{formatted}} sorties et voyages auxquels vous participez",
  "list.count.agendaMine_other": "{{formatted}} sorties et voyages auxquels vous participez",
  "list.count.agendaMineRides_one": "{{formatted}} sortie à laquelle vous participez",
  "list.count.agendaMineRides_many": "{{formatted}} sorties auxquelles vous participez",
  "list.count.agendaMineRides_other": "{{formatted}} sorties auxquelles vous participez",
  "list.count.agendaMineTrips_one": "{{formatted}} voyage auquel vous participez",
  "list.count.agendaMineTrips_many": "{{formatted}} voyages auxquels vous participez",
  "list.count.agendaMineTrips_other": "{{formatted}} voyages auxquels vous participez",
  "list.count.agendaPast_one": "{{formatted}} sortie ou voyage passé",
  "list.count.agendaPast_many": "{{formatted}} sorties et voyages passés",
  "list.count.agendaPast_other": "{{formatted}} sorties et voyages passés",
  "list.count.agendaPastRides_one": "{{formatted}} sortie passée",
  "list.count.agendaPastRides_many": "{{formatted}} sorties passées",
  "list.count.agendaPastRides_other": "{{formatted}} sorties passées",
  "list.count.agendaPastTrips_one": "{{formatted}} voyage passé",
  "list.count.agendaPastTrips_many": "{{formatted}} voyages passés",
  "list.count.agendaPastTrips_other": "{{formatted}} voyages passés",
  "list.count.agendaUpcoming_one": "{{formatted}} sortie ou voyage à venir",
  "list.count.agendaUpcoming_many": "{{formatted}} sorties et voyages à venir",
  "list.count.agendaUpcoming_other": "{{formatted}} sorties et voyages à venir",
  "list.count.agendaUpcomingRides_one": "{{formatted}} sortie à venir",
  "list.count.agendaUpcomingRides_many": "{{formatted}} sorties à venir",
  "list.count.agendaUpcomingRides_other": "{{formatted}} sorties à venir",
  "list.count.agendaUpcomingTrips_one": "{{formatted}} voyage à venir",
  "list.count.agendaUpcomingTrips_many": "{{formatted}} voyages à venir",
  "list.count.agendaUpcomingTrips_other": "{{formatted}} voyages à venir",
  "list.count.members_one": "{{formatted}} membre",
  "list.count.members_many": "{{formatted}} membres",
  "list.count.members_other": "{{formatted}} membres",
  "list.count.notifications_one": "{{formatted}} notification",
  "list.count.notifications_many": "{{formatted}} notifications",
  "list.count.notifications_other": "{{formatted}} notifications",
  "list.count.participations_one": "{{formatted}} participation",
  "list.count.participations_many": "{{formatted}} participations",
  "list.count.participations_other": "{{formatted}} participations",
  "list.count.publications_one": "{{formatted}} publication",
  "list.count.publications_many": "{{formatted}} publications",
  "list.count.publications_other": "{{formatted}} publications",
  "list.count.rides_one": "{{formatted}} sortie",
  "list.count.rides_many": "{{formatted}} sorties",
  "list.count.rides_other": "{{formatted}} sorties",
  "list.count.routes_one": "{{formatted}} parcours",
  "list.count.routes_many": "{{formatted}} parcours",
  "list.count.routes_other": "{{formatted}} parcours",
  "list.count.teams_one": "{{formatted}} équipe",
  "list.count.teams_many": "{{formatted}} équipes",
  "list.count.teams_other": "{{formatted}} équipes",
  "list.count.trips_one": "{{formatted}} voyage",
  "list.count.trips_many": "{{formatted}} voyages",
  "list.count.trips_other": "{{formatted}} voyages",
  "listView.calendar": "Calendrier",
  "listView.card": "Vignettes",
  "listView.label": "Affichage",
  "listView.map": "Carte",
  "listView.row": "Lignes",
  "loading": "Chargement...",
  "logo.change": "Changer",
  "logo.remove": "Supprimer",
  "logo.title": "Logo",
  "logo.upload": "Ajouter un logo",
  "map.elevationCredit": "Altitudes : IGN LiDAR HD, Mapterhorn",
  "map.fullscreen.enter": "Plein écran",
  "map.fullscreen.exit": "Quitter le plein écran",
  "map.fullscreen.open": "Carte plein écran",
  "map.fullscreen.title": "Carte",
  "map.hideTrack.hide": "Masquer la trace (H)",
  "map.hideTrack.show": "Afficher la trace (H)",
  "map.hillshade.label": "Ombrage",
  "map.locate.find": "Me localiser",
  "map.locate.unavailable": "Position indisponible",
  "map.noRoutes": "Aucun parcours disponible",
  "map.noTrackData": "Aucune donnée de tracé disponible pour ce parcours",
  "map.popup.close": "Fermer",
  "map.resetBearing": "Orienter au nord",
  "map.search.noResults": "Aucun lieu trouvé",
  "map.search.placeholder": "Rechercher un lieu…",
  "map.styles.group.raster": "Scan / Raster",
  "map.styles.group.satellite": "Satellite",
  "map.styles.group.vector": "Vectoriel",
  "map.styles.switch": "Changer le style",
  "map.styles.title": "Style de carte",
  "map.terrain3d.label": "Terrain 3D",
  "map.tooltip.climb": "Montée ({{index}}/{{total}}) : {{gain}} / {{distance}} ({{gradient}}%)",
  "map.tooltip.climbNamed": "{{name}} ({{index}}/{{total}}) : {{gain}} / {{distance}} ({{gradient}}%)",
  "map.tooltip.part": "Partie ({{index}}/{{total}}) : {{distance}} ({{gradient}}%)",
  "map.traces.title": "Traces",
  "map.zoomIn": "Zoomer",
  "map.zoomOut": "Dézoomer",
  "memberCount_one": "{{count}} membre",
  "memberCount_many": "{{count}} membres",
  "memberCount_other": "{{count}} membres",
  "moderation.block.confirm": "Bloquer",
  "moderation.block.confirmMessage": "Vous ne verrez plus ses commentaires, posts et annonces. {{name}} n'en sera pas informé. Vous pourrez le débloquer depuis votre profil.",
  "moderation.block.confirmTitle": "Bloquer {{name}} ?",
  "moderation.block.menu": "Bloquer {{name}}",
  "moderation.block.success": "Vous avez bloqué {{name}}.",
  "moderation.menu.ariaLabel": "Plus d'actions",
  "moderation.queue.actions.dismiss": "Rejeter le signalement",
  "moderation.queue.actions.remove": "Supprimer le contenu",
  "moderation.queue.author": "Par {{name}}",
  "moderation.queue.commentOn": "Commentaire sur « {{name}} »",
  "moderation.queue.contentGone": "Le contenu n'existe plus.",
  "moderation.queue.description.platform": "Tous les signalements du domaine, avec qui les a faits.",
  "moderation.queue.description.team": "Les contenus signalés par les membres de l'équipe. L'identité des personnes qui signalent n'est pas communiquée.",
  "moderation.queue.dismissed": "Signalement rejeté : le contenu reste visible.",
  "moderation.queue.empty.open.description": "Les contenus signalés apparaîtront ici en attendant votre décision.",
  "moderation.queue.empty.open.title": "Aucun signalement en attente",
  "moderation.queue.empty.resolved.description": "Les dernières décisions apparaîtront ici.",
  "moderation.queue.empty.resolved.title": "Aucun signalement traité",
  "moderation.queue.hidden": "Masqué aux membres",
  "moderation.queue.lastReported": "Dernier signalement : {{date}}",
  "moderation.queue.member": "Membre signalé : {{name}}",
  "moderation.queue.memberHint": "Pour retirer ce membre de l'équipe, passez par la page Membres (rôle Administrateur).",
  "moderation.queue.messages": "Précisions des signalements",
  "moderation.queue.removeConfirm.message": "Le contenu sera supprimé pour tout le monde, et tous ses signalements seront clos.",
  "moderation.queue.removeConfirm.title": "Supprimer ce contenu ?",
  "moderation.queue.removed": "Contenu supprimé.",
  "moderation.queue.reportCount_one": "{{count}} signalement",
  "moderation.queue.reportCount_many": "{{count}} signalements",
  "moderation.queue.reportCount_other": "{{count}} signalements",
  "moderation.queue.reporters": "Signalé par",
  "moderation.queue.tabs.open": "À traiter",
  "moderation.queue.tabs.resolved": "Traités",
  "moderation.queue.team": "Équipe : {{team}}",
  "moderation.reason.HARASSMENT": "Harcèlement",
  "moderation.reason.HATE": "Propos haineux",
  "moderation.reason.ILLEGAL": "Contenu illégal",
  "moderation.reason.INAPPROPRIATE_IMAGE": "Image inappropriée",
  "moderation.reason.OTHER": "Autre",
  "moderation.reason.SEXUAL": "Contenu sexuel",
  "moderation.reason.SPAM": "Spam ou publicité",
  "moderation.reason.VIOLENCE": "Violence ou menace",
  "moderation.report.menu": "Signaler",
  "moderation.report.messageLabel": "Précisions (facultatif)",
  "moderation.report.messagePlaceholder": "Ce qui pose problème, pour aider la modération",
  "moderation.report.reasonLabel": "Motif",
  "moderation.report.recipients": "Transmis à qui organise {{team}} et à l'équipe {{appName}}.",
  "moderation.report.submit": "Envoyer",
  "moderation.report.success": "Merci. Ce contenu est masqué pour vous.",
  "moderation.report.title.AD": "Signaler cette annonce",
  "moderation.report.title.COMMENT": "Signaler ce commentaire",
  "moderation.report.title.MEMBER": "Signaler ce membre",
  "moderation.report.title.POST": "Signaler ce post",
  "moderation.report.title.RIDE": "Signaler cette sortie",
  "moderation.report.title.ROUTE": "Signaler ce parcours",
  "moderation.report.title.TRIP": "Signaler ce voyage",
  "moderation.status.DISMISSED": "Rejeté",
  "moderation.status.OPEN": "En attente",
  "moderation.status.REMOVED": "Supprimé",
  "moderation.targetType.AD": "Annonce",
  "moderation.targetType.COMMENT": "Commentaire",
  "moderation.targetType.MEMBER": "Membre",
  "moderation.targetType.POST": "Post",
  "moderation.targetType.RIDE": "Sortie",
  "moderation.targetType.ROUTE": "Parcours",
  "moderation.targetType.TRIP": "Voyage",
  "nav.admin": "Admin",
  "nav.closeMenu": "Fermer le menu",
  "nav.colorScheme": "Changer le thème",
  "nav.explore": "Explorer",
  "nav.features": "Fonctionnalités",
  "nav.landmark.admin": "Navigation de l'administration",
  "nav.landmark.home": "Navigation principale",
  "nav.landmark.team": "Navigation de l'équipe",
  "nav.landmark.teamAdmin": "Navigation de la gestion de l'équipe",
  "nav.language": "Langue",
  "nav.openMenu": "Ouvrir le menu",
  "nav.profile": "Profil",
  "nav.routes": "Parcours",
  "nav.signIn": "Se connecter",
  "nav.signOut": "Se déconnecter",
  "nav.skipToContent": "Aller au contenu principal",
  "nav.viewProfile": "Voir mon profil",
  "noResults": "Aucun résultat ne correspond à votre recherche.",
  "noRouteSelected": "Aucun parcours sélectionné",
  "notFound.message": "Page non trouvée",
  "notFound.title": "404",
  "notifications.actions.markAllRead": "Tout marquer lu",
  "notifications.actions.seeAll": "Voir toutes les notifications",
  "notifications.actions.settings": "Réglages",
  "notifications.bell.ariaLabel": "Notifications",
  "notifications.bell.ariaLabelUnread_one": "Notifications, {{count}} non lue",
  "notifications.bell.ariaLabelUnread_many": "Notifications, {{count}} non lues",
  "notifications.bell.ariaLabelUnread_other": "Notifications, {{count}} non lues",
  "notifications.change.DATE_TIME": "Nouvelle date : {{date}}",
  "notifications.change.START_PLACE": "Nouveau point de départ",
  "notifications.channel.EMAIL": "E-mail",
  "notifications.channel.IN_APP": "Application",
  "notifications.channel.PUSH": "Push",
  "notifications.empty.description": "Les sorties, voyages et publications de vos équipes apparaîtront ici.",
  "notifications.empty.filtered.action": "Voir toutes les notifications",
  "notifications.empty.filtered.description": "Tout est lu. Enlevez le filtre pour revoir les notifications précédentes.",
  "notifications.empty.filtered.title": "Aucune notification non lue",
  "notifications.empty.title": "Aucune notification",
  "notifications.family.posts": "Publications",
  "notifications.family.rides": "Sorties",
  "notifications.family.teams": "Équipes et modération",
  "notifications.family.trips": "Voyages",
  "notifications.filter.unreadOnly": "Non lues uniquement",
  "notifications.item.group": "Groupe : {{group}}",
  "notifications.item.meta": "{{team}} · {{when}}",
  "notifications.item.startsAt": "Départ : {{date}}",
  "notifications.item.unread": "Non lue",
  "notifications.preferences.columnType": "Type",
  "notifications.preferences.description": "Les types sont regroupés par famille, dans le même ordre que dans l'application.",
  "notifications.preferences.digest.description": "Un seul e-mail par jour, à 7 h, au lieu d'un e-mail par événement. Les annulations, les modifications et les rappels partent toujours tout de suite.",
  "notifications.preferences.digest.label": "Résumé quotidien par e-mail",
  "notifications.preferences.inAppAlwaysOn": "Vous recevez toujours les notifications dans l'application. Réglez ici seulement ce qui vous interrompt : e-mails et notifications push.",
  "notifications.preferences.matrix.title": "Par type et par canal",
  "notifications.preferences.nothingToSet": "Aucune notification ne se règle sur ce site : vous les recevez toutes dans l'application.",
  "notifications.preferences.openInbox": "Ouvrir mes notifications",
  "notifications.preferences.teams.description": "Coupez une équipe pour ne plus recevoir ses annonces (sorties, voyages et articles publiés), sans la quitter, y compris dans l'application. Ce qui vous concerne personnellement vous parvient toujours : annulation ou modification d'une sortie à laquelle vous participez, rappel, réponse, invitation.",
  "notifications.preferences.teams.title": "Annonces des équipes",
  "notifications.preferences.teams.toggleAriaLabel": "Recevoir les annonces de {{team}}",
  "notifications.preferences.title": "Notifications",
  "notifications.preferences.toggleAriaLabel": "{{type}} par {{channel}}",
  "notifications.title": "Notifications",
  "notifications.type.COMMENT_ON_MY_PUBLICATION": "{{actor}} a commenté votre publication",
  "notifications.type.COMMENT_REPLY": "{{actor}} a répondu à votre commentaire",
  "notifications.type.CONTENT_REPORTED": "Nouveau signalement dans {{team}}",
  "notifications.type.POST_PUBLISHED": "{{actor}} a publié un article",
  "notifications.type.RIDE_CANCELLED": "Une sortie est annulée",
  "notifications.type.RIDE_GROUP_REMOVED": "Votre groupe a été retiré d'une sortie",
  "notifications.type.RIDE_JOINED": "{{actor}} a rejoint votre sortie",
  "notifications.type.RIDE_PUBLISHED": "{{actor}} a publié une sortie",
  "notifications.type.RIDE_REMINDER": "Rappel : votre sortie a lieu demain",
  "notifications.type.RIDE_UPDATED": "Une sortie à laquelle vous participez a changé",
  "notifications.type.TEAM_INVITATION": "{{actor}} vous invite à rejoindre {{team}}",
  "notifications.type.TRIP_CANCELLED": "Un voyage est annulé",
  "notifications.type.TRIP_PUBLISHED": "{{actor}} a publié un voyage",
  "notifications.typeLabel.COMMENT_ON_MY_PUBLICATION": "Commentaire sur votre publication",
  "notifications.typeLabel.COMMENT_REPLY": "Réponse à un commentaire",
  "notifications.typeLabel.CONTENT_REPORTED": "Contenu signalé",
  "notifications.typeLabel.POST_PUBLISHED": "Article publié",
  "notifications.typeLabel.RIDE_CANCELLED": "Sortie annulée",
  "notifications.typeLabel.RIDE_GROUP_REMOVED": "Groupe retiré d'une sortie",
  "notifications.typeLabel.RIDE_JOINED": "Inscription à votre sortie",
  "notifications.typeLabel.RIDE_PUBLISHED": "Sortie publiée",
  "notifications.typeLabel.RIDE_REMINDER": "Rappel la veille d'une sortie",
  "notifications.typeLabel.RIDE_UPDATED": "Sortie modifiée",
  "notifications.typeLabel.TEAM_INVITATION": "Invitation dans une équipe",
  "notifications.typeLabel.TRIP_CANCELLED": "Voyage annulé",
  "notifications.typeLabel.TRIP_PUBLISHED": "Voyage publié",
  "notifications.webPush.denied": "Les notifications sont bloquées pour ce site dans les réglages de votre navigateur.",
  "notifications.webPush.disable": "Désactiver",
  "notifications.webPush.disabled": "Recevez les notifications « Push » sur ce navigateur.",
  "notifications.webPush.enable": "Activer",
  "notifications.webPush.enabled": "Ce navigateur reçoit vos notifications « Push ».",
  "notifications.webPush.failed": "L'activation n'a pas abouti. Réessayez plus tard.",
  "notifications.webPush.needsInstall": "Sur iPhone et iPad, les notifications ne sont possibles qu'une fois le site installé sur l'écran d'accueil.",
  "notifications.webPush.title": "Sur cet appareil",
  "pagination.firstPage": "Première page",
  "pagination.goToPage": "Aller à la page {{page}}",
  "pagination.label": "Pagination",
  "pagination.lastPage": "Dernière page",
  "pagination.nextPage": "Page suivante",
  "pagination.outOfRange.description": "La liste s'arrête avant cette page.",
  "pagination.outOfRange.firstPage": "Revenir à la première page",
  "pagination.outOfRange.title": "Cette page n'existe pas",
  "pagination.page": "Page {{current}} sur {{total}}",
  "pagination.previousPage": "Page précédente",
  "participantCount_one": "{{count}} personne",
  "participantCount_many": "{{count}} personnes",
  "participantCount_other": "{{count}} personnes",
  "participants.empty": "Aucune inscription pour le moment.",
  "participants.loadError": "La liste des inscriptions n'a pas pu être chargée. Réessayez.",
  "participants.noMatch": "Personne ne correspond à « {{search}} ».",
  "participants.noMatchGeneric": "Personne ne correspond à votre recherche.",
  "participants.searchByName": "Rechercher par nom…",
  "participants.searchPlaceholder": "Rechercher une personne…",
  "participants.shownOf": "{{from}}–{{to}} sur {{total}}",
  "passkeys.add": "Ajouter une clé d'accès",
  "passkeys.delete": "Supprimer cette clé d'accès",
  "passkeys.deleteConfirm.confirm": "Supprimer",
  "passkeys.deleteConfirm.message": "Cette clé d'accès ne pourra plus être utilisée pour vous connecter.",
  "passkeys.deleteConfirm.title": "Supprimer la clé d'accès ?",
  "passkeys.description": "Connectez-vous avec votre empreinte, votre visage ou le code de votre appareil, sans code par e-mail.",
  "passkeys.empty": "Aucune clé d'accès enregistrée. Ajoutez-en une pour vous connecter plus vite, en toute sécurité.",
  "passkeys.errors.cancelled": "L'enregistrement a été annulé.",
  "passkeys.errors.registrationFailed": "L'enregistrement de la clé d'accès a échoué.",
  "passkeys.lastUsed": "Dernière utilisation : {{date}}",
  "passkeys.never": "jamais",
  "passkeys.noPlatformAuthenticator": "Votre appareil ne dispose pas d'authentificateur intégré (Touch ID, Face ID, Windows Hello). Vous pouvez utiliser une clé de sécurité externe.",
  "passkeys.notSupported": "Les clés d'accès ne sont pas prises en charge par votre navigateur.",
  "passkeys.register.confirm": "Enregistrer",
  "passkeys.register.description": "Votre navigateur va vous demander votre empreinte, votre visage ou le code de votre appareil pour créer une clé d'accès.",
  "passkeys.register.deviceName": "Nom de l'appareil (optionnel)",
  "passkeys.register.deviceNamePlaceholder": "Ex: MacBook Pro, iPhone...",
  "passkeys.register.title": "Ajouter une clé d'accès",
  "passkeys.title": "Clés d'accès",
  "passkeys.unnamedDevice": "Appareil sans nom",
  "places.add": "Ajouter un lieu",
  "places.delete": "Supprimer le lieu",
  "places.deleteConfirm.confirm": "Supprimer",
  "places.deleteConfirm.message": "Voulez-vous vraiment supprimer ce lieu ? Cette action est irréversible.",
  "places.deleteConfirm.title": "Supprimer le lieu",
  "places.empty": "Aucun lieu défini. Ajoutez des lieux pour les départs/arrivées de sorties.",
  "places.form.address.label": "Adresse",
  "places.form.address.placeholder": "Entrez l'adresse (optionnel)",
  "places.form.create": "Ajouter",
  "places.form.editTitle": "Modifier le lieu",
  "places.form.endPlace": "Peut servir d'arrivée",
  "places.form.link.label": "Lien",
  "places.form.link.placeholder": "https://maps.google.com/...",
  "places.form.name.label": "Nom",
  "places.form.name.placeholder": "Entrez le nom du lieu",
  "places.form.startPlace": "Peut servir de départ",
  "places.noResults": "Aucun lieu trouvé",
  "places.search.label": "Rechercher",
  "places.search.placeholder": "Rechercher par nom ou adresse...",
  "places.title": "Lieux",
  "places.viewLink": "Voir sur la carte",
  "planner.calculating": "Calcul de l'itinéraire...",
  "planner.clear": "Effacer",
  "planner.cleared": "Tracé effacé",
  "planner.cleared.undo": "Annuler",
  "planner.colorBy.grade": "Pente",
  "planner.colorBy.label": "Colorer le profil et le tracé selon",
  "planner.colorBy.surface": "Revêtement",
  "planner.direct.toggle": "Ligne droite",
  "planner.direct.toggle.mouse": "Ligne droite (ou {{shortcut}})",
  "planner.directWarning": "Ce tracé comporte {{total}} en ligne droite (pointillés), dont un tronçon de {{longest}} : il ne suit aucune route. Vérifiez qu'il est praticable.",
  "planner.done": "Terminer",
  "planner.draw": "Tracer le parcours",
  "planner.edit": "Modifier le tracé",
  "planner.elevation.collapse": "Replier le graphe d'altitude",
  "planner.elevation.expand": "Déplier le graphe d'altitude",
  "planner.elevation.title": "Profil altimétrique",
  "planner.elevation.unknown": "Altitude inconnue",
  "planner.error.cutNeedsZoom": "Zoomez jusqu'à voir un point blanc : le tracé sera coupé jusqu'à lui.",
  "planner.error.disabled": "Le tracé d'itinéraire n'est pas ouvert pour cette équipe.",
  "planner.error.disabledSite": "Le tracé d'itinéraire n'est pas ouvert sur ce site.",
  "planner.error.forbidden": "Vous ne pouvez plus tracer pour cette équipe (vos droits ou l'équipe ont changé). Rechargez la page.",
  "planner.error.noRoute": "Aucun itinéraire trouvé jusqu'à ce point. Déplacez-le, ou tracez une ligne droite ({{shortcut}}).",
  "planner.error.quota": "Le service d'itinéraires a atteint son quota mensuel. Réessayez plus tard.",
  "planner.error.routing": "Le calcul de l'itinéraire a échoué. Réessayez.",
  "planner.error.segmentTooLong": "Ces deux points sont trop éloignés pour un seul calcul. Ajoutez un point intermédiaire.",
  "planner.error.unavailable": "Le service d'itinéraires est indisponible. Réessayez dans un instant.",
  "planner.expand": "Agrandir",
  "planner.fullscreen.title": "Tracé",
  "planner.help.add": "Ajouter un point",
  "planner.help.add.mouse": "Clic sur la carte",
  "planner.help.add.touch": "Appui sur la carte",
  "planner.help.addWaypoint": "Ajouter un point de parcours",
  "planner.help.addWaypoint.mouse": "Clic droit sur le tracé",
  "planner.help.addWaypoint.touch": "Appui long sur le tracé",
  "planner.help.dashed": "Pointillés",
  "planner.help.dashed.gesture": "tronçon en ligne droite",
  "planner.help.direct": "Ligne droite",
  "planner.help.direct.apple": "{{alt}} + clic",
  "planner.help.direct.mouse": "Ctrl ou {{alt}} + clic",
  "planner.help.direct.touch": "Bouton « Ligne droite » de la barre",
  "planner.help.directMode": "Lignes droites en continu",
  "planner.help.directMode.mouse": "Bouton « Ligne droite »",
  "planner.help.editWaypoint": "Modifier un point de parcours",
  "planner.help.editWaypoint.mouse": "Clic sur l'icône",
  "planner.help.editWaypoint.touch": "Appui sur l'icône",
  "planner.help.hide": "Masquer la trace",
  "planner.help.insert": "Insérer un point",
  "planner.help.insert.mouse": "Glisser depuis le tracé",
  "planner.help.insert.touch": "Appui sur le tracé",
  "planner.help.keyboard": "Déplacer un point au clavier",
  "planner.help.keyboard.mouse": "Tab, puis flèches (Maj : plus loin) ; Échap annule",
  "planner.help.label": "Aide : gestes",
  "planner.help.menu": "Ajouter un point de parcours ou supprimer le point",
  "planner.help.menu.mouse": "Menu du point : Maj+F10",
  "planner.help.move": "Déplacer un point",
  "planner.help.move.mouse": "Glisser le point",
  "planner.help.move.touch": "Glisser le point",
  "planner.help.moveWaypoint": "Déplacer un point de parcours",
  "planner.help.moveWaypoint.mouse": "Glisser l'icône ({{alt}} : hors du tracé)",
  "planner.help.moveWaypoint.touch": "Glisser l'icône",
  "planner.help.redo": "Rétablir",
  "planner.help.remove": "Supprimer un point",
  "planner.help.remove.mouse": "Clic droit sur le point",
  "planner.help.remove.touch": "Appui long sur le point",
  "planner.help.removeAnchor": "Supprimer un point blanc",
  "planner.help.removeAnchor.mouse": "Clic droit sur le point blanc",
  "planner.help.removeAnchor.touch": "Appui long sur le point blanc",
  "planner.help.title": "Gestes du planificateur",
  "planner.help.undo": "Annuler",
  "planner.import": "Importer un fichier GPX",
  "planner.import.append": "Ajouter à la fin",
  "planner.import.choice.text": "Le tracé contient déjà des points. Que faire de « {{name}} » ?",
  "planner.import.choice.title": "Importer un fichier GPX",
  "planner.import.elevationFallback": "Une partie des altitudes n'a pas pu être relue : celles du fichier sont conservées.",
  "planner.import.failed": "Le fichier n'a pas pu être importé. Réessayez.",
  "planner.import.replace": "Remplacer le tracé",
  "planner.import.tooBig": "Ce fichier est trop volumineux : 10 Mo au plus.",
  "planner.import.tooManyTracks": "Trop de tracés distincts : 8 au plus. Fusionnez d'abord les fichiers avec l'outil Fusionner.",
  "planner.import.waypointsDropped_one": "{{count}} point de parcours du fichier n'est pas repris : 500 au plus.",
  "planner.import.waypointsDropped_many": "{{count}} points de parcours du fichier ne sont pas repris : 500 au plus.",
  "planner.import.waypointsDropped_other": "{{count}} points de parcours du fichier ne sont pas repris : 500 au plus.",
  "planner.instructions": "Cliquer pour ajouter, glisser pour déplacer, glisser depuis le tracé pour insérer, clic droit pour supprimer",
  "planner.instructions.touch": "Appuyer pour ajouter, glisser pour déplacer, appuyer sur le tracé pour insérer, appui long pour supprimer",
  "planner.marker.label": "Point {{index}} sur {{total}}",
  "planner.marker.label.end": "Arrivée, point {{index}} sur {{total}}",
  "planner.marker.label.start": "Départ, point {{index}} sur {{total}}",
  "planner.menu.addWaypoint": "Ajouter un point de parcours",
  "planner.menu.addWaypoint.full": "500 points de parcours au plus",
  "planner.menu.delete": "Supprimer le point",
  "planner.pointCount_one": "{{count}} point",
  "planner.pointCount_many": "{{count}} points",
  "planner.pointCount_other": "{{count}} points",
  "planner.preview.empty": "Aucun tracé pour le moment",
  "planner.profile.BIKE": "Vélo",
  "planner.profile.FASTBIKE": "Vélo rapide",
  "planner.profile.GRAVEL": "Gravel",
  "planner.profile.label": "Profil",
  "planner.profile.MOTORCYCLE": "Moto",
  "planner.profile.MTB": "VTT",
  "planner.profile.RUN_HIKE": "Course / Rando",
  "planner.redo": "Rétablir (Ctrl+Maj+Z)",
  "planner.redo.touch": "Rétablir",
  "planner.startHere": "Démarrer ici",
  "planner.state.readFailed": "Les points de contrôle enregistrés n'ont pas pu être relus : le tracé s'ouvre comme un import.",
  "planner.state.tooLarge": "Tracé enregistré sans ses points de contrôle : il en a trop pour être relu tel quel.",
  "planner.surface.offNetwork": "Hors réseau",
  "planner.surface.paved": "Revêtu",
  "planner.surface.summary": "Non revêtu {{unpaved}} % (routé), inconnu {{unknown}} %",
  "planner.surface.summary.offNetwork": ", hors réseau {{offNetwork}} %",
  "planner.surface.unknown": "Inconnu",
  "planner.surface.unpaved": "Non revêtu",
  "planner.tuning.custom": "Réglage différent de celui du profil",
  "planner.tuning.help": "Ces réglages orientent le choix du chemin entre vos points, tronçon par tronçon. Ils n'ont d'effet que là où deux itinéraires réels existent (une vallée ou une côte, une grande route ou une petite). Sur un tronçon court, ou si vos points imposent le passage, le tracé ne change pas. Éviter les côtes peut rallonger la sortie.",
  "planner.tuning.hills.0": "Éviter",
  "planner.tuning.hills.1": "Plutôt éviter",
  "planner.tuning.hills.2": "Intermédiaire",
  "planner.tuning.hills.3": "Plutôt indifférent",
  "planner.tuning.hills.4": "Indifférent",
  "planner.tuning.hills.label": "Côtes",
  "planner.tuning.reset": "Valeurs du profil",
  "planner.tuning.roads.0": "Pistes",
  "planner.tuning.roads.1": "Plutôt pistes",
  "planner.tuning.roads.2": "Mixte",
  "planner.tuning.roads.3": "Plutôt routes",
  "planner.tuning.roads.4": "Routes",
  "planner.tuning.roads.label": "Trafic",
  "planner.undo": "Annuler (Ctrl+Z)",
  "planner.undo.touch": "Annuler",
  "planner.waypoint.deleted": "Point de parcours supprimé",
  "planner.waypoint.form.add": "Ajouter",
  "planner.waypoint.form.counter": "{{length}} / {{max}}",
  "planner.waypoint.form.delete": "Supprimer le point de parcours",
  "planner.waypoint.form.description": "Description",
  "planner.waypoint.form.name": "Nom",
  "planner.waypoint.form.nameHint": "Certains compteurs n'en affichent que les 15 premiers caractères.",
  "planner.waypoint.form.titleAdd": "Nouveau point de parcours",
  "planner.waypoint.form.titleEdit": "Modifier le point de parcours",
  "planner.waypoint.form.type": "Type",
  "planner.waypoint.marker.label": "Point de parcours {{label}}, {{where}}",
  "planner.waypoint.offTrack.hint": "Hors tracé : à plus de 50 m du tracé. Il figure dans le fichier GPX, pas dans le FIT.",
  "planner.waypoint.snap": "Remettre sur le tracé",
  "posts.author.byline": "Par {{name}}",
  "posts.author.onBehalfOfTeam": "Publié au nom de l'équipe : seul le rôle Administrateur voit qui l'a écrit",
  "posts.create.dateTimeHint": "Date et heure de la publication",
  "posts.create.dateTimeLabel": "Date et heure",
  "posts.create.descriptionPlaceholder": "Décrivez votre publication...",
  "posts.create.namePlaceholder": "Entrez le titre de la publication",
  "posts.create.publishAtLabel": "Publication programmée",
  "posts.create.submit": "Créer la publication",
  "posts.create.title": "Nouvelle publication",
  "posts.detail.actions.cancel": "Annuler la publication",
  "posts.detail.actions.uncancel": "Réactiver",
  "posts.detail.confirmations.cancel": "Voulez-vous annuler cette publication ? Elle restera lisible, marquée « Annulé ».",
  "posts.detail.confirmations.delete": "Voulez-vous vraiment supprimer cette publication ? Cette action est irréversible.",
  "posts.detail.confirmations.uncancel": "Voulez-vous réactiver cette publication ? Elle sera à nouveau publiée.",
  "posts.detail.confirmations.unpublish": "Voulez-vous dépublier cette publication ? Elle redeviendra un brouillon.",
  "posts.detail.notFound.message": "Cette publication n'existe pas ou a été supprimée",
  "posts.detail.notFound.title": "Publication introuvable",
  "posts.detail.scheduledPublish": "Publication programmée pour le {{date}}",
  "posts.edit.title": "Modifier la publication",
  "posts.form.signedAsTeam.hint": "Le public voit la signature de l'équipe, pas votre nom. Le rôle Administrateur de l'équipe sait toujours qui a écrit.",
  "posts.form.signedAsTeam.label": "Publier au nom de {{team}}",
  "posts.notifications.created": "Publication créée avec succès",
  "posts.notifications.deleted": "Publication supprimée avec succès",
  "posts.notifications.published": "Publication mise en ligne avec succès",
  "posts.notifications.restored": "Publication restaurée avec succès",
  "posts.notifications.updated": "Publication mise à jour avec succès",
  "posts.title": "Publications",
  "precipitation": "{{precipitation}} mm",
  "precipitation_imperial": "{{precipitation}} in",
  "profile.account.dangerZone.blocked_one": "Vous êtes la seule personne à administrer cette équipe, qui compte d'autres membres :",
  "profile.account.dangerZone.blocked_many": "Vous êtes la seule personne à administrer ces équipes, qui comptent d'autres membres :",
  "profile.account.dangerZone.blocked_other": "Vous êtes la seule personne à administrer ces équipes, qui comptent d'autres membres :",
  "profile.account.dangerZone.blockedHint": "Confiez l'administration à un autre membre, ou supprimez l'équipe, puis revenez supprimer votre compte.",
  "profile.account.dangerZone.blockedMigrated_one": "Vous êtes la seule personne à administrer cette équipe venue de biketeam. Ses anciennes adresses biketeam redirigent vers elle : elle ne peut pas partir avec votre compte.",
  "profile.account.dangerZone.blockedMigrated_many": "Vous êtes la seule personne à administrer ces équipes venues de biketeam. Leurs anciennes adresses biketeam redirigent vers elles : elles ne peuvent pas partir avec votre compte.",
  "profile.account.dangerZone.blockedMigrated_other": "Vous êtes la seule personne à administrer ces équipes venues de biketeam. Leurs anciennes adresses biketeam redirigent vers elles : elles ne peuvent pas partir avec votre compte.",
  "profile.account.dangerZone.blockedMigratedHint": "Confiez l'administration à un autre de ses membres, puis revenez supprimer votre compte. Pour supprimer l'équipe elle-même, l'administration de la plateforme doit d'abord annuler sa bascule sur biketeam.",
  "profile.account.dangerZone.blockedTitle": "Vous ne pouvez pas encore supprimer votre compte",
  "profile.account.dangerZone.confirmButton": "Oui, supprimer mon compte",
  "profile.account.dangerZone.confirmMessage": "Voulez-vous vraiment continuer ? Cette action est irréversible.",
  "profile.account.dangerZone.deleteButton": "Supprimer le compte",
  "profile.account.dangerZone.deleteDescription": "Effacer votre compte et vos données personnelles. Ce que vous avez publié pour une équipe reste en ligne, attribué à « Ancien membre ».",
  "profile.account.dangerZone.impactLoading": "Vérification de vos équipes…",
  "profile.account.dangerZone.teamsDeleted_one": "Vous êtes l'unique membre de cette équipe : elle sera supprimée avec votre compte.",
  "profile.account.dangerZone.teamsDeleted_many": "Vous êtes l'unique membre de ces équipes : elles seront supprimées avec votre compte.",
  "profile.account.dangerZone.teamsDeleted_other": "Vous êtes l'unique membre de ces équipes : elles seront supprimées avec votre compte.",
  "profile.account.dangerZone.title": "Zone de danger",
  "profile.account.logoutAll": "Déconnecter tous les appareils",
  "profile.account.logoutAllDescription": "Ferme toutes vos sessions : ce navigateur, l'application mobile, et votre Karoo ou votre Garmin appairé. Utile si vous avez perdu un appareil ou oublié de vous déconnecter ailleurs.",
  "profile.account.logoutAllFailed": "La déconnexion a échoué : vos sessions sont toujours ouvertes. Réessayez.",
  "profile.account.logoutAllMessage": "Toutes vos sessions seront fermées, celle-ci comprise. Vous devrez vous reconnecter.",
  "profile.account.logoutAllTitle": "Déconnecter tous les appareils ?",
  "profile.account.photo": "Photo",
  "profile.avatar.remove": "Supprimer l'avatar",
  "profile.avatar.upload": "Ajouter un avatar",
  "profile.blockedUsers.description": "Vous ne voyez plus leurs commentaires, posts et annonces. Ces personnes n'en sont pas informées.",
  "profile.blockedUsers.empty": "Vous n'avez bloqué personne.",
  "profile.blockedUsers.title": "Personnes bloquées",
  "profile.blockedUsers.unblock": "Débloquer",
  "profile.blockedUsers.unblocked": "{{name}} est débloqué.",
  "profile.contactable.description": "Les membres peuvent vous écrire au sujet de vos annonces, par un relais : votre adresse e-mail n'est jamais publiée. Décoché, vos annonces restent visibles mais ne sont plus joignables.",
  "profile.contactable.label": "Accepter les messages des membres",
  "profile.dataExport.description": "Demandez une copie de vos données personnelles. Nous préparons une archive ZIP et vous envoyons un lien de téléchargement par e-mail.",
  "profile.dataExport.expired": "Votre dernier export a expiré. Vous pouvez en demander un nouveau.",
  "profile.dataExport.failed": "La préparation de votre dernier export a échoué. Vous pouvez réessayer.",
  "profile.dataExport.inProgress": "Préparation en cours",
  "profile.dataExport.ready": "Votre export est prêt. Le lien envoyé par e-mail est valable jusqu'au {{date}}.",
  "profile.dataExport.requestButton": "Demander mes données",
  "profile.dataExport.requested": "Export demandé. Vous recevrez un e-mail dès qu'il sera prêt.",
  "profile.dataExport.title": "Mes données",
  "profile.devices.howTo.link": "Voir les applications",
  "profile.devices.howTo.text": "Installez l'application Pédalons sur votre Karoo ou votre Garmin, puis saisissez sur ce site le code qu'elle affiche.",
  "profile.devices.howTo.title": "Comment appairer",
  "profile.errorReports.description": "En cas d'erreur inattendue, l'application envoie un rapport technique (page, version, journal récent) pour nous aider à la corriger. Réglage propre à ce navigateur.",
  "profile.errorReports.label": "Rapports d'erreur",
  "profile.form.displayName.label": "Nom affiché",
  "profile.form.email.label": "Adresse e-mail",
  "profile.form.email.readOnly": "Elle sert à vous connecter et ne se change pas ici.",
  "profile.help.version": "Version",
  "profile.nav.account": "Mon compte",
  "profile.nav.devices": "Appareils et services",
  "profile.nav.group.security": "Sécurité et confidentialité",
  "profile.nav.group.settings": "Réglages",
  "profile.nav.help": "Aide et à propos",
  "profile.nav.notifications": "Notifications",
  "profile.nav.overview": "Vue d'ensemble",
  "profile.nav.preferences": "Préférences",
  "profile.nav.privacy": "Confidentialité",
  "profile.nav.security": "Connexion et sécurité",
  "profile.nav.teams": "Mes équipes",
  "profile.notifications.accountDeleted": "Compte supprimé avec succès",
  "profile.notifications.avatarDeleted": "Avatar supprimé avec succès",
  "profile.notifications.avatarUpdated": "Avatar mis à jour avec succès",
  "profile.notifications.updated": "Profil mis à jour avec succès",
  "profile.preferences.language.label": "Langue",
  "profile.preferences.theme.DARK": "Sombre",
  "profile.preferences.theme.label": "Thème",
  "profile.preferences.theme.LIGHT": "Clair",
  "profile.preferences.theme.SYSTEM": "Système",
  "profile.preferences.timezone.label": "Fuseau horaire",
  "profile.preferences.unitSystem.imperial": "Impérial (mi, ft)",
  "profile.preferences.unitSystem.label": "Système d'unités",
  "profile.preferences.unitSystem.metric": "Métrique (km, m)",
  "profile.security.deleteHint": "Pour supprimer votre compte, ouvrez <link>Mon compte</link>.",
  "profile.security.sessions.title": "Sessions",
  "profile.status.account": "Photo, nom affiché, adresse e-mail",
  "profile.status.blocked_one": "{{count}} personne bloquée",
  "profile.status.blocked_many": "{{count}} personnes bloquées",
  "profile.status.blocked_other": "{{count}} personnes bloquées",
  "profile.status.contactable": "Joignable par les membres",
  "profile.status.devicePaired_one": "{{count}} {{device}} appairé",
  "profile.status.devicePaired_many": "{{count}} {{device}} appairés",
  "profile.status.devicePaired_other": "{{count}} {{device}} appairés",
  "profile.status.help": "Applications, aide, signaler un problème",
  "profile.status.noDevice": "Aucun service ni appareil",
  "profile.status.noPasskey": "Aucune clé d'accès",
  "profile.status.notContactable": "Non joignable par les membres",
  "profile.status.notifications.digest": "résumé quotidien activé",
  "profile.status.notifications.email": "Par e-mail",
  "profile.status.notifications.emailAndPush": "E-mail et push",
  "profile.status.notifications.inAppOnly": "Dans l'application seulement",
  "profile.status.notifications.push": "Push",
  "profile.status.passkeys_one": "{{count}} clé d'accès",
  "profile.status.passkeys_many": "{{count}} clés d'accès",
  "profile.status.passkeys_other": "{{count}} clés d'accès",
  "profile.status.serviceAutoSync": "{{service}} connecté, envoi automatique",
  "profile.status.serviceConnected": "{{service}} connecté",
  "profile.status.theme.DARK": "Thème sombre",
  "profile.status.theme.LIGHT": "Thème clair",
  "profile.status.theme.SYSTEM": "Thème système",
  "profile.status.unit.IMPERIAL": "Impérial",
  "profile.status.unit.METRIC": "Métrique",
  "profile.teams.empty": "Vous n'êtes membre d'aucune équipe.",
  "profile.title": "Profil",
  "publications.registered": "J'y vais",
  "publications.scope.all": "Tout",
  "publications.scope.label": "Portée du fil",
  "publications.scope.me": "Je participe",
  "publications.scope.upcoming": "À venir",
  "publicationType.post": "Publication",
  "publicationType.ride": "Sortie",
  "publicationType.trip": "Voyage",
  "query.error.message": "Les données n'ont pas pu être chargées. Vérifiez votre connexion puis réessayez.",
  "query.error.title": "Chargement impossible",
  "query.notFound.message": "Cette page n'existe pas ou a été supprimée.",
  "query.notFound.title": "Introuvable",
  "rides.create.button": "Créer la sortie",
  "rides.create.form.description.placeholder": "Décrivez la sortie, les points forts du parcours, les arrêts café...",
  "rides.create.form.endPlace.label": "Lieu d'arrivée",
  "rides.create.form.endPlace.placeholder": "Rechercher un lieu d'arrivée...",
  "rides.create.form.groups.defaultName": "Groupe {{number}}",
  "rides.create.form.groups.empty": "Aucun groupe défini. Ajoutez au moins un groupe.",
  "rides.create.form.groups.hint": "Créez différents groupes pour différents niveaux ou vitesses",
  "rides.create.form.groups.label": "Groupes",
  "rides.create.form.groups.leader.clear": "Retirer",
  "rides.create.form.groups.leader.label": "Capitaine",
  "rides.create.form.groups.leader.placeholder": "Rechercher un membre de l'équipe...",
  "rides.create.form.groups.leader.unknown": "Nom inconnu",
  "rides.create.form.groups.maxParticipants.placeholder": "Taille max",
  "rides.create.form.groups.name.placeholder": "Nom du groupe",
  "rides.create.form.groups.remove": "Supprimer",
  "rides.create.form.groups.removeRegistered.confirm": "Retirer le groupe",
  "rides.create.form.groups.removeRegistered.message_one": "Ce groupe compte {{count}} inscription. À l'enregistrement, elle sera supprimée et la personne prévenue.",
  "rides.create.form.groups.removeRegistered.message_many": "Ce groupe compte {{count}} inscriptions. À l'enregistrement, elles seront supprimées et les personnes prévenues.",
  "rides.create.form.groups.removeRegistered.message_other": "Ce groupe compte {{count}} inscriptions. À l'enregistrement, elles seront supprimées et les personnes prévenues.",
  "rides.create.form.groups.removeRegistered.title": "Retirer un groupe avec des inscriptions",
  "rides.create.form.groups.route.label": "Parcours du groupe",
  "rides.create.form.groups.speed.placeholder": "Vitesse ({{unit}})",
  "rides.create.form.publishAt.label": "Publication programmée",
  "rides.create.form.route.clear": "Retirer",
  "rides.create.form.route.hint": "Optionnel : associez un parcours global à cette sortie",
  "rides.create.form.route.label": "Parcours global",
  "rides.create.form.route.select": "Sélectionner un parcours",
  "rides.create.form.route.selectForGroup": "Sélectionner un parcours pour le groupe",
  "rides.create.form.route.selectForRide": "Sélectionner un parcours pour la sortie",
  "rides.create.form.startPlace.label": "Lieu de départ",
  "rides.create.form.startPlace.placeholder": "Rechercher un lieu de départ...",
  "rides.create.form.title.label": "Titre de la sortie",
  "rides.create.form.title.placeholder": "ex. Sortie du dimanche matin",
  "rides.create.loadTemplate": "Charger un modèle",
  "rides.create.subtitle": "Planifiez une sortie pour {{teamName}}",
  "rides.create.title": "Créer une sortie",
  "rides.detail.actions.cancel": "Annuler la sortie",
  "rides.detail.actions.uncancel": "Restaurer la sortie",
  "rides.detail.confirmations.cancel": "Voulez-vous vraiment annuler cette sortie ?",
  "rides.detail.confirmations.delete": "Voulez-vous vraiment supprimer cette sortie ? Cette action est irréversible.",
  "rides.detail.confirmations.uncancel": "Voulez-vous vraiment restaurer cette sortie ? Elle repassera en brouillon.",
  "rides.detail.confirmations.unpublish": "Voulez-vous vraiment dépublier cette sortie ? Elle repassera en brouillon.",
  "rides.detail.finished": "Terminée",
  "rides.detail.groups.actionFailed": "L'inscription n'a pas pu être enregistrée. Réessayez.",
  "rides.detail.groups.empty": "Aucun groupe défini pour cette sortie.",
  "rides.detail.groups.emptyTitle": "Aucun groupe",
  "rides.detail.groups.full": "Complet",
  "rides.detail.groups.join": "Rejoindre",
  "rides.detail.groups.joined": "J'y vais",
  "rides.detail.groups.leader": "Capitaine",
  "rides.detail.groups.leave": "Quitter",
  "rides.detail.groups.others": "Autres groupes",
  "rides.detail.groups.participants_one": "{{current}}/{{count}} personne",
  "rides.detail.groups.participants_many": "{{current}}/{{count}} personnes",
  "rides.detail.groups.participants_other": "{{current}}/{{count}} personnes",
  "rides.detail.groups.participantsNoMax_one": "{{count}} personne",
  "rides.detail.groups.participantsNoMax_many": "{{count}} personnes",
  "rides.detail.groups.participantsNoMax_other": "{{count}} personnes",
  "rides.detail.groups.route.downloadFit": "FIT",
  "rides.detail.groups.route.downloadGpx": "GPX",
  "rides.detail.groups.route.view": "Voir le parcours",
  "rides.detail.groups.soloLabel": "Groupe",
  "rides.detail.groups.title": "Groupes",
  "rides.detail.groups.viewAll": "Voir tout",
  "rides.detail.groups.viewParticipants": "Voir toutes les personnes inscrites",
  "rides.detail.mainRoute": "Parcours principal",
  "rides.detail.nonMember.message": "Rejoignez cette équipe pour participer aux sorties.",
  "rides.detail.nonMember.viewTeam": "Voir l'équipe",
  "rides.detail.notAuthenticated.message": "Connectez-vous et rejoignez cette équipe pour participer aux sorties.",
  "rides.detail.notAuthenticated.signIn": "Se connecter",
  "rides.detail.notFound.backToRides": "Retour aux sorties",
  "rides.detail.notFound.message": "La sortie que vous recherchez n'existe pas.",
  "rides.detail.notFound.title": "Sortie non trouvée",
  "rides.detail.scheduledPublish": "Publication programmée pour le {{date}}",
  "rides.edit.subtitle": "Modifier les détails de la sortie pour {{teamName}}",
  "rides.edit.title": "Modifier la sortie",
  "rides.group.backToRide": "Retour à la sortie",
  "rides.group.header": "{{ride}} · {{date}}, départ {{time}}",
  "rides.group.mapTitle": "{{ride}} · Groupe {{name}}",
  "rides.group.notFound.description": "Il a peut-être été retiré de la sortie. Les autres groupes vous attendent sur la page de la sortie.",
  "rides.group.notFound.title": "Ce groupe n'existe plus",
  "rides.group.option": "{{name}} · {{current}}/{{max}}",
  "rides.group.optionNoMax": "{{name}} · {{current}}",
  "rides.group.participantsTitle": "Personnes inscrites",
  "rides.group.placesLeft_zero": "Aucune place restante",
  "rides.group.placesLeft_one": "{{count}} place restante",
  "rides.group.placesLeft_many": "{{count}} places restantes",
  "rides.group.placesLeft_other": "{{count}} places restantes",
  "rides.group.registeredElsewhere": "Votre inscription est dans le groupe {{group}}.",
  "rides.group.routeTitle": "Parcours du groupe",
  "rides.group.selector": "Groupes de la sortie",
  "rides.group.signInToJoin": "Connectez-vous pour rejoindre ce groupe.",
  "rides.group.stats.after": "après la sortie",
  "rides.group.stats.arrival": "Arrivée estimée {{time}}",
  "rides.group.stats.before": "avant la sortie",
  "rides.group.stats.departure": "Départ",
  "rides.group.stats.distance": "Distance",
  "rides.group.stats.elevation": "Dénivelé positif",
  "rides.group.stats.pace": "Allure moyenne",
  "rides.group.stats.with": "avec la sortie",
  "rides.group.title": "Groupe {{name}}",
  "rides.group.view": "Voir le groupe",
  "rides.group.weatherTitle": "Météo du parcours",
  "rides.notifications.cancelled": "Sortie annulée avec succès",
  "rides.notifications.created": "Sortie créée avec succès",
  "rides.notifications.deleted": "Sortie supprimée avec succès",
  "rides.notifications.joined": "Inscription à la sortie confirmée",
  "rides.notifications.left": "Désinscription de la sortie confirmée",
  "rides.notifications.published": "Sortie publiée avec succès",
  "rides.notifications.restored": "Sortie restaurée avec succès",
  "rides.notifications.uncancelled": "Sortie restaurée avec succès",
  "rides.notifications.unpublished": "Sortie dépubliée avec succès",
  "rides.notifications.updated": "Sortie mise à jour avec succès",
  "rides.weather.attribution": "Prévisions",
  "rides.weather.checkpoints.finish": "Arrivée · {{distance}}",
  "rides.weather.checkpoints.label": "Prévisions le long du parcours",
  "rides.weather.checkpoints.noForecast": "Pas encore de prévision",
  "rides.weather.checkpoints.start": "Départ",
  "rides.weather.compass.E": "E",
  "rides.weather.compass.N": "N",
  "rides.weather.compass.NE": "NE",
  "rides.weather.compass.NW": "NO",
  "rides.weather.compass.S": "S",
  "rides.weather.compass.SE": "SE",
  "rides.weather.compass.SW": "SO",
  "rides.weather.compass.W": "O",
  "rides.weather.condition.CLEAR": "Ciel dégagé",
  "rides.weather.condition.DRIZZLE": "Bruine",
  "rides.weather.condition.FOG": "Brouillard",
  "rides.weather.condition.FREEZING_RAIN": "Pluie verglaçante",
  "rides.weather.condition.HEAVY_RAIN": "Forte pluie",
  "rides.weather.condition.MOSTLY_CLEAR": "Plutôt dégagé",
  "rides.weather.condition.OVERCAST": "Couvert",
  "rides.weather.condition.PARTLY_CLOUDY": "Partiellement nuageux",
  "rides.weather.condition.RAIN": "Pluie",
  "rides.weather.condition.SHOWERS": "Averses",
  "rides.weather.condition.SNOW": "Neige",
  "rides.weather.condition.THUNDERSTORM": "Orage",
  "rides.weather.condition.unknown": "Météo",
  "rides.weather.departure.title": "Au départ · {{time}}",
  "rides.weather.departure.unavailable": "Pas encore de prévision au point de départ.",
  "rides.weather.departureTitle": "Météo au départ",
  "rides.weather.exposure.segment": "{{relativeWind}} de {{from}} à {{to}}",
  "rides.weather.exposure.title": "Exposition au vent",
  "rides.weather.exposure.total": "{{relativeWind}} {{distance}}",
  "rides.weather.feelsLike": "ressenti {{temperature}}",
  "rides.weather.groupLine.conditions": "{{temperature}} · {{condition}}",
  "rides.weather.groupLine.label": "Météo du groupe au départ",
  "rides.weather.groupLine.rain": "{{condition}} {{probability}} % vers {{time}}",
  "rides.weather.leg.noRoute": "Ce groupe n'a pas de parcours : la météo n'est connue qu'au départ.",
  "rides.weather.leg.prevailingWind": "Vent dominant : {{wind}}",
  "rides.weather.leg.schedule": "Départ {{start}} → arrivée vers {{arrival}} · {{distance}}",
  "rides.weather.leg.speed": "Heures de passage estimées à {{speed}}",
  "rides.weather.leg.speedDefault": "Heures de passage estimées à {{speed}}, vitesse par défaut (le groupe n'en indique pas)",
  "rides.weather.leg.unavailable": "Les prévisions le long du parcours ne sont pas encore disponibles.",
  "rides.weather.map.checkpointTitle": "{{place}} · {{time}}",
  "rides.weather.map.inContext": "{{name}}, {{day}} — {{text}}",
  "rides.weather.map.legend": "Vent sur le tracé :",
  "rides.weather.map.precipitationAmount": "Pluie {{amount}}",
  "rides.weather.map.windDetail": "{{wind}} · {{relativeWind}}",
  "rides.weather.noLocation": "Ajoutez un lieu de départ ou un parcours pour afficher la météo de la sortie.",
  "rides.weather.notYetAvailable": "La météo sera disponible à partir du {{date}}.",
  "rides.weather.notYetAvailableNoDate": "La météo sera disponible sept jours avant le départ.",
  "rides.weather.percent": "{{value}} %",
  "rides.weather.precipitation": "Pluie {{probability}} %",
  "rides.weather.precipitationLabel": "Probabilité de pluie",
  "rides.weather.precipitationWithAmount": "Pluie {{probability}} % · {{amount}}",
  "rides.weather.rain.alert": "{{condition}} probable ({{probability}} %) vers {{time}}",
  "rides.weather.rain.alertAt": "{{condition}} probable ({{probability}} %) vers {{time}}, à {{distance}}",
  "rides.weather.rain.dry": "Pas de pluie attendue sur le parcours",
  "rides.weather.rain.probability": "Probabilité de pluie : {{probability}} %",
  "rides.weather.relativeWind.CROSS": "Vent de travers",
  "rides.weather.relativeWind.HEAD": "Vent de face",
  "rides.weather.relativeWind.TAIL": "Vent dans le dos",
  "rides.weather.relativeWindShort.CROSS": "Travers",
  "rides.weather.relativeWindShort.HEAD": "Face",
  "rides.weather.relativeWindShort.TAIL": "Dos",
  "rides.weather.relativeWindUnknown": "Vent inconnu",
  "rides.weather.retry": "Réessayer",
  "rides.weather.route.detail.announce": "{{place}}, {{time}}",
  "rides.weather.route.detail.finish": "Arrivée · {{distance}}",
  "rides.weather.route.detail.gusts": "rafales {{gusts}}",
  "rides.weather.route.detail.phase": "Tronçon",
  "rides.weather.route.detail.phaseRange": "{{relativeWind}} du {{from}} au {{to}}",
  "rides.weather.route.detail.rain": "Pluie",
  "rides.weather.route.detail.rainAmount": "{{probability}} % · {{amount}}",
  "rides.weather.route.detail.rainChance": "{{probability}} %",
  "rides.weather.route.detail.sector": "secteur {{compass}}",
  "rides.weather.route.detail.temperature": "Température",
  "rides.weather.route.detail.wind": "Vent",
  "rides.weather.route.duration.hours": "{{hours}} h {{minutes}}",
  "rides.weather.route.duration.minutes": "{{minutes}} min",
  "rides.weather.route.marker": "km {{distance}}",
  "rides.weather.route.marker_imperial": "mi {{distance}}",
  "rides.weather.route.phaseList.gusts": "raf. {{gusts}}",
  "rides.weather.route.phaseList.heading": "{{relativeWind}} · {{range}}",
  "rides.weather.route.phaseList.noPoint": "Aucun point de prévision sur ce tronçon, plus court que l'écart entre deux points.",
  "rides.weather.route.phaseList.rain": "pluie ≤ {{probability}} %",
  "rides.weather.route.phaseList.title": "Par tronçon",
  "rides.weather.route.phaseList.windRange": "{{min}}–{{max}}",
  "rides.weather.route.phaseList.windRow": "{{relativeWind}} {{speed}} ({{gusts}})",
  "rides.weather.route.phaseList.windRowNoGusts": "{{relativeWind}} {{speed}}",
  "rides.weather.route.phases.block": "{{relativeWind}} du {{from}} au {{to}}, {{times}}",
  "rides.weather.route.phases.range": "{{from}}–{{to}}",
  "rides.weather.route.phases.times": "{{from}}–{{to}}",
  "rides.weather.route.phases.title": "Le vent, tronçon par tronçon",
  "rides.weather.route.phases.total": "{{relativeWind}} {{distance}}",
  "rides.weather.route.timeline.column": "{{time}}, {{place}} : {{summary}}",
  "rides.weather.route.timeline.empty": "—",
  "rides.weather.route.timeline.label": "Prévisions à chaque passage",
  "rides.weather.route.timeline.rows.gusts": "Rafales",
  "rides.weather.route.timeline.rows.phases": "Tronçons",
  "rides.weather.route.timeline.rows.rain": "Pluie",
  "rides.weather.route.timeline.rows.speedUnit": "km/h",
  "rides.weather.route.timeline.rows.speedUnit_imperial": "mph",
  "rides.weather.route.timeline.rows.temperature": "Temp.",
  "rides.weather.route.timeline.rows.time": "Heure",
  "rides.weather.route.timeline.rows.wind": "Vent",
  "rides.weather.route.timeline.slider": "Glisser pour choisir un passage",
  "rides.weather.route.timeline.spacing": "un point tous les {{distance}}",
  "rides.weather.route.timeline.speed": "Passages estimés à {{speed}}",
  "rides.weather.route.timeline.speedDefault": "Passages estimés à {{speed}}, vitesse par défaut (le groupe n'en indique pas)",
  "rides.weather.route.timeline.summary": "{{temperature}}, {{condition}}, pluie {{rain}} %, {{wind}}",
  "rides.weather.route.timeline.summaryNoRain": "{{temperature}}, {{condition}}, {{wind}}",
  "rides.weather.route.timeline.title": "Heure par heure, à votre passage",
  "rides.weather.route.verdict.day.afterSunset": "Arrivée {{duration}} après le coucher",
  "rides.weather.route.verdict.day.arrival": "Arrivée estimée {{time}}.",
  "rides.weather.route.verdict.day.beforeSunrise": "Départ avant le lever du soleil.",
  "rides.weather.route.verdict.day.label": "Jour",
  "rides.weather.route.verdict.day.margin": "{{duration}} de marge",
  "rides.weather.route.verdict.day.night": "Arrivée de nuit",
  "rides.weather.route.verdict.day.sun": "Lever {{sunrise}}, coucher {{sunset}}.",
  "rides.weather.route.verdict.day.sunset": "Coucher {{sunset}}.",
  "rides.weather.route.verdict.rain.alert": "Dès {{time}} ({{distance}}), {{probability}} %.",
  "rides.weather.route.verdict.rain.alertNoDistance": "Dès {{time}}, {{probability}} %.",
  "rides.weather.route.verdict.rain.dry": "Sec",
  "rides.weather.route.verdict.rain.label": "Pluie",
  "rides.weather.route.verdict.rain.none": "0 % de risque de pluie tout le long.",
  "rides.weather.route.verdict.rain.peak": "{{probability}} % au plus, vers {{time}} ({{distance}}).",
  "rides.weather.route.verdict.rain.unknown": "Cette prévision ne donne pas de probabilité de pluie.",
  "rides.weather.route.verdict.rain.window": "{{probability}} % au plus, de {{from}} à {{to}} ({{fromDistance}} à {{toDistance}}).",
  "rides.weather.route.verdict.temperature.label": "Températures",
  "rides.weather.route.verdict.temperature.range": "{{min}} → {{max}}",
  "rides.weather.route.verdict.temperature.start": "{{temperature}} au départ, ressenti {{felt}}.",
  "rides.weather.route.verdict.temperature.warmest": "Le plus chaud vers {{time}}.",
  "rides.weather.route.verdict.wind.headOver": "De face sur {{distance}}.",
  "rides.weather.route.verdict.wind.headUntil": "De face par moments jusqu'au {{distance}}.",
  "rides.weather.route.verdict.wind.headUntilGusts": "De face par moments jusqu'au {{distance}} (rafales {{gusts}}).",
  "rides.weather.route.verdict.wind.label": "Vent",
  "rides.weather.route.verdict.wind.lower.CROSS": "travers",
  "rides.weather.route.verdict.wind.lower.HEAD": "face",
  "rides.weather.route.verdict.wind.lower.TAIL": "dos",
  "rides.weather.route.verdict.wind.mostly.CROSS": "Surtout de travers",
  "rides.weather.route.verdict.wind.mostly.HEAD": "Surtout de face",
  "rides.weather.route.verdict.wind.mostly.TAIL": "Surtout dans le dos",
  "rides.weather.route.verdict.wind.prevailing": "Vent dominant : {{wind}}.",
  "rides.weather.route.verdict.wind.tailAfter": "Dans le dos après le {{distance}}.",
  "rides.weather.route.verdict.wind.tailOver": "Dans le dos sur {{distance}}.",
  "rides.weather.route.verdict.wind.then": "{{first}}, puis {{second}}",
  "rides.weather.route.verdicts.label": "L'essentiel du parcours",
  "rides.weather.stale": "Prévision ancienne",
  "rides.weather.summary.availableFrom": "Météo disponible à partir du {{date}}",
  "rides.weather.summary.rainAlert": "{{condition}} dès {{time}}",
  "rides.weather.summary.range": "{{min}} → {{max}}",
  "rides.weather.sunrise": "Lever du soleil",
  "rides.weather.sunset": "Coucher du soleil",
  "rides.weather.title": "Météo",
  "rides.weather.unavailable": "La météo n'est pas disponible pour le moment.",
  "rides.weather.updatedAt": "Mise à jour à {{time}}",
  "rides.weather.updatedOn": "Mise à jour le {{date}} à {{time}}",
  "rides.weather.wind.fromCompass": "{{compass}} {{speed}}",
  "rides.weather.wind.gustsShort": "rafales {{gusts}}",
  "rides.weather.wind.relativeAria": "{{relativeWind}}, {{speed}}",
  "rides.weather.wind.withGusts": "{{wind}}, rafales {{gusts}}",
  "rideTemplates.buttons.delete": "Supprimer le modèle",
  "rideTemplates.confirmations.delete": "Voulez-vous vraiment supprimer le modèle \"{{name}}\" ?",
  "rideTemplates.confirmations.deleteTitle": "Supprimer le modèle",
  "rideTemplates.create.button": "Créer le modèle",
  "rideTemplates.create.subtitle": "Définissez un modèle réutilisable pour {{teamName}}",
  "rideTemplates.create.title": "Créer un modèle",
  "rideTemplates.edit.subtitle": "Modifier les détails du modèle",
  "rideTemplates.edit.title": "Modifier le modèle",
  "rideTemplates.form.groups.defaultName": "Groupe {{number}}",
  "rideTemplates.form.name.label": "Nom du modèle",
  "rideTemplates.form.name.placeholder": "ex. Sortie du dimanche matin",
  "rideTemplates.form.nextNumber.description": "Les sorties créées depuis ce modèle sont titrées « Nom #42 », et le numéro augmente de un à chacune. Laisser vide pour ne pas numéroter.",
  "rideTemplates.form.nextNumber.label": "Numéro de la prochaine sortie",
  "rideTemplates.form.nextNumber.placeholder": "ex. 42",
  "rideTemplates.list.empty.admin": "Créez des modèles pour accélérer la création de sorties.",
  "rideTemplates.list.empty.member": "Aucun modèle n'a encore été créé.",
  "rideTemplates.list.empty.title": "Aucun modèle",
  "rideTemplates.list.noResults": "Aucun modèle trouvé",
  "rideTemplates.list.search.label": "Rechercher",
  "rideTemplates.list.search.placeholder": "Rechercher par nom...",
  "rideTemplates.list.title": "Modèles de sortie",
  "rideTemplates.notifications.created": "Modèle créé avec succès",
  "rideTemplates.notifications.deleted": "Modèle supprimé avec succès",
  "rideTemplates.notifications.updated": "Modèle mis à jour avec succès",
  "rideTemplates.picker.search": "Rechercher un modèle...",
  "rideTemplates.picker.title": "Choisir un modèle",
  "roles.ADMIN": "Administrateur",
  "roles.MEMBER": "Membre",
  "roles.ORGANIZER": "Organisateur",
  "routes.climbCategory.CAT1": "1ère Catégorie",
  "routes.climbCategory.CAT2": "2ème Catégorie",
  "routes.climbCategory.CAT3": "3ème Catégorie",
  "routes.climbCategory.CAT4": "4ème Catégorie",
  "routes.climbCategory.HC": "Hors Catégorie",
  "routes.create.form.gpxFile": "Fichier GPX",
  "routes.create.form.gpxFileHint": "Format .gpx uniquement",
  "routes.create.form.name": "Nom du parcours",
  "routes.create.form.nameSuggestions": "Noms trouvés :",
  "routes.create.form.plannerLabel": "Tracer le parcours sur la carte",
  "routes.create.form.pointCount_one": "Tracé de {{count}} point",
  "routes.create.form.pointCount_many": "Tracé de {{count}} points",
  "routes.create.form.pointCount_other": "Tracé de {{count}} points",
  "routes.create.form.sourceMode": "Source du parcours",
  "routes.create.form.sourceModeGpx": "Importer un fichier GPX",
  "routes.create.form.sourceModePlanner": "Tracer sur la carte",
  "routes.create.form.surfaceType": "Type de revêtement",
  "routes.create.submit": "Créer le parcours",
  "routes.create.subtitle": "Importez un fichier GPX ou tracez un parcours sur la carte",
  "routes.create.title": "Créer un nouveau parcours",
  "routes.create.validation.fileRequired": "Un fichier GPX est requis",
  "routes.create.validation.invalidFileType": "Le fichier doit être au format .gpx",
  "routes.create.validation.pointsRequired": "Au moins 2 points de contrôle sont requis",
  "routes.deadEnd.description": "Aucun parcours ne correspond aux filtres {{filters}}.",
  "routes.deadEnd.descriptionWithSearch_one": "Aucun parcours ne correspond à « {{search}} » avec le filtre {{filters}}.",
  "routes.deadEnd.descriptionWithSearch_many": "Aucun parcours ne correspond à « {{search}} » avec les filtres {{filters}}.",
  "routes.deadEnd.descriptionWithSearch_other": "Aucun parcours ne correspond à « {{search}} » avec les filtres {{filters}}.",
  "routes.deadEnd.filterSeparator": " et ",
  "routes.deadEnd.previewHeading_one": "Sans le filtre {{filter}}, 1 parcours revient",
  "routes.deadEnd.previewHeading_many": "Sans le filtre {{filter}}, {{count}} parcours reviennent",
  "routes.deadEnd.previewHeading_other": "Sans le filtre {{filter}}, {{count}} parcours reviennent",
  "routes.deadEnd.removeFilter": "Retirer le filtre {{filter}}",
  "routes.deadEnd.reset": "Tout réinitialiser",
  "routes.deadEnd.searchTerm": "recherche",
  "routes.deadEnd.title": "Aucun parcours ne correspond",
  "routes.detail.climbs.avgGradient": "Pente moyenne",
  "routes.detail.climbs.distance": "De {{start}} {{unit}} à {{end}} {{unit}}",
  "routes.detail.climbs.gain": "Dénivelé",
  "routes.detail.climbs.maxGradient": "Pente maximale",
  "routes.detail.climbs.title": "Cols et montées",
  "routes.detail.climbs.unnamed": "Montée {{number}}",
  "routes.detail.deleteConfirm.message": "Voulez-vous vraiment supprimer ce parcours ? Cette action est irréversible.",
  "routes.detail.deleteConfirm.title": "Supprimer le parcours",
  "routes.detail.download.fit": "Télécharger FIT",
  "routes.detail.download.gpx": "Télécharger GPX",
  "routes.detail.elevationRefining": "Profil d'altitude provisoire",
  "routes.detail.info.createdAt": "Créé le",
  "routes.detail.info.surfaceType": "Type de revêtement",
  "routes.detail.info.title": "Informations du parcours",
  "routes.detail.notFound.backToRoutes": "Retour aux parcours",
  "routes.detail.notFound.message": "Le parcours que vous recherchez n'existe pas.",
  "routes.detail.notFound.title": "Parcours introuvable",
  "routes.detail.sendToDevice": "Envoyer vers l'appareil",
  "routes.detail.stats.distance": "Distance",
  "routes.detail.stats.elevationGain": "Dénivelé positif",
  "routes.detail.stats.elevationLoss": "Dénivelé négatif",
  "routes.edit.subtitle": "Modifier les informations du parcours",
  "routes.edit.title": "Modifier le parcours",
  "routes.list.empty.description": "Aucun parcours n'est disponible pour le moment.",
  "routes.list.empty.title": "Aucun parcours",
  "routes.list.filters.clear": "Effacer",
  "routes.list.filters.distance.label": "Distance",
  "routes.list.filters.distance.max": "Max",
  "routes.list.filters.distance.min": "Min",
  "routes.list.filters.distance.unit": "km",
  "routes.list.filters.distance.unit_imperial": "mi",
  "routes.list.filters.elevationGain.label": "Dénivelé positif",
  "routes.list.filters.elevationGain.max": "Max",
  "routes.list.filters.elevationGain.min": "Min",
  "routes.list.filters.elevationGain.unit": "m",
  "routes.list.filters.elevationGain.unit_imperial": "ft",
  "routes.list.filters.hide": "Masquer les filtres",
  "routes.list.filters.hilliness.FLAT": "Plat",
  "routes.list.filters.hilliness.HILLY": "Vallonné",
  "routes.list.filters.hilliness.label": "Relief",
  "routes.list.filters.hilliness.MOUNTAINOUS": "Montagneux",
  "routes.list.filters.hilliness.placeholder": "Tous les niveaux",
  "routes.list.filters.show": "Filtres",
  "routes.list.filters.sort.ASC": "Croissant",
  "routes.list.filters.sort.DATE_TIME": "Date",
  "routes.list.filters.sort.DESC": "Décroissant",
  "routes.list.filters.sort.DISTANCE": "Distance",
  "routes.list.filters.sort.ELEVATION_GAIN": "Dénivelé",
  "routes.list.filters.sort.HILLINESS": "Relief",
  "routes.list.filters.sort.label": "Trier par",
  "routes.list.filters.surfaceType.label": "Type de revêtement",
  "routes.list.filters.surfaceType.placeholder": "Tous les types",
  "routes.list.filters.tags.label": "Tags",
  "routes.list.filters.windDirection.EAST": "Est",
  "routes.list.filters.windDirection.label": "Direction du vent",
  "routes.list.filters.windDirection.NORTH": "Nord",
  "routes.list.filters.windDirection.NORTH_EAST": "Nord-Est",
  "routes.list.filters.windDirection.NORTH_WEST": "Nord-Ouest",
  "routes.list.filters.windDirection.placeholder": "Toutes directions",
  "routes.list.filters.windDirection.SOUTH": "Sud",
  "routes.list.filters.windDirection.SOUTH_EAST": "Sud-Est",
  "routes.list.filters.windDirection.SOUTH_WEST": "Sud-Ouest",
  "routes.list.filters.windDirection.WEST": "Ouest",
  "routes.list.noResults": "Aucun parcours ne correspond à votre recherche.",
  "routes.list.noResultsTitle": "Aucun parcours trouvé",
  "routes.list.search.label": "Rechercher des parcours",
  "routes.list.search.placeholder": "Rechercher par nom ou description...",
  "routes.list.title": "Parcours",
  "routes.notifications.created": "Parcours créé avec succès",
  "routes.notifications.deleted": "Parcours supprimé avec succès",
  "routes.notifications.restored": "Parcours restauré avec succès",
  "routes.notifications.updated": "Parcours mis à jour avec succès",
  "routes.picker.clearSelection": "Retirer le parcours",
  "routes.picker.noResults": "Aucun parcours trouvé",
  "routes.picker.search": "Rechercher par nom...",
  "routes.picker.title": "Sélectionner un parcours",
  "routes.preview.notFound": "Parcours non trouvé",
  "routes.surface.attribution": "© contributeurs OpenStreetMap",
  "routes.surface.class.DIRT": "Terre",
  "routes.surface.class.GRAVEL": "Compacté, gravier",
  "routes.surface.class.OFF_NETWORK": "Hors réseau",
  "routes.surface.class.PATH": "Sentier",
  "routes.surface.class.PAVED": "Asphalte",
  "routes.surface.class.PAVED_ROUGH": "Revêtement dégradé",
  "routes.surface.class.UNKNOWN": "Inconnu",
  "routes.surface.colorBy.grade": "Pente",
  "routes.surface.colorBy.label": "Colorer le profil et le tracé selon",
  "routes.surface.colorBy.lineLabel": "Colorer le tracé selon",
  "routes.surface.colorBy.stages": "Étapes",
  "routes.surface.colorBy.surface": "Revêtement",
  "routes.surface.colorBy.wind": "Météo",
  "routes.surface.pending": "Revêtement en cours de calcul",
  "routes.surface.share": "{{share}} %",
  "routes.surface.shareBelowOne": "< 1 %",
  "routes.surfaceType.GRAVEL": "Gravel",
  "routes.surfaceType.MIXED": "Mixte",
  "routes.surfaceType.MTB": "VTT",
  "routes.surfaceType.ROAD": "Route",
  "routes.surfaceTypeSuggestion.hint": "D'après le revêtement OpenStreetMap du tracé enregistré",
  "routes.surfaceTypeSuggestion.label": "Suggéré : {{type}}",
  "routes.thumbnail.alt": "Aperçu du parcours",
  "routes.upload.button": "Importer GPX",
  "routes.upload.progress": "{{current}}/{{total}}",
  "routes.usages.title": "Utilisée dans",
  "routes.usages.viaRide": "via les groupes : {{names}}",
  "routes.usages.viaTrip": "via les étapes : {{names}}",
  "routes.view.map": "Carte",
  "routes.waypoints.fromStart": "À {{distance}} du départ",
  "routes.waypoints.offTrack": "Hors tracé",
  "routes.waypoints.showLess": "Réduire",
  "routes.waypoints.showMore_one": "Voir le point suivant",
  "routes.waypoints.showMore_many": "Voir les {{count}} autres points",
  "routes.waypoints.showMore_other": "Voir les {{count}} autres points",
  "routes.waypoints.title": "Points du parcours",
  "routes.waypoints.tooltipNamed": "{{type}} : {{name}}",
  "routes.waypoints.type.BIKE_SHOP": "Magasin de vélo",
  "routes.waypoints.type.CAFE": "Café, pause",
  "routes.waypoints.type.DANGER": "Danger",
  "routes.waypoints.type.INFO": "Information",
  "routes.waypoints.type.REAL_START": "Départ réel",
  "routes.waypoints.type.REGROUP": "Regroupement",
  "routes.waypoints.type.SPLIT": "Séparation des groupes",
  "routes.waypoints.type.SUMMIT": "Col, sommet",
  "routes.waypoints.type.SUPPLY": "Ravitaillement",
  "routes.waypoints.type.TOILETS": "Toilettes",
  "routes.waypoints.type.VIEWPOINT": "Point de vue",
  "routes.waypoints.type.WATER": "Point d'eau",
  "seo.elevation": "D+",
  "seo.gpx.imageAlt": "Tracé GPX {{name}} — {{km}} km sur {{appName}}",
  "seo.gpx.sharedVia": "Tracé GPX partagé via {{appName}}",
  "seo.gpx.stats": "{{km}} km · {{gain}} m D+ · {{loss}} m D−",
  "seo.ride.imageAlt": "Carte de la sortie {{name}} — {{team}}",
  "seo.ride.participants_one": "{{count}} personne",
  "seo.ride.participants_many": "{{count}} personnes",
  "seo.ride.participants_other": "{{count}} personnes",
  "seo.ride.startPrefix": "Départ : ",
  "seo.rideGroup.departure": "Départ {{time}}",
  "seo.rideGroup.imageAlt": "Carte du groupe {{group}} de la sortie {{name}} — {{team}}",
  "seo.rideGroup.pace": "{{speed}} km/h",
  "seo.route.imageAlt": "Carte du parcours {{name}}",
  "seo.stage.description": "Étape du voyage {{trip}}",
  "seo.team.description": "Suivez les sorties, itinéraires et actualités de {{name}} sur {{appName}}.",
  "seo.teamAbout.imageAlt": "Logo de l'équipe {{name}}",
  "seo.teamAbout.title": "À propos de {{name}}",
  "seo.teamPage.description": "Découvrez « {{page}} » sur la page de l'équipe {{team}}.",
  "seo.trip.imageAlt": "Carte de l'itinéraire de {{name}}",
  "seo.trip.section": "Voyages",
  "seo.trip.stages_one": "{{count}} étape",
  "seo.trip.stages_many": "{{count}} étapes",
  "seo.trip.stages_other": "{{count}} étapes",
  "seo.trip.startPrefix": "départ ",
  "share.button": "Partager",
  "share.copied": "Lien copié",
  "share.copyFailed": "Impossible de copier le lien",
  "slug.edit": "Modifier l'URL",
  "slug.error.empty": "L'URL ne peut pas être vide",
  "slug.error.invalid": "Seules les lettres minuscules, chiffres et tirets sont autorisés",
  "slug.error.taken": "Cette URL est déjà utilisée",
  "slug.error.tooLong": "L'URL est trop longue (max 200 caractères)",
  "slug.hint": "L'ancienne URL redirigera vers la nouvelle.",
  "slug.label": "URL",
  "slug.success": "URL modifiée avec succès",
  "speed": "{{speed}} km/h",
  "speed_imperial": "{{speed}} mph",
  "spotsFull": "Complet",
  "spotsOf": "{{current}}/{{max}} places",
  "startPlace": "Départ",
  "status.CANCELLED": "Annulé",
  "status.checkingAuth": "Vérification de l'authentification...",
  "status.creating": "Création...",
  "status.DELETED": "Supprimé",
  "status.DRAFT": "Brouillon",
  "status.PUBLISHED": "Publié",
  "status.saving": "Enregistrement...",
  "tags.admin.add": "Nouveau tag",
  "tags.admin.delete": "Supprimer le tag « {{label}} »",
  "tags.admin.deleteConfirm.confirm": "Supprimer",
  "tags.admin.deleteConfirm.title": "Supprimer le tag ?",
  "tags.admin.deleteConfirm.unused": "Aucun contenu ne le porte. Cette suppression est définitive.",
  "tags.admin.deleteConfirm.used_one": "Il sera retiré du contenu qui le porte. Cette suppression est définitive.",
  "tags.admin.deleteConfirm.used_many": "Il sera retiré des {{count}} contenus qui le portent. Cette suppression est définitive.",
  "tags.admin.deleteConfirm.used_other": "Il sera retiré des {{count}} contenus qui le portent. Cette suppression est définitive.",
  "tags.admin.description": "Chaque type de contenu a ses propres tags. Qui peut modifier un contenu choisit ses tags parmi ceux-ci ; seul le rôle Administrateur de l'équipe les crée, renomme ou supprime.",
  "tags.admin.edit": "Modifier le tag « {{label}} »",
  "tags.admin.empty.AD": "Créez des tags pour classer les annonces et les filtrer dans leur liste.",
  "tags.admin.empty.POST": "Créez des tags pour classer les publications et les filtrer dans leur liste.",
  "tags.admin.empty.RIDE": "Créez des tags pour classer les sorties et les filtrer dans leur liste.",
  "tags.admin.empty.ROUTE": "Créez des tags pour classer les parcours et les filtrer dans leur liste.",
  "tags.admin.empty.title": "Aucun tag",
  "tags.admin.empty.TRIP": "Créez des tags pour classer les voyages et les filtrer dans leur liste.",
  "tags.admin.form.color": "Couleur",
  "tags.admin.form.create": "Créer",
  "tags.admin.form.createTitle": "Nouveau tag",
  "tags.admin.form.editTitle": "Modifier le tag",
  "tags.admin.form.label": "Libellé",
  "tags.admin.form.labelHint": "{{max}} caractères au plus, unique pour ce type (sans tenir compte de la casse)",
  "tags.admin.form.labelPlaceholder": "Ex. : Gravel, Sortie longue…",
  "tags.admin.form.preview": "Aperçu :",
  "tags.admin.kind.AD": "Annonces",
  "tags.admin.kind.POST": "Publications",
  "tags.admin.kind.RIDE": "Sorties",
  "tags.admin.kind.ROUTE": "Parcours",
  "tags.admin.kind.TRIP": "Voyages",
  "tags.admin.limit": "{{used}} / {{max}} tags pour ce type",
  "tags.admin.noKind.description": "Les tags s'appliquent aux sorties, publications, voyages, parcours et annonces : activez l'une de ces sections dans les paramètres de l'équipe.",
  "tags.admin.noKind.title": "Aucune section active",
  "tags.admin.notifications.created": "Tag créé",
  "tags.admin.notifications.deleted_one": "Tag supprimé et retiré de {{count}} contenu",
  "tags.admin.notifications.deleted_many": "Tag supprimé et retiré de {{count}} contenus",
  "tags.admin.notifications.deleted_other": "Tag supprimé et retiré de {{count}} contenus",
  "tags.admin.notifications.updated": "Tag modifié",
  "tags.admin.title": "Tags",
  "tags.admin.usage_zero": "Inutilisé",
  "tags.admin.usage_one": "{{count}} contenu",
  "tags.admin.usage_many": "{{count}} contenus",
  "tags.admin.usage_other": "{{count}} contenus",
  "tags.color.BLUE": "Bleu",
  "tags.color.GRAPE": "Violet",
  "tags.color.GRAY": "Gris",
  "tags.color.GREEN": "Vert",
  "tags.color.INDIGO": "Indigo",
  "tags.color.ORANGE": "Orange",
  "tags.color.RED": "Rouge",
  "tags.color.TEAL": "Turquoise",
  "tags.color.YELLOW": "Jaune",
  "tags.filter.label": "Filtrer par tag",
  "tags.filter.nothingFound": "Aucun tag",
  "tags.filter.placeholder": "Tags",
  "tags.listLabel": "Tags",
  "tags.more_one": "{{count}} autre tag",
  "tags.more_many": "{{count}} autres tags",
  "tags.more_other": "{{count}} autres tags",
  "tags.moreShort": "+{{hidden}}",
  "tags.picker.empty": "L'équipe n'a pas encore de tag pour ce type de contenu. Seul le rôle Administrateur peut en créer.",
  "tags.picker.emptyAdmin": "L'équipe n'a pas encore de tag pour ce type de contenu.",
  "tags.picker.hint": "Parmi les tags de l'équipe, {{max}} au plus",
  "tags.picker.label": "Tags",
  "tags.picker.manageLink": "Gérer les tags",
  "tags.picker.placeholder": "Choisir des tags",
  "teams.actions.edit": "Modifier l'équipe",
  "teams.admin.tabs.members": "Gestion des membres",
  "teams.admin.tabs.pages": "Pages",
  "teams.admin.tabs.places": "Lieux",
  "teams.admin.tabs.reports": "Signalements",
  "teams.admin.tabs.rideTemplates": "Modèles de sortie",
  "teams.admin.tabs.settings": "Paramètres",
  "teams.admin.tabs.tags": "Tags",
  "teams.admin.title": "Gestion de l'équipe",
  "teams.buttons.delete": "Supprimer l'équipe",
  "teams.contextBanner.goToTeam": "Voir la page de l'équipe {{name}}",
  "teams.create.button": "Créer l'équipe",
  "teams.create.form.description.placeholder": "Décrivez votre équipe, votre style de cyclisme ou votre communauté...",
  "teams.create.form.enableAds.hint": "Permet aux membres de publier des annonces (vente, location, recherche)",
  "teams.create.form.enableAds.label": "Activer les annonces",
  "teams.create.form.enableMemberDirectory.hint": "Sans cette option, seul le rôle Administrateur voit la liste des membres. Le rôle Organisateur y a accès dans tous les cas, mais sans les rôles ni les dates d'adhésion.",
  "teams.create.form.enableMemberDirectory.label": "Ouvrir le trombinoscope aux membres",
  "teams.create.form.enablePosts.hint": "Le rôle Organisateur peut publier des articles et actualités",
  "teams.create.form.enablePosts.label": "Activer les posts",
  "teams.create.form.enableRides.hint": "Le rôle Organisateur peut créer et gérer des sorties",
  "teams.create.form.enableRides.label": "Activer les sorties",
  "teams.create.form.enableRoutes.hint": "Le rôle Organisateur peut créer des parcours. Désactiver masque aussi les sorties et voyages",
  "teams.create.form.enableRoutes.label": "Activer les parcours",
  "teams.create.form.enableTrips.hint": "Le rôle Organisateur peut créer et gérer des voyages sur plusieurs jours",
  "teams.create.form.enableTrips.label": "Activer les voyages",
  "teams.create.form.name.label": "Nom de l'équipe",
  "teams.create.form.name.placeholder": "Entrez le nom de l'équipe",
  "teams.create.form.postsAsTeamByDefault.hint": "Une nouvelle publication est signée par l'équipe plutôt que par la personne qui l'écrit, qui peut changer ce choix pour chaque publication.",
  "teams.create.form.postsAsTeamByDefault.label": "Publications au nom de l'équipe par défaut",
  "teams.create.form.timezone.hint": "Les sorties, voyages et publications sans lieu de départ suivent ce fuseau.",
  "teams.create.form.timezone.label": "Fuseau horaire",
  "teams.create.form.visibility.hint": "Contrôle qui peut trouver et rejoindre cette équipe",
  "teams.create.form.visibility.label": "Visibilité de l'équipe",
  "teams.create.subtitle": "Lancez votre communauté cycliste et invitez d'autres personnes",
  "teams.create.title": "Créer une équipe",
  "teams.dashboard.admin.admins_one": "{{count}} administrateur",
  "teams.dashboard.admin.admins_many": "{{count}} administrateurs",
  "teams.dashboard.admin.admins_other": "{{count}} administrateurs",
  "teams.dashboard.admin.feature.ads": "Annonces",
  "teams.dashboard.admin.feature.directory": "Annuaire des membres",
  "teams.dashboard.admin.feature.posts": "Publications",
  "teams.dashboard.admin.feature.rides": "Sorties",
  "teams.dashboard.admin.feature.routes": "Parcours",
  "teams.dashboard.admin.feature.trips": "Voyages",
  "teams.dashboard.admin.features": "Fonctionnalités",
  "teams.dashboard.admin.invite": "Inviter",
  "teams.dashboard.admin.manageMembers": "Gérer les membres",
  "teams.dashboard.admin.members_one": "{{count}} membre",
  "teams.dashboard.admin.members_many": "{{count}} membres",
  "teams.dashboard.admin.members_other": "{{count}} membres",
  "teams.dashboard.admin.newestMembers": "Nouveaux membres",
  "teams.dashboard.admin.organizers_one": "{{count}} organisateur",
  "teams.dashboard.admin.organizers_many": "{{count}} organisateurs",
  "teams.dashboard.admin.organizers_other": "{{count}} organisateurs",
  "teams.dashboard.admin.roleSplit": "Répartition des membres par rôle",
  "teams.dashboard.admin.title": "Administration",
  "teams.dashboard.admin.webhook": "Webhook {{kind}}",
  "teams.dashboard.admin.webhookActive": "Actif",
  "teams.dashboard.admin.webhookDisabled": "Désactivé",
  "teams.dashboard.admin.webhookLastAttempt": "dernier envoi le",
  "teams.dashboard.admin.webhookNone": "Aucun webhook configuré",
  "teams.dashboard.ads.empty": "Aucune annonce pour le moment.",
  "teams.dashboard.ads.sector": "Secteur {{place}}",
  "teams.dashboard.ads.title": "Annonces",
  "teams.dashboard.groupPace": "{{group}} · {{pace}}",
  "teams.dashboard.myUpcoming.empty": "Aucune inscription à une sortie à venir de l'équipe.",
  "teams.dashboard.myUpcoming.title": "Vos prochaines sorties",
  "teams.dashboard.myUpcoming.viewTrip": "Voir le voyage",
  "teams.dashboard.posts.empty": "Aucune publication pour le moment.",
  "teams.dashboard.posts.title": "Dernières publications",
  "teams.dashboard.ride.edit": "Modifier",
  "teams.dashboard.ride.fill": "{{current}} / {{max}}",
  "teams.dashboard.ride.noRoute": "Aucun parcours associé",
  "teams.dashboard.ride.register": "S'inscrire",
  "teams.dashboard.ride.registeredCount_one": "{{count}} inscription",
  "teams.dashboard.ride.registeredCount_many": "{{count}} inscriptions",
  "teams.dashboard.ride.registeredCount_other": "{{count}} inscriptions",
  "teams.dashboard.routes.empty": "Aucun parcours pour le moment.",
  "teams.dashboard.routes.title": "Nouveaux parcours",
  "teams.dashboard.seeAll": "Voir tout",
  "teams.dashboard.templates.empty": "Aucun modèle de sortie.",
  "teams.dashboard.templates.title": "Créer depuis un modèle",
  "teams.dashboard.title": "Tableau de bord",
  "teams.dashboard.todo.addRoute": "Ajouter un parcours",
  "teams.dashboard.todo.drafts_one": "Brouillon",
  "teams.dashboard.todo.drafts_many": "Brouillons",
  "teams.dashboard.todo.drafts_other": "Brouillons",
  "teams.dashboard.todo.fullGroup_one": "Sortie avec un groupe complet",
  "teams.dashboard.todo.fullGroup_many": "Sorties avec un groupe complet",
  "teams.dashboard.todo.fullGroup_other": "Sorties avec un groupe complet",
  "teams.dashboard.todo.fullGroupDetail_one": "{{group}} de « {{ride}} » : {{count}} inscription sur {{max}}",
  "teams.dashboard.todo.fullGroupDetail_many": "{{group}} de « {{ride}} » : {{count}} inscriptions sur {{max}}",
  "teams.dashboard.todo.fullGroupDetail_other": "{{group}} de « {{ride}} » : {{count}} inscriptions sur {{max}}",
  "teams.dashboard.todo.reportDetail": "{{target}} : {{reason}}",
  "teams.dashboard.todo.reportExcerpt": "— « {{excerpt}} »",
  "teams.dashboard.todo.reports_one": "Signalement",
  "teams.dashboard.todo.reports_many": "Signalements",
  "teams.dashboard.todo.reports_other": "Signalements",
  "teams.dashboard.todo.resume": "Reprendre",
  "teams.dashboard.todo.review": "Examiner",
  "teams.dashboard.todo.seeGroups": "Voir les groupes",
  "teams.dashboard.todo.title": "À traiter",
  "teams.dashboard.todo.withoutRoute_one": "Sortie sans parcours",
  "teams.dashboard.todo.withoutRoute_many": "Sorties sans parcours",
  "teams.dashboard.todo.withoutRoute_other": "Sorties sans parcours",
  "teams.dashboard.upcomingRides.empty": "Aucune sortie n'est programmée pour le moment.",
  "teams.dashboard.upcomingRides.title": "Sorties à venir",
  "teams.detail.about.created": "Création",
  "teams.detail.about.members": "Membres",
  "teams.detail.about.noDescription": "Aucune description disponible.",
  "teams.detail.about.routes": "Parcours",
  "teams.detail.about.title": "À propos de l'équipe",
  "teams.detail.about.upcomingRides": "Sorties à venir",
  "teams.detail.actions.admin": "Gérer",
  "teams.detail.actions.confirmLeave": "Voulez-vous vraiment quitter cette équipe ?",
  "teams.detail.actions.join": "Rejoindre l'équipe",
  "teams.detail.actions.joining": "Adhésion...",
  "teams.detail.actions.leave": "Quitter l'équipe",
  "teams.detail.members.addError": "Échec de l'ajout du membre. Veuillez réessayer.",
  "teams.detail.members.addMember": "Ajouter un membre",
  "teams.detail.members.confirmRemove": "Voulez-vous vraiment retirer ce membre ?",
  "teams.detail.members.empty": "Aucun membre trouvé.",
  "teams.detail.members.filterRole": "Rôle",
  "teams.detail.members.filterRoleAll": "Tous les rôles",
  "teams.detail.members.joined": "A rejoint le {{date}}",
  "teams.detail.members.noResults": "Aucun membre trouvé",
  "teams.detail.members.remove": "Retirer",
  "teams.detail.members.role": "Rôle",
  "teams.detail.members.roleOf": "Rôle de {{name}}",
  "teams.detail.members.search.label": "Rechercher",
  "teams.detail.members.search.placeholder": "Rechercher par nom ou e-mail...",
  "teams.detail.members.searchPlaceholder": "Rechercher par nom...",
  "teams.detail.members.searchUser": "Rechercher une personne",
  "teams.detail.members.title": "Membres",
  "teams.detail.members.you": "(vous)",
  "teams.detail.notFound.backToTeams": "Retour aux équipes",
  "teams.detail.tabs.about": "À propos",
  "teams.detail.tabs.agenda": "Agenda",
  "teams.detail.tabs.posts": "Publications",
  "teams.detail.tabs.routes": "Parcours",
  "teams.directory.forbidden.message": "Cette équipe ne partage pas la liste de ses membres avec vous.",
  "teams.directory.forbidden.title": "Liste des membres non partagée",
  "teams.invitations.consentNotice": "Nous n'inscrivons personne d'office : l'invitation doit être acceptée. Le message est le même que la personne ait déjà un compte ou non.",
  "teams.invitations.email": "Adresse e-mail",
  "teams.invitations.emailHelp": "La personne recevra un e-mail et rejoindra l'équipe seulement si elle accepte.",
  "teams.invitations.emailPlaceholder": "prenom.nom@exemple.fr",
  "teams.invitations.error.generic": "L'invitation n'a pas pu être envoyée.",
  "teams.invitations.expiresAt": "Expire le",
  "teams.invitations.invite": "Inviter par e-mail",
  "teams.invitations.pendingHelp": "Une adresse mal orthographiée produit une invitation qui ne sera jamais acceptée : c'est ici qu'elle se voit, et le bouton d'annulation est là pour ça.",
  "teams.invitations.pendingTitle": "Invitations en attente",
  "teams.invitations.resend": "Renvoyer",
  "teams.invitations.revoke": "Annuler l'invitation",
  "teams.invitations.revokeConfirm": "Annuler l'invitation envoyée à {{email}} ?",
  "teams.invitations.revoked": "Invitation annulée.",
  "teams.invitations.send": "Envoyer l'invitation",
  "teams.invitations.sent": "Invitation envoyée à {{email}}.",
  "teams.invitations.sentBy": "Invitation de",
  "teams.list.empty.noTeamsDescription": "Aucune équipe n'a encore été créée sur ce site.",
  "teams.list.empty.noTeamsTitle": "Aucune équipe",
  "teams.list.empty.publicTeams": "Aucune équipe ne correspond à votre recherche.",
  "teams.list.empty.title": "Aucune équipe trouvée",
  "teams.list.filter.all": "Toutes",
  "teams.list.filter.label": "Filtre",
  "teams.list.search.label": "Rechercher des équipes",
  "teams.list.search.placeholder": "Rechercher des équipes...",
  "teams.list.subtitle": "Parcourez les équipes cyclistes ou créez la vôtre",
  "teams.notifications.created": "Équipe créée avec succès",
  "teams.notifications.deleted": "Équipe supprimée avec succès",
  "teams.notifications.governanceUpdateFailed": "Paramètres enregistrés, mais les attributs de gouvernance n'ont pas pu être mis à jour",
  "teams.notifications.memberAdded": "Membre ajouté à l'équipe",
  "teams.notifications.memberRemoved": "Membre retiré de l'équipe",
  "teams.notifications.placeCreated": "Lieu créé avec succès",
  "teams.notifications.placeDeleted": "Lieu supprimé avec succès",
  "teams.notifications.placeUpdated": "Lieu mis à jour avec succès",
  "teams.notifications.updated": "Équipe mise à jour avec succès",
  "teams.pages.add": "Ajouter une page",
  "teams.pages.confirmations.delete": "Voulez-vous vraiment supprimer la page \"{{name}}\" ? Cette action est irréversible.",
  "teams.pages.confirmations.deleteTitle": "Supprimer la page",
  "teams.pages.create.title": "Créer une page",
  "teams.pages.edit.title": "Modifier {{name}}",
  "teams.pages.empty.description": "Créez des pages personnalisées pour la FAQ, les règles ou toute information sur l'équipe.",
  "teams.pages.empty.title": "Aucune page",
  "teams.pages.form.content.label": "Contenu",
  "teams.pages.form.content.placeholder": "Rédigez le contenu de votre page ici...",
  "teams.pages.form.create": "Créer la page",
  "teams.pages.form.title.hint": "Ceci apparaîtra comme un onglet dans la navigation de l'équipe",
  "teams.pages.form.title.label": "Titre de la page",
  "teams.pages.form.title.placeholder": "ex: FAQ, Règlement, Équipement",
  "teams.pages.form.visibility.hint": "Les pages publiques sont visibles par tout le monde, les pages d'équipe uniquement par les membres",
  "teams.pages.noContent": "Cette page n'a pas encore de contenu.",
  "teams.pages.notifications.created": "Page créée avec succès",
  "teams.pages.notifications.deleted": "Page supprimée avec succès",
  "teams.pages.notifications.reordered": "Pages réordonnées avec succès",
  "teams.pages.notifications.restored": "Page restaurée avec succès",
  "teams.pages.notifications.updated": "Page mise à jour avec succès",
  "teams.pages.subtitle_one": "{{count}} page sur {{max}} maximum",
  "teams.pages.subtitle_many": "{{count}} pages sur {{max}} maximum",
  "teams.pages.subtitle_other": "{{count}} pages sur {{max}} maximum",
  "teams.pages.title": "Pages de l'équipe",
  "teams.posts.empty": "Aucune publication pour le moment",
  "teams.posts.emptyDescription": "Les publications de l'équipe apparaîtront ici une fois publiées",
  "teams.posts.search.noResultsDescription": "Aucune publication ne correspond à votre recherche. Essayez d'autres mots-clés ou effacez la recherche.",
  "teams.posts.search.placeholder": "Rechercher par titre ou description...",
  "teams.publications.list.filter.all": "Tous",
  "teams.publications.list.filter.label": "Type",
  "teams.publications.list.filter.post": "Publications",
  "teams.publications.list.filter.ride": "Sorties",
  "teams.publications.list.filter.trip": "Voyages",
  "teams.settings.dangerZone.confirmDelete": "Oui, supprimer l'équipe",
  "teams.settings.dangerZone.deleteTeam": "Supprimer l'équipe",
  "teams.settings.dangerZone.deleteWarning": "Voulez-vous vraiment supprimer <strong>{{teamName}}</strong> ? Cette action est irréversible et supprimera toutes les données de l'équipe, y compris les sorties et les parcours.",
  "teams.settings.dangerZone.description": "Une fois que vous supprimez une équipe, il n'y a pas de retour en arrière. Soyez certain.",
  "teams.settings.dangerZone.title": "Zone de danger",
  "teams.settings.error.loadFailed": "Échec du chargement des paramètres. Veuillez réessayer.",
  "teams.settings.platformAdmin.addMemberAllowed": "Autoriser les admins à ajouter des membres",
  "teams.settings.platformAdmin.enableRoutePlanner": "Autoriser le tracé de parcours sur la carte",
  "teams.settings.platformAdmin.enableRoutePlannerHint": "Sans cette option, les parcours ne peuvent être créés ou mis à jour qu'en important un fichier GPX.",
  "teams.settings.platformAdmin.joinable": "Permettre à tout le monde de rejoindre librement",
  "teams.settings.platformAdmin.title": "Paramètres plateforme",
  "teams.settings.platformAdmin.visibilityEditable": "Autoriser les admins à modifier la visibilité",
  "teams.settings.subtitle": "Gérer le profil et les paramètres de votre équipe",
  "teams.settings.timezoneChange.confirm": "Changer le fuseau",
  "teams.settings.timezoneChange.datePattern": "EEEE d MMMM",
  "teams.settings.timezoneChange.error": "Impossible de calculer les conséquences de ce changement. Veuillez réessayer.",
  "teams.settings.timezoneChange.example.POST": "la publication « {{title}} » du {{date}} restera à {{time}}, désormais heure {{ofCity}}.",
  "teams.settings.timezoneChange.example.RIDE": "la sortie « {{title}} » du {{date}} restera à {{time}}, désormais heure {{ofCity}}.",
  "teams.settings.timezoneChange.example.TRIP": "le voyage « {{title}} » du {{date}} restera à {{time}}, désormais heure {{ofCity}}.",
  "teams.settings.timezoneChange.example.TRIP_STAGE": "l'étape « {{title}} » du voyage « {{trip}} », le {{date}}, restera à {{time}}, désormais heure {{ofCity}}.",
  "teams.settings.timezoneChange.located": "Les sorties, voyages et étapes situés par un lieu de départ ou un parcours ne changent pas.",
  "teams.settings.timezoneChange.none": "Aucun rendez-vous à venir sans lieu de départ : aucune heure ne change.",
  "teams.settings.timezoneChange.past_one": "{{count}} rendez-vous passé sans lieu de départ garde son heure réelle, désormais affichée heure {{ofCity}}.",
  "teams.settings.timezoneChange.past_many": "{{count}} rendez-vous passés sans lieu de départ gardent leur heure réelle, désormais affichée heure {{ofCity}}.",
  "teams.settings.timezoneChange.past_other": "{{count}} rendez-vous passés sans lieu de départ gardent leur heure réelle, désormais affichée heure {{ofCity}}.",
  "teams.settings.timezoneChange.question": "Passer l'équipe de l'heure {{ofFrom}} à l'heure {{ofTo}} ?",
  "teams.settings.timezoneChange.title": "Changer le fuseau horaire",
  "teams.settings.timezoneChange.upcoming_one": "{{count}} rendez-vous à venir sans lieu de départ : {{example}}",
  "teams.settings.timezoneChange.upcoming_many": "{{count}} rendez-vous à venir sans lieu de départ, par exemple {{example}}",
  "teams.settings.timezoneChange.upcoming_other": "{{count}} rendez-vous à venir sans lieu de départ, par exemple {{example}}",
  "teams.settings.title": "Paramètres de l'équipe",
  "teams.settings.webhook.current": "Adresse actuelle :",
  "teams.settings.webhook.description": "Publiez automatiquement les annonces de l'équipe (sorties, voyages et articles publiés, annulations, changements de date ou de point de départ) dans Slack, Discord, Mattermost ou sur n'importe quelle adresse https. Le format est déduit de l'URL.",
  "teams.settings.webhook.enabledHint": "Désactivé, le webhook est conservé mais plus rien n'est envoyé.",
  "teams.settings.webhook.enabledLabel": "Envoyer les annonces",
  "teams.settings.webhook.kind.DISCORD": "Discord",
  "teams.settings.webhook.kind.GENERIC": "JSON",
  "teams.settings.webhook.kind.MATTERMOST": "Mattermost",
  "teams.settings.webhook.kind.SLACK": "Slack",
  "teams.settings.webhook.languageHint": "Langue des messages envoyés.",
  "teams.settings.webhook.languageLabel": "Langue",
  "teams.settings.webhook.lastAttempt": "Dernier envoi :",
  "teams.settings.webhook.remove": "Supprimer le webhook",
  "teams.settings.webhook.removed": "Webhook supprimé",
  "teams.settings.webhook.removeTitle": "Supprimer le webhook",
  "teams.settings.webhook.removeWarning": "Les annonces de l'équipe ne seront plus publiées à cette adresse. Pour la rétablir, il faudra saisir l'URL de nouveau.",
  "teams.settings.webhook.saved": "Webhook enregistré",
  "teams.settings.webhook.status.FAILED": "Échec",
  "teams.settings.webhook.status.PENDING": "En attente",
  "teams.settings.webhook.status.SENDING": "En cours",
  "teams.settings.webhook.status.SENT": "Réussi",
  "teams.settings.webhook.status.SKIPPED": "Ignoré",
  "teams.settings.webhook.test": "Envoyer un message de test",
  "teams.settings.webhook.testFailed": "Le message de test n'a pas abouti : {{error}}",
  "teams.settings.webhook.testFailedStatus": "Le message de test a été refusé (HTTP {{status}}). {{error}}",
  "teams.settings.webhook.testSuccess": "Message de test reçu (HTTP {{status}}).",
  "teams.settings.webhook.title": "Webhook",
  "teams.settings.webhook.urlHint": "L'URL fournie par Slack, Discord, Mattermost ou votre service. Elle reste secrète : elle ne sera plus jamais affichée en entier.",
  "teams.settings.webhook.urlKeepHint": "Laissez vide pour garder l'adresse actuelle, ou collez une nouvelle URL pour la remplacer.",
  "teams.settings.webhook.urlLabel": "URL du webhook",
  "teams.switcher.allTeams": "Toutes les équipes",
  "teams.switcher.open": "Changer d'équipe",
  "teams.switcher.title": "Mes équipes",
  "teams.title": "Équipes",
  "temperature": "{{temperature}} °C",
  "temperature_imperial": "{{temperature}} °F",
  "timezone.readerEquivalent": "{{time}} chez vous",
  "timezone.rendezvousMention": "{{zone}} ({{equivalent}})",
  "timezone.zoneMention": "heure {{ofCity}}",
  "trips.card.stageCount_one": "{{count}} étape",
  "trips.card.stageCount_many": "{{count}} étapes",
  "trips.card.stageCount_other": "{{count}} étapes",
  "trips.create.button": "Créer le voyage",
  "trips.create.form.description.placeholder": "Décrivez le voyage, les points forts, la logistique...",
  "trips.create.form.publishAt.label": "Publication programmée",
  "trips.create.form.route.clear": "Supprimer",
  "trips.create.form.route.hint": "Optionnel : associer un parcours global pour tout le voyage",
  "trips.create.form.route.label": "Parcours global",
  "trips.create.form.route.select": "Sélectionner un parcours",
  "trips.create.form.route.selectForStage": "Sélectionner le parcours de l'étape",
  "trips.create.form.route.selectForTrip": "Sélectionner le parcours du voyage",
  "trips.create.form.stages.date.label": "Date/Heure",
  "trips.create.form.stages.defaultName": "Étape {{number}}",
  "trips.create.form.stages.description.placeholder": "Décrivez cette étape...",
  "trips.create.form.stages.endPlace.label": "Lieu d'arrivée",
  "trips.create.form.stages.endPlace.placeholder": "Rechercher un lieu d'arrivée...",
  "trips.create.form.stages.name.label": "Nom de l'étape",
  "trips.create.form.stages.name.placeholder": "Nom de l'étape (ex: Jour 1: Col de montagne)",
  "trips.create.form.stages.remove": "Supprimer",
  "trips.create.form.stages.route.label": "Parcours de l'étape",
  "trips.create.form.stages.speed.label": "Vitesse moyenne",
  "trips.create.form.stages.speed.placeholder": "Facultative ({{unit}})",
  "trips.create.form.stages.startPlace.label": "Lieu de départ",
  "trips.create.form.stages.startPlace.placeholder": "Rechercher un lieu de départ...",
  "trips.create.form.title.label": "Titre du voyage",
  "trips.create.form.title.placeholder": "ex: Aventure cycliste dans les Alpes",
  "trips.create.subtitle": "Planifiez un voyage de plusieurs jours pour {{teamName}}",
  "trips.create.title": "Créer un voyage",
  "trips.detail.actions.cancel": "Annuler le voyage",
  "trips.detail.actions.join": "Rejoindre le voyage",
  "trips.detail.actions.leave": "Quitter le voyage",
  "trips.detail.actions.uncancel": "Restaurer le voyage",
  "trips.detail.confirmations.cancel": "Voulez-vous vraiment annuler ce voyage ?",
  "trips.detail.confirmations.delete": "Voulez-vous vraiment supprimer ce voyage ? Cette action est irréversible.",
  "trips.detail.confirmations.uncancel": "Voulez-vous vraiment restaurer ce voyage ? Il reviendra au statut brouillon.",
  "trips.detail.confirmations.unpublish": "Voulez-vous vraiment dépublier ce voyage ? Il reviendra au statut brouillon.",
  "trips.detail.endDate": "Fin le {{date}}",
  "trips.detail.nonMember.message": "Rejoignez cette équipe pour participer aux voyages.",
  "trips.detail.nonMember.viewTeam": "Voir l'équipe",
  "trips.detail.notAuthenticated.message": "Connectez-vous et rejoignez cette équipe pour participer aux voyages.",
  "trips.detail.notAuthenticated.signIn": "Se connecter",
  "trips.detail.notFound.backToTrips": "Retour aux voyages",
  "trips.detail.notFound.message": "Le voyage que vous recherchez n'existe pas.",
  "trips.detail.notFound.title": "Voyage introuvable",
  "trips.detail.participants.title": "Personnes inscrites",
  "trips.detail.participants.viewAll": "Voir toutes les personnes inscrites",
  "trips.detail.scheduledPublish": "Publication programmée pour le {{date}}",
  "trips.detail.stages.empty": "Aucune étape définie pour ce voyage.",
  "trips.detail.stages.title": "Étapes",
  "trips.edit.subtitle": "Mettre à jour les détails du voyage pour {{teamName}}",
  "trips.edit.title": "Modifier le voyage",
  "trips.notifications.cancelled": "Voyage annulé avec succès",
  "trips.notifications.created": "Voyage créé avec succès",
  "trips.notifications.deleted": "Voyage supprimé avec succès",
  "trips.notifications.joined": "Inscription au voyage confirmée",
  "trips.notifications.left": "Désinscription du voyage confirmée",
  "trips.notifications.published": "Voyage publié avec succès",
  "trips.notifications.restored": "Voyage restauré avec succès",
  "trips.notifications.uncancelled": "Voyage restauré avec succès",
  "trips.notifications.unpublished": "Voyage dépublié avec succès",
  "trips.notifications.updated": "Voyage mis à jour avec succès",
  "trips.stage.notFound.backToTrip": "Retour au voyage",
  "trips.stage.notFound.message": "L'étape que vous recherchez n'existe pas.",
  "trips.stage.notFound.title": "Étape introuvable",
  "trips.stage.viewRoute": "Voir le parcours",
  "trips.stage.viewRouteDetails": "Voir les détails du parcours",
  "trips.tabs.addStage": "Ajouter une étape",
  "trips.tabs.details": "Détails",
  "trips.tabs.overview": "Aperçu",
  "trips.weather.map.speedDefault": "Heures de passage estimées à {{speed}} pour les étapes sans vitesse indiquée",
  "trips.weather.noLocation": "Ajoutez un parcours à cette étape pour afficher sa météo.",
  "trips.weather.noRoute": "Cette étape n'a pas de parcours : pas de prévision le long de la route.",
  "trips.weather.notYetAvailableNoDate": "La météo sera disponible sept jours avant le départ de l'étape.",
  "trips.weather.speedDefault": "Heures de passage estimées à {{speed}}, vitesse par défaut (l'étape n'en indique pas)",
  "unknown": "Inconnu",
  "visibility.label": "Visibilité",
  "visibility.public": "Public",
  "visibility.public_unlisted": "Non répertorié",
  "visibility.team": "Équipe uniquement",
  "welcome": "Bienvenue sur {{appName}}"
}
